import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { usererrors } from 'src/app/errors/usererrors';
import { CustomerSite } from 'src/app/Models/CustomerSite';
import { CustomerSiteAddress } from 'src/app/Models/CustomersiteAddress';
import { CustomerSiteContact } from 'src/app/Models/Customersitecontact';
'src/app/Models/Customersitecontact';
import { CustomerSiteSpecialDelivery } from 'src/app/Models/CustomerSiteSpecialDelivery';
import { CustomerSiteTAT } from 'src/app/Models/CustomerSiteTAT';
import { CustomerSiteOperation } from 'src/app/Models/ServiceLocationAndOperation';
import { CustomerinformationService } from 'src/app/Services/customerinformation.service';
import { ServiceLocationAndOperationService } from 'src/app/Services/service-location-and-operation.service';
import { vContract, vcusEmailID, vCustomersite, vServiceLocations, vSUK } from 'src/app/Validators/validation';
import { CommonUtilities } from 'src/assets/js/common-utilities';
import { ExportUtility } from 'src/assets/js/export-utility';
import * as XLSX from 'xlsx';
import { FileUpload } from 'primeng/fileupload';
import { ExistingvendorService } from 'src/app/Services/existingvendor.service';
import { CustomerSiteVendor } from 'src/app/Models/CustomerSiteVendor';
import { CustomerSiteTradeReference } from 'src/app/Models/CustomerSiteTradeReference';
import { TradereferenceService } from 'src/app/Services/tradereference.service';
import { KeyPress } from 'src/assets/js/KeyPress';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { CustomerSUKService } from 'src/app/Services/customer-suk.service';
import { CustomerSiteSKUList } from 'src/app/Models/CustomerSiteSKUList';
import { APIService } from 'src/app/Services/api.service';
import { MapsAPILoader } from '@agm/core';
import { parse } from 'querystring';
import { CustomerSiteContractAddOnCharge } from 'src/app/Models/CustomerSiteContractAddOnCharge';
import { CustomerSiteContract } from 'src/app/Models/CustomerSiteContract';
import { CustomerSiteCostAndContractService } from 'src/app/Services/customer-site-cost-and-contract.service';
import { CustomerSiteContractRegion } from 'src/app/Models/CustomerSiteContractRegion';
import { CustomerSiteContractArticle } from 'src/app/Models/CustomerSiteContractArticle';
import { CustomerSiteContractSlab } from 'src/app/Models/CustomerSiteContractSlab';
import { CustomerSiteContractTwoD } from 'src/app/Models/CustomerSiteContractTwoD';
import { ApprovalService } from 'src/app/Services/approval.service';
import { PrequoteApprovalService } from 'src/app/Services/prequote-approval.service';
import { Approval } from 'src/app/Models/Approval';


@Component({
  selector: 'app-reportapproval',
  templateUrl: './reportapproval.component.html',
  styleUrls: ['./reportapproval.component.css']
})
export class ReportapprovalComponent implements OnInit {
//Customer Informations

_CustomerSiteform: FormGroup;
_CustomerAddressPickupform: FormGroup;
_CustomerAddressBillingform: FormGroup;
_CustomerContactPickform: FormGroup;
// _CustomerContactInvoiceform: FormGroup;
// _CustomerContactOutgoingform: FormGroup;
_CustomerSite: CustomerSite;
_Tempform: FormGroup
_TempformforTab: FormGroup
CustomersListGrid: any[];
selectedtab: number = 0;
selectedtab1: number = 0;
Contactselectedtab: number = 0
displayBasic: boolean;
_CompanyType: any[]
_CreditType: any[]
_AccquiredAgent: any[]
_ProductType: any[]
_BillingTo: any[]
_AddressType: any[]
_ContactAddressType: any[]
_FloorType: any[]
_Country: any[]
_State: any[]
_District: any[]
_Validation: any[]
_GSTStatus: any[]
ContactList: any
Addresslist: any
_GSTStatus_: any[]
_Basedon: any[]
Temp_Basedon: any[]
_CustomerList: any[]
_PincodeLocation: any[]
pincodelocation: any[]
pincodelocation1: any[]
_PincodeLocation1: any[]
disablePinLocation: boolean = true
disablePinLocation1: boolean = true
_LastAddedDocumentinCustomer: File
CusomerFile: File[] = [];
imageselect: string = ""
_SelectedCreditType: any[] = []
CreditTypeCode: any
CustomerCode: string
CreditTypeName: string
ExistCustomerCI: any[]

CustomersiteCode: string
_CustomerSiteCode
_CustomerDetail: any
_CustomerDetailTemp: any
creditCode: any
_CreditTypeCode: any
_CreditTypeCode_: string[] = [];
addressid: number
addressid1: number
contactid: number
contactid1: number
contactid2: number
_submitted: boolean = false;
// imageselect:any;
GstValidationStatusCode: string
validationStatusCode: string





ExistCustomer: any[]
selectedtabquote: number = 0
// selectedtab: number = 0;
// selectedtab1: number = 0;
// selectedtab2: number = 0;
// Contactselectedtab: number = 0;
// ContactList:any[];
transporter: string
ManageCustomersList: any[]
_BillingCycle: any[]
id: any
_CustomerType: any[]
_QuoteStatus: any[]
_Status: any[]
hideStatus: boolean = true
// CustomersListGrid:any[];
// displayBasic: boolean;

// _FloorType:any[]
_Transporter: any[]

_TempServiceLocationsCode: any
_TempServiceLocations: any
_TempSLPincodeLocation: any[]
TempSLpincodelocation: any[]

// CustomersListGrid:any[];
SpecialDeliveryList: any[] = [];
TATDetails: any[] = [];
// selectedtab: number = 0;
// displayBasic: boolean;
_ServiceLocation: any[]
_Tier: any[]
_Requirments: any[]
_SpecialDelivery: any[]
// _FloorType:any[];
// _State:any[]
// _District:any[]
_TatBased: any[]
_Location: any[]


agentListGrid: any[]
VolumeList: any[]

_Uom: any[]
_Hub: any[]
// _Basedon:any[]
willDownload



GeneralRateList: any[]
// _State: any[]
_OdaList: any
_FlatOdaList: any
// id: any
idflat: any
HideOpenTYpe: boolean = true
HideFlatTYpe: boolean = true
HideArticleODA: boolean = true
HideTonnageODA: boolean = true
HideServiceable: boolean = true
HideTranscationTYpe: boolean = true

_ServiceOpt: CustomerSiteOperation;



contacttypeid: any[] = []
// HideGeneralRate: boolean = true
// HideArticleBased: boolean = true
// HideRegionLevel: boolean = true
// HideSlab: boolean = true
// Hide2DRate: boolean = true



//Trade Referance
outsideCompanyList: CustomerSiteTradeReference[] = [];
WithinCompanyList: CustomerSiteTradeReference[] = [];

TempWithinCompanyList: CustomerSiteTradeReference[] = []
TempoutsideCompanyList: CustomerSiteTradeReference[] = []

EditTempWithinCompanyList: CustomerSiteTradeReference[] = []
EditTempoutsideCompanyList: CustomerSiteTradeReference[] = []

CompanyList: any[] = []
TempCompanyList: any[] = []
// displayBasic: boolean;
// _Status:any[]

// SpecialDeliveryList: any[]
// selectedtab: number = 0;
// displayBasic: boolean;
OtherChargesList: any[]
DoorCollectionList: any[]
_WaybillType: any[]
// _GSTStatus:any[]


// _CustomerList: any[]
// _PincodeLocation: any[]
// pincodelocation: any[]
// pincodelocation1: any[]
// _PincodeLocation1: any[]
// disablePinLocation: boolean = true
// disablePinLocation1: boolean = true
// _LastAddedDocument: File;
// imageselect:any
typeid: any
_ContractType: any

// _ContactAddressType:any[]
// _Validation:any[]
_Basedon1: any[]
_TempformAD: FormGroup
_ServiceLocationAndOperation_Form: FormGroup
_ServiceLocationAndOperation_SpecialDelivery_Form: FormGroup
_ServiceLocationAndOperation_TATDetails_Form: FormGroup
_TATListTemp: any[]
selectedFiles: FileList;
currentFile: File;
arrayBuffer: any
VolumeReferList: any[]
//SpecialDeliveryList:any[]
TATselectedFiles: FileList;
TATcurrentFile: File;
addressRowIndex: number = -1;


//Existing vendor
CustomerVendorlist: any

ExistingVendorList: CustomerSiteVendor[] = []
TempExistingVendorList: CustomerSiteVendor[] = []
ExistingVendorListTemp: CustomerSiteVendor[] = []
_ExistingVendordetails: CustomerSiteVendor[]

hidecustomer: boolean = true


//////////////////---------SL and SKU ---------/////////////////////

_TempTierCode: any
_TempTierName: any

SUKList: any[] = [];
SUKVolumeDistrubutionList: any[] = [];
ExistCustomerSL: any[]
ExistCustomerSUK: any[]
_Basedon_: any[]
_BasedonSKU: any
_SUK_Form: FormGroup
_SUK_VolumeDistrubution_Form: FormGroup
_selectedDocuments: File[] = [];
selectedFilesInSKU: FileList;
documentimage: SafeUrl;
currentFileInSKU: File;
_SLsubmitted: boolean = false
_SLSpecialDeliverysubmitted: boolean = false
_SLTATsubmitted: boolean = false
_SUKsubmitted: boolean = false
_SUKVolumeDistrubutionsubmitted: boolean = false
HideUnReg: boolean = true
HideAadhar: boolean = true
_selectedServiceLocation: string[] = [];
_selectedtier: string[] = [];
_SLFloorType: any[]
_CustomerSKUList: CustomerSiteSKUList;
_ODALocations: any[]
_CustomerLR: any[]
_Invoice: any[]
_ReturnBooking: any[]


latitude: number = 0;
longitude: number = 0;
searchControl: FormControl;
zoom: number = 1;
QuantityPer: any = 0
tempQuantity: any
volumeQuantity: any = 0
tempQuantitypercentage: any

/////////////////////---------------Cost and Contract --------------////////////////////////////
//---------------- Region Level -------------------//
_BillingBranch: any[];
_InclusiveExclusive: any[];
_ToBranch: any[];
_ArticleName: any[];
_RateType: any[];
_DCRateType: any[];
_DDRateType: any[];
_ArticleChargeCode: any[];
_AddonCharges: any[];
displayACRateType: boolean;
displayDCRate: boolean;
displayDCRateKG: boolean;
displayDDRate: boolean;
displayDDRateKG: boolean;
displayACRate: boolean;
displayACRateKG: boolean;
_RegionLevelForm: FormGroup
_CostingContract: FormGroup
_FromDCPiece: string;
_ToDCPiece: string;
_RateDCPiece: string;
_FromDCKG: string;
_ToDCKG: string;
_RateDCKG: string;
_FromDDPiece: string;
_ToDDPiece: string;
_RateDDPiece: string;
_FromDDKG: string;
_ToDDKG: string;
_RateDDKG: string;
_FromACPiece: string;
_ToACPiece: string;
_RateACPiece: string;
_FromACKG: string;
_ToACKG: string;
_RateACKG: string;
_DCPiece: any[] = [];
_DCKG: any[] = [];
_DDPiece: any[] = [];
_DDKG: any[] = [];
_ACPiece: any[] = [];
_ACKG: any[] = [];
_RegionList: any[] = [];
_updateRowRegion: boolean = true;
_addRowRegion: boolean = false;
_RegionIndex: any = null;
_RegionLevelFormsubmitted: boolean = false

//---------------- Article Based -------------------//

displayACRateTypeAB: boolean;
displayDCRateAB: boolean;
displayDCRateKGAB: boolean;
displayDDRateAB: boolean;
displayDDRateKGAB: boolean;
displayACRateAB: boolean;
displayACRateKGAB: boolean;
_ArticleBasedForm: FormGroup
_FromDCPieceAB: string;
_ToDCPieceAB: string;
_RateDCPieceAB: string;
_FromDCKGAB: string;
_ToDCKGAB: string;
_RateDCKGAB: string;
_FromDDPieceAB: string;
_ToDDPieceAB: string;
_RateDDPieceAB: string;
_FromDDKGAB: string;
_ToDDKGAB: string;
_RateDDKGAB: string;
_FromACPieceAB: string;
_ToACPieceAB: string;
_RateACPieceAB: string;
_FromACKGAB: string;
_ToACKGAB: string;
_RateACKGAB: string;
_DCPieceAB: any[] = [];
_DCKGAB: any[] = [];
_DDPieceAB: any[] = [];
_DDKGAB: any[] = [];
_ACPieceAB: any[] = [];
_ACKGAB: any[] = [];
_ArticleBasedList: any[] = [];
_updateRowArticleBased: boolean = true;
_addRowArticleBased: boolean = false;
_ArticleBasedIndex: any = null;
_ArticleBasedFormsubmitted: boolean = false


//---------------- Slab -------------------//
displaySlab: boolean;
displayKGSlab: boolean;
displayACRateTypeSlab: boolean;
displayDCRateSlab: boolean;
displayDCRateKGSlab: boolean;
displayDDRateSlab: boolean;
displayDDRateKGSlab: boolean;
displayACRateSlab: boolean;
displayACRateKGSlab: boolean;
_SlabForm: FormGroup
_FromPieceSlab: string;
_ToPieceSlab: string;
_RatePieceSlab: string;
_FromKGSlab: string;
_ToKGSlab: string;
_RateKGSlab: string;
_FromDCPieceSlab: string;
_ToDCPieceSlab: string;
_RateDCPieceSlab: string;
_FromDCKGSlab: string;
_ToDCKGSlab: string;
_RateDCKGSlab: string;
_FromDDPieceSlab: string;
_ToDDPieceSlab: string;
_RateDDPieceSlab: string;
_FromDDKGSlab: string;
_ToDDKGSlab: string;
_RateDDKGSlab: string;
_FromACPieceSlab: string;
_ToACPieceSlab: string;
_RateACPieceSlab: string;
_FromACKGSlab: string;
_ToACKGSlab: string;
_RateACKGSlab: string;
_PieceSlab: any[] = [];
_KGSlab: any[] = [];
_DCPieceSlab: any[] = [];
_DCKGSlab: any[] = [];
_DDPieceSlab: any[] = [];
_DDKGSlab: any[] = [];
_ACPieceSlab: any[] = [];
_ACKGSlab: any[] = [];
_SlabFormList: any[] = [];
_updateRowSlab: boolean = true;
_addRowSlab: boolean = false;
_SlabIndex: any = null;
_SlabFormsubmitted: boolean = false



//---------------- 2D -------------------//
display2D: boolean;
displayKG2D: boolean;
displayACRateType2D: boolean;
displayDCRate2D: boolean;
displayDCRateKG2D: boolean;
displayDDRate2D: boolean;
displayDDRateKG2D: boolean;
displayACRate2D: boolean;
displayACRateKG2D: boolean;
_2DForm: FormGroup
_FromPiece2D: string;
_ToPiece2D: string;
_RatePiece2D: string;
_FromKG2D: string;
_ToKG2D: string;
_RateKG2D: string;
_FromDCPiece2D: string;
_ToDCPiece2D: string;
_RateDCPiece2D: string;
_FromDCKG2D: string;
_ToDCKG2D: string;
_RateDCKG2D: string;
_FromDDPiece2D: string;
_ToDDPiece2D: string;
_RateDDPiece2D: string;
_FromDDKG2D: string;
_ToDDKG2D: string;
_RateDDKG2D: string;
_FromACPiece2D: string;
_ToACPiece2D: string;
_RateACPiece2D: string;
_FromACKG2D: string;
_ToACKG2D: string;
_RateACKG2D: string;
_Piece2D: any[] = [];
_KG2D: any[] = [];
_DCPiece2D: any[] = [];
_DCKG2D: any[] = [];
_DDPiece2D: any[] = [];
_DDKG2D: any[] = [];
_ACPiece2D: any[] = [];
_ACKG2D: any[] = [];
_2DList: any[] = [];
_updateRow2D: boolean = true;
_addRow2D: boolean = false;
_2DIndex: any = null;
_2DFormsubmitted: boolean = false

///////--------------Way Bill-------------//////////////

displayRateTypeWayBill: boolean;
displayPieceWayBill: boolean;
displayKGWayBill: boolean;
displayPieceKGWayBill: boolean;
_WaybillForm: FormGroup
_FromPieceWayBill: string;
_ToPieceWayBill: string;
_RatePieceWayBill: string;
_FromKGWayBill: string;
_ToKGWayBill: string;
_RateKGWayBill: string;
_FromPieceKGWayBill: string;
_ToPieceKGWayBill: string;
_RatePieceKGWayBill: string;
WayBillList: CustomerSiteContractAddOnCharge[] = [];
_WayBillListGrid: CustomerSiteContractAddOnCharge[] = [];
_PieceWayBill: any[] = [];
_KGWayBill: any[] = [];
_PieceKGWayBill: any[] = [];
_AddOnChargeType: any[];
_updateRowWayBill: boolean = true;
_addRowWayBill: boolean = false;
_WayBillIndex: any = null;
_WaybillFormsubmitted: boolean = false



_StateMinimumODACharges: string;
_FlatMinimumODACharges: string;
_ArticleFrom: string;
_ArticleTo: string;
_ArticleCharges: string;
_KGFrom: string;
_KGTo: string;
_KGCharges: string;
_KGList: any[] = [];
_ArticleList: any[] = [];
_selectedDocumentsContract: File[] = [];
currentFileContract: File;



CustomerSiteContractList: CustomerSiteContract;
_CustomerSiteContractGeneralForm: FormGroup;
_contracttypescode: string;
_contracttypes_: string;
_ServiceableMinimumODACharges: string;
_TranscationODACharges: string;
_TranscationMinimumODACharges: string;
_StateCode: string;
ExistCustomerContract: any[];
_ContractTypes: string[] = [];
_StateNG: string[] = [];
_TempWaybillList: any[];
_CostingContractsubmitted: boolean = false
_CustomerSiteContractGeneralFormsubmitted: boolean = false
_ODAChargesAgree: any[]
_ODACalculationMode: any[]
selectedtabContract: number = 5;

HideGeneralRate: boolean = false
HideArticleBased: boolean = false
HideRegionLevel: boolean = false
HideSlab: boolean = false
Hide2DRate: boolean = false
_approvalid:string;
_workflowid:string;
_Comments:string;
_approval:Approval;
_buttonHide:boolean = false;
_ApprovalId:string = 'MSC00148';
_ReferBackId:string = 'MSC00486';
_RejectId:string = 'MSC00149';

DisableMail: boolean = false
_Designation: any
_Quote: any
@ViewChild("search")
public searchElementRef: ElementRef
constructor(private fb: FormBuilder, private router: Router, 
  private _ServiceLocationAndOperationService: ServiceLocationAndOperationService,
  public exportUtility: ExportUtility,
  private utility: CommonUtilities, 
  private _CustomerInformationService: CustomerinformationService, 
  private _CustomExceptionService: CustomExceptionService,
  private _ExistingvendorService: ExistingvendorService, private _TradereferenceService: TradereferenceService, public keypress: KeyPress,
  private _CustomerSUKService: CustomerSUKService, private _APIdService: APIService,
  private _DomSanitizationService: DomSanitizer, private mapsAPILoader: MapsAPILoader,
  private ngZone: NgZone,
  private _CustomerSiteCostAndContractService: CustomerSiteCostAndContractService,
  private route: ActivatedRoute,
  private _ApprovalService: ApprovalService,
  private _PrequoteApprovalService:PrequoteApprovalService) { }


  ngOnInit(): void { 
    //this.utility.pageLoadScript();
    this.route.queryParams
      .subscribe(params => {
        console.log(params); // { orderby: "price" }
        this._CustomerSiteCode = params.customersitecode;
        this.CustomersiteCode = params.customersitecode;
        this._approvalid = params.approvalid;
        this._workflowid = params.workflowid;
      });   
    //Customer Informations

    var x = document.getElementById("Header");
    x.style.display = "none";
    //create search FormControl
    this.searchControl = new FormControl();
    //set current position
    this.setCurrentPosition();


    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //types: ["address"]
        //types: ['(cities)']
      });
      autocomplete.addListener("place_changed", () => {  //place_changed ///place_changed
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
          this._CustomerSiteform.controls['latitude'].setValue(this.latitude);
          this._CustomerSiteform.controls['longitude'].setValue(this.longitude);
          // alert("latitude : " + this.latitude + "    longitude : " + this.longitude);
        });
      });
    });
    this._BasedonSKU = [
      { id: '1', name: '6' },
      { id: '2', name: '8' },
      { id: '3', name: '10' }

    ]
    //////////////////---------CUSTOMER FORMS--------------/////////////////////
    this._CustomerSiteform = this.fb.group({
      customercode: [],
      customersitecode: [],
      customersitename: ['', vCustomersite],
      credittypecode: ['', vCustomersite],
      credittypes: [],
      acquiredbycode: ['', vCustomersite],
      acquiredby: [],
      billingtocode: ['', vCustomersite],
      billingto: [],
      productname: ['', vCustomersite],
      producttypecode: ['', vCustomersite],
      producttype: [],
      gstin: ['', vCustomersite],
      gstStatuscode: ['', vCustomersite],
      gstStatus: [],
      validationbasedoncode: ['', vCustomersite],
      validationbasedon: [],
      idNumber: ['', vCustomersite],
      //client_id:[],
      // AadharOTPVerification:[],
      onBehalfOf: [],
      gstValidationstatuscode: [],
      gstValidationstatus: [],
      googlelocation: [],
      latitude: [],
      longitude: [],
      pickuplocationphotoURL: [],
      // pickuplocationphotoFORMFILE: [],
      pickuplocationintime: ['', vCustomersite],
      pickuplocationouttime: ['', vCustomersite],
      pickuplocationobservations: ['', vCustomersite],
      recordstatus: [],
      createdby: [],
      modifiedby: [],
      createdon: [],
      modifiedon: [],
      accountingyear: [],
      lstCustomerSiteAddress: [],
      lstCustomerSiteContact: [],
      customername: [],
      companytypecode: [],
      companytype: [],
      tallyid: [],
      pan: [],
      billingcyclecode: [],
      billingcycle: [],
      istransportercode: [],
      istransporter: [],
      prequotestatuscode: [],
      prequotestatus: [],
      recordstatuscode: [],
      comments: [],
      signedcontractdocumentURL: [],
      cutoffdateforsignedcontract: [],
      prequotesignoffcomments: [],
      prequotesignedoffby: [],
      prequotesignedon: [],
      isspecialdelivery:[]

      // isTemp: [],
      // customersitename:[]
      // totalspendtime: []
    });
    this._CustomerAddressPickupform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerAddressBillingform = this.fb.group({
      addressid: [],
      customersitecode: [],
      addresstype: [],
      address: ['', vCustomersite],
      taluk: [],
      pincode: ['', vCustomersite],
      pincodelocation: ['', vCustomersite],
      floortype: ['', vCustomersite],
      addresstypecode: [],
      recordstatuscode: [],
      floortypecode: [],
      recordstatus: []
    });
    this._CustomerContactPickform = this.fb.group({
      contactid: [],
      customersitecode: [],
      contacttype: [],
      contactperson: ['', vCustomersite],
      designation: ['', vCustomersite],
      department: ['', vCustomersite],
      phoneno: ['', vCustomersite],
      mobileno: ['', vCustomersite],
      emailid: ['', vcusEmailID],
      faxno: ['', vCustomersite],
      contacttypecode: [],
      recordstatuscode: [],
      recordstatus: []
    });
    // this._CustomerContactInvoiceform = this.fb.group({
    //   contactid: [],
    //   customersitecode: [],
    //   contacttype: [],
    //   contactperson: ['', vCustomersite],
    //   designation: ['', vCustomersite],
    //   department: ['', vCustomersite],
    //   phoneno: ['', vCustomersite],
    //   mobileno: ['', vCustomersite],
    //   emailid: ['', vcusEmailID],
    //   faxno: ['', vCustomersite],
    //   contacttypecode: [],
    //   recordstatuscode: [],
    //   recordstatus: []
    // });
    // this._CustomerContactOutgoingform = this.fb.group({
    //   contactid: [],
    //   customersitecode: [],
    //   contacttype: [],
    //   contactperson: ['', vCustomersite],
    //   designation: ['', vCustomersite],
    //   department: ['', vCustomersite],
    //   phoneno: ['', vCustomersite],
    //   mobileno: ['', vCustomersite],
    //   emailid: ['', vcusEmailID],
    //   faxno: ['', vCustomersite],
    //   contacttypecode: [],
    //   recordstatuscode: [],
    //   recordstatus: []
    // });
    this._Tempform = this.fb.group({

      companytype: [],
      billingcycle: [],
      customername: [],
      sameaddress: [],
      totalspendtime: []
    })
    this._TempformforTab = this.fb.group({
      TabName: [],
    })
    this._TempformAD = this.fb.group({
      client_id: [],
      AadharOTPVerification: []
    })

    /////////////////costing & contract/////////////////////////////

    this._CostingContract = this.fb.group({
      billingbranchcode: ['', vContract],
      billingbranch: ['', vContract],
      communicationmaildocumentURL: [],
      communicationmaildocumentDOC: [],
      odachargetype: [],
      odachargetypecode: ['', vContract],
      pertransactionfixedodacharges: [],
      opentypeodastates: [],
      flatodabasedon: [],
      fuelpriceperltr: [],
      quotedrateperqtlperkm: ['', vContract],
      minimumfreight: ['', vContract],
      minimumchargeableweight: ['', vContract],
      minimumvsc: ['', vContract],
      expectedsales: ['', vContract],
      creditlimit: ['', vContract],
      invoicecreditdays: ['', vContract],
      minimumdc: ['', vContract],
      costtocompanydc: ['', vContract],
      costtoagentdc: ['', vContract],
      minimumdd: ['', vContract],
      costtocompanydd: ['', vContract],
      costtoagentdd: ['', vContract],
      minimumac: ['', vContract],
      costtocompanyac: ['', vContract],
      costtoagentac: ['', vContract],
      contracttypescode: [],
      odainclusiveorexclusivecode: [],
      opentypeodastatescode: [],
      flatodabasedoncode: [],
      odachargesagreed: [],
      odachargesagreedcode: [],
      costtocompanyoda: [],
      costtoagentoda: [],
      odainclusiveorexclusive: [],
      minimumoda: [],
      contracttypes: ['', vContract],
      //lstFlatODACharges:[],
      //lstGeneralContract:[],
      //lstRegionContract:[],
      //lstArticleContract:[],
      //lstSlabContract:[],
      //lstTwoDContract:[],
      //lstAddOnCharge:[],
      //lstAddOnSlabs:[],
      //lstDCDDACSlabs:[],
      //lstAddOnSlabs:[],
      //lstAddOnCharge:[],
      //lstAddOnCharge:[],
    })

    this._CustomerSiteContractGeneralForm = this.fb.group({
      rateperqtlperkm: ['', vContract],
      odacalculationmodecode: ['', vContract],
    })

    this._RegionLevelForm = this.fb.group({
      frombranchcode: ['', vContract],
      toregioncode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._ArticleBasedForm = this.fb.group({
      frombranchcode: ['', vContract],
      tobranchcode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._SlabForm = this.fb.group({
      frombranchcode: ['', vContract],
      tobranchcode: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: [],
    })

    this._2DForm = this.fb.group({
      frombranchcode: ['', vContract],
      toKM: ['', vContract],
      articlecode: ['', vContract],
      ratetypecode: ['', vContract],
      rate: [],
      dcratetypecode: ['', vContract],
      dcrate: [],
      ddratetypecode: ['', vContract],
      ddrate: [],
      acratetypecode: ['', vContract],
      acrate: [],
      inclusiveorexclusivecode: ['', vContract],
      isneedreversebooking: ['', vContract],
    })

    this._WaybillForm = this.fb.group({
      chargecodeid: ['', vContract],
      chargetypecode: ['', vContract],
      chargeratetypecode: ['', vContract],
      adrate: [],
      inclusiveorexclusivecode: ['', vContract],
      printinothercharge: [],
    })


   
    // lstCustomer



    /*this._Tempform = this.fb.group({
      TabName: [],
    })*/
    ////////////////////-------------SERVICE LOCATIONS FORM-----------------/////////////////////
    this._TempformforTab.get("TabName").setValue(0);
    this._ServiceLocationAndOperation_Form = this.fb.group({
      servicelocationscode: ['', vServiceLocations],
      tiercode: ['', vServiceLocations],
      podrequirementcode: ['', vServiceLocations],
      bookingcutofftime: ['', vServiceLocations],
      vehicledeparturecutofftime: ['', vServiceLocations],
      pickupcutofftime: ['', vServiceLocations],
      odalocation: ['', vServiceLocations],
      customerlrcopy: ['', vServiceLocations],
      invoiceacknowledgement: ['', vServiceLocations],
      returnbooking: ['', vServiceLocations],
    })
    this._ServiceLocationAndOperation_SpecialDelivery_Form = this.fb.group({
      SpecialDeliverytypecode: ['', vServiceLocations],
      ContactPerson: ['', vServiceLocations],
      MobileNo: ['', vServiceLocations],
      EmailID: ['', vcusEmailID],
      Address: ['', vServiceLocations],
      PinCode: ['', vServiceLocations],
      PincodeLocation: ['', vServiceLocations],
      Floor: ['', vServiceLocations],
    })
    this._ServiceLocationAndOperation_TATDetails_Form = this.fb.group({
      Basedoncode: ['', vServiceLocations],
      Fromlocationcode: ['', vServiceLocations],
      Tolocationcode: ['', vServiceLocations],
      Tatindays: ['', vServiceLocations],
      //TabName3:[],
    })
    ////////////////------------------SKU FORMS ---------------////////////////////
    this._SUK_Form = this.fb.group({
      SkuType: ['', vSUK],
      SkuUom: ['', vSUK],
      SkuLength: ['', vSUK],
      SkuBreadth: ['', vSUK],
      SkuHeight: ['', vSUK],
      CftBasedOn: ['', vSUK],
      CftWeight: ['', vSUK],
      ContributionPercentage: ['', vSUK],
      SkuPhotoURL: [],
      //SkuPhotoFORMFILE:[],  
    })
    this._SUK_VolumeDistrubution_Form = this.fb.group({
      Hub: ['', vSUK],
      VolumeDistributionPercentage: ['', vSUK],
    })
    this.ApprovalPageLoad();
  }

  ApprovalPageLoad()
  {
    this._PrequoteApprovalService.GetPageInitializeDetails().subscribe((result) => {

      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log(resultJSON);
      ////////---Customer---/////////
      this._CreditType = resultJSON.lstCreditType
      this._FloorType = resultJSON.lstFloorType
      this._AccquiredAgent = resultJSON.lstAcquiredBy
      this._ProductType = resultJSON.lstProductType
      this._GSTStatus = resultJSON.lstGSTstatus
      this._Basedon = resultJSON.lstValidationBasedOn
      this.Temp_Basedon = resultJSON.lstValidationBasedOn
      this._BillingTo = resultJSON.lstBillingTo
      this._CustomerList = resultJSON.lstCustomer
      this._PincodeLocation = resultJSON.lstPincodeLocation
      this._PincodeLocation1 = resultJSON.lstPincodeLocation
      ////////---Service Location and operation---/////////
      this._ServiceLocation = resultJSON.lstServiceLocation;
      this._Tier = resultJSON.lstTier;
      this._Requirments = resultJSON.lstPODRequirement;
      this._SpecialDelivery = resultJSON.lstSpecialDeliveryType;
      this._SLFloorType = resultJSON.lstFloorType;
      this._TempSLPincodeLocation = resultJSON.lstPincodeLocation;
      this._TatBased = resultJSON.lstTATBasedOn;
      this._Location = resultJSON.lstTATLocation;
      this._ODALocations = resultJSON.lstYesNo;
      ////////---SKU---/////////
      this._Uom = resultJSON.lstSKUUom;
      this._Hub = resultJSON.lstHub;
      ////////---Contract---/////////
      this._BillingBranch = resultJSON.lstBranch;
      this._FlatOdaList = resultJSON.lstFlatODABasedOn;
      this._ContractType = resultJSON.lstContractType;
      this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
      this._State = resultJSON.lstRegion;
      this._ODAChargesAgree = resultJSON.lstYesNo;
      this._ODACalculationMode = resultJSON.lstODACalculationMode;
      this._ToBranch = resultJSON.lstBranch;
      this._ArticleName = resultJSON.lstArticle;
      this._RateType = resultJSON.lstRateType;
      this._DCRateType = resultJSON.lstDCRateType;
      this._DDRateType = resultJSON.lstDDRateType;
      this._ArticleChargeCode = resultJSON.lstACRateType;
      this._AddonCharges = resultJSON.lstAddOnChargeType;
      this._AddOnChargeType = resultJSON.lstAddOnChargeType;
      this._Quote =resultJSON.lstQuoteStatus

      this._Designation = resultJSON.lstDesignation
      // this._Quote = [
      //   { metasubcode: '1', metasubdescription: 'initiate' },
      //   { metasubcode: '2', metasubdescription: 'Conformed' },
      // ]
      ////////---Existing Vendor---/////////
      ////////---Trade Reference---/////////

      this.ApprovalPageGetbyId();
      // lstCustomer
    }, error => { this._CustomExceptionService.handleError(error); }
    );
  }

  ApprovalPageGetbyId() {
    if(this.CustomersiteCode != null || this.CustomersiteCode != undefined || this.CustomersiteCode != "")
    {
      this._PrequoteApprovalService.GetById(this.CustomersiteCode).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log("update", resultJSON);
        if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
          this._CustomerDetail = resultJSON.customerSiteDetail
          this._CustomerDetailTemp = resultJSON.customerSiteDetail
          this.CustomerCode = resultJSON.customercode
              
              
            ///////----------- customersitecode---------------//////////////////
            if(resultJSON.customerSiteDetail != null)
            {
              this._Tempform.controls['companytype'].setValue(resultJSON.customerSiteDetail.companytype);
              this._Tempform.controls['billingcycle'].setValue(resultJSON.customerSiteDetail.billingcycle);
              resultJSON.customerSiteDetail.pickuplocationintime = new Date(resultJSON.customerSiteDetail.pickuplocationintime);
              resultJSON.customerSiteDetail.pickuplocationouttime = new Date(resultJSON.customerSiteDetail.pickuplocationouttime);
              this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)
              this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
              var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
              this._Tempform.get("totalspendtime").setValue(spendtime)
              console.log("bh", spendtime);
              this.imageselect = resultJSON.customerSiteDetail.pickuplocationphotoURL
              this.CustomersiteCode = resultJSON.customerSiteDetail.customersitecode
              this._CustomerAddressPickupform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0])
              this._CustomerAddressBillingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1])
              this._CustomerContactPickform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[0])
              // this._CustomerContactInvoiceform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[1])
              // this._CustomerContactOutgoingform.setValue(resultJSON.customerSiteDetail.lstCustomerSiteContact[2])
              this.addressid = this._CustomerDetail.lstCustomerSiteAddress[0].addressid
              this.addressid1 = this._CustomerDetail.lstCustomerSiteAddress[1].addressid
              this.contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid
              this.contactid1 = this._CustomerDetail.lstCustomerSiteContact[1].contactid
              this.contactid2 = this._CustomerDetail.lstCustomerSiteContact[2].contactid
              this._CustomerAddressPickupform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].floortypecode);
              this._CustomerAddressBillingform.get("floortype").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].floortypecode);
              var PinCode = this._CustomerAddressPickupform.get("pincode").value;
              this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);
              this._CustomerAddressPickupform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation);
              var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
              this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
              this._CustomerAddressBillingform.get("pincodelocation").setValue(resultJSON.customerSiteDetail.lstCustomerSiteAddress[1].pincodelocation);
              console.log("loc", resultJSON.customerSiteDetail.lstCustomerSiteAddress[0].pincodelocation)
              this.creditCode = resultJSON.customerSiteDetail.credittypecode
              this._CustomerSiteform.setValue(resultJSON.customerSiteDetail);
              if (resultJSON.customerSiteDetail.credittypecode != null) {
                var _CrediTypeCode = resultJSON.customerSiteDetail.credittypecode.split(',');            
                var CreditTypeCode: string[] = [];
                Object.keys(_CrediTypeCode).map((Index) => {
                  CreditTypeCode.push(_CrediTypeCode[Index]);
                });
                this._CreditTypeCode_ = CreditTypeCode;
              }
              this.validationStatusCode = resultJSON.customerSiteDetail.gstValidationstatuscode
            }
            ////////////////////////////////////-------------Service Location and operation-------------------------/////////
            if(resultJSON.customerSiteOperationDetail != null){
              var splitServiceLocation = resultJSON.customerSiteOperationDetail.servicelocations.split(',');              
              const servicelocations = [];
              for (i = 0; i < splitServiceLocation.length; i++) {
                servicelocations.push(splitServiceLocation[i]);
              }
              var servicelocationsCode: string[] = [];
              Object.keys(servicelocations).map((Index) => {
                servicelocationsCode.push(servicelocations[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._selectedServiceLocation = servicelocationsCode;
              var splittier = resultJSON.customerSiteOperationDetail.tiercode.split(',');
              const tier = [];
              for (i = 0; i < splittier.length; i++) {
                tier.push(splittier[i]);
              }
              var tierCode: string[] = [];
              Object.keys(tier).map((Index) => {
                tierCode.push(tier[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._selectedtier = tierCode;
              this._TempServiceLocationsCode = resultJSON.customerSiteOperationDetail.servicelocations;
              this._TempTierCode = resultJSON.customerSiteOperationDetail.tiercode;

          

              //this._ServiceLocationAndOperation_Form.get("tiercode").setValue(this._Tier.find(f => f.metasubcode === resultJSON.customerSiteOperationDetail.tiercode));
              this._ServiceLocationAndOperation_Form.get("podrequirementcode").setValue(resultJSON.customerSiteOperationDetail.podrequirementcode);
              this._ServiceLocationAndOperation_Form.controls['bookingcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.bookingcutofftime));
              this._ServiceLocationAndOperation_Form.controls['vehicledeparturecutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.vehicledeparturecutofftime));
              this._ServiceLocationAndOperation_Form.controls['pickupcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.pickupcutofftime));
              this._ServiceLocationAndOperation_Form.controls['odalocation'].setValue(resultJSON.customerSiteOperationDetail.odalocationcode);
              this._ServiceLocationAndOperation_Form.controls['customerlrcopy'].setValue(resultJSON.customerSiteOperationDetail.customerlrcopycode);
              this._ServiceLocationAndOperation_Form.controls['invoiceacknowledgement'].setValue(resultJSON.customerSiteOperationDetail.invoiceacknowledgementcode);
              this._ServiceLocationAndOperation_Form.controls['returnbooking'].setValue(resultJSON.customerSiteOperationDetail.returnbookingcode);
              this.SpecialDeliveryList = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery.length; i++) {
                this.SpecialDeliveryList[i].SpecialDeliverytypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytypecode
                this.SpecialDeliveryList[i].SpecialDeliverytype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytype
                this.SpecialDeliveryList[i].contactPerson = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].contactPerson
                this.SpecialDeliveryList[i].MobileNo = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].mobileNo
                this.SpecialDeliveryList[i].EmailID = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].emailID
                this.SpecialDeliveryList[i].Address = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].address
                this.SpecialDeliveryList[i].pincode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincode
                this.SpecialDeliveryList[i].PincodeLocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincodeLocation
                this.SpecialDeliveryList[i].Floortypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortypecode
                this.SpecialDeliveryList[i].Floortype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortype
              }
              this.TATDetails = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT.length; i++) {
                this.TATDetails[i].Basedoncode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedoncode
                this.TATDetails[i].Basedon = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedon
                this.TATDetails[i].Fromlocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocationcode
                this.TATDetails[i].Fromlocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocation
                this.TATDetails[i].Tolocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocationcode
                this.TATDetails[i].Tolocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocation
                //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
                this.TATDetails[i].Tatindays = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tatindays
              }
            }
            ////////////////////////////////////-------------------SKU-------------------------/////////
            if(resultJSON.lstCustomerSiteSKU != null)
            {
              this.SUKList = resultJSON.lstCustomerSiteSKU;
              for (var i = 0; i < resultJSON.lstCustomerSiteSKU.length; i++) {
                this.SUKList[i].SkuType = resultJSON.lstCustomerSiteSKU[i].skuType
                this.SUKList[i].SkuUom = resultJSON.lstCustomerSiteSKU[i].skuUom
                this.SUKList[i].SkuUomCode = resultJSON.lstCustomerSiteSKU[i].skuUomCode
                this.SUKList[i].SkuLength = resultJSON.lstCustomerSiteSKU[i].skuLength
                this.SUKList[i].SkuBreadth = resultJSON.lstCustomerSiteSKU[i].skuBreadth
                this.SUKList[i].SkuHeight = resultJSON.lstCustomerSiteSKU[i].skuHeight
                this.SUKList[i].CftBasedOn = resultJSON.lstCustomerSiteSKU[i].cftBasedOn
                this.SUKList[i].CftWeight = resultJSON.lstCustomerSiteSKU[i].cftWeight
                this.SUKList[i].ContributionPercentage = resultJSON.lstCustomerSiteSKU[i].contributionPercentage
                this.SUKList[i].SkuPhotoURL_ = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL
                var filename = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.substring(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.lastIndexOf('/') + 1);
                this.SUKList[i].SkuPhotoURLName = filename;
                this.SUKList[i].SkuPhotoFORMFILE = null
                this.SUKList[i].Customersitecode = resultJSON.lstCustomerSiteSKU[i].customersitecode;
              }
            }
            if(resultJSON.lstCustomerSiteSKUVolumeDistribution != null)
            {
              this.SUKVolumeDistrubutionList = resultJSON.lstCustomerSiteSKUVolumeDistribution;
              for (var i = 0; i < resultJSON.lstCustomerSiteSKUVolumeDistribution.length; i++) {
                this.SUKVolumeDistrubutionList[i].Hub = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hub;
                this.SUKVolumeDistrubutionList[i].HubCode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hubCode;
                this.SUKVolumeDistrubutionList[i].VolumeDistributionPercentage = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage;
                this.SUKVolumeDistrubutionList[i].Customersitecode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].customersitecode;           
              }
            }          
            
            ////////////////////////////////////--------------------Contract--------------------------/////////
            if(resultJSON.customerSiteContractDetail != null)
            {
              if (resultJSON.customerSiteContractDetail.contracttypescode != null) {
                var splitContractTypes = resultJSON.customerSiteContractDetail.contracttypescode.split(',');
                var ContractTypesCode: string[] = [];
                Object.keys(splitContractTypes).map((Index) => {
                  ContractTypesCode.push(splitContractTypes[Index]);
                  //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
                });
                this._ContractTypes = ContractTypesCode;
              }
              if (resultJSON.customerSiteContractDetail.opentypeodastatescode != null) {
                var splitState = resultJSON.customerSiteContractDetail.opentypeodastatescode.split(',');
                var StateCode: string[] = [];
                Object.keys(splitState).map((Index) => {
                  StateCode.push(splitState[Index]);
                  //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
                });
                this._StateNG = StateCode;
              }

              for (var i = 0; i < splitContractTypes.length; i++) {
                if (splitContractTypes[i] == 'MSC00081') {
                  this.HideGeneralRate = true
                }
                if (splitContractTypes[i] == 'MSC00083') {
                  this.HideArticleBased = true
                }
                if (splitContractTypes[i] == 'MSC00082') {
                  this.HideRegionLevel = true
                }
                if (splitContractTypes[i] == 'MSC00084') {
                  this.HideSlab = true
                }
                if (splitContractTypes[i] == 'MSC00104') {
                  this.Hide2DRate = true
                }
              }
              this._contracttypescode = resultJSON.customerSiteContractDetail.contracttypescode;
              this._contracttypes_ = resultJSON.customerSiteContractDetail.contracttypescode;
              console.log(this._contracttypes_);
              this._StateCode = resultJSON.customerSiteContractDetail.opentypeodastatescode;          
              this._CostingContract.controls['billingbranchcode'].setValue(resultJSON.customerSiteContractDetail.billingbranchcode);
              this._CostingContract.controls['fuelpriceperltr'].setValue(resultJSON.customerSiteContractDetail.fuelpriceperltr);
              this._CostingContract.controls['quotedrateperqtlperkm'].setValue(resultJSON.customerSiteContractDetail.quotedrateperqtlperkm);
              this._CostingContract.controls['minimumfreight'].setValue(resultJSON.customerSiteContractDetail.minimumfreight);
              this._CostingContract.controls['minimumchargeableweight'].setValue(resultJSON.customerSiteContractDetail.minimumchargeableweight);
              this._CostingContract.controls['minimumvsc'].setValue(resultJSON.customerSiteContractDetail.minimumvsc);
              this._CostingContract.controls['expectedsales'].setValue(resultJSON.customerSiteContractDetail.expectedsales);
              this._CostingContract.controls['creditlimit'].setValue(resultJSON.customerSiteContractDetail.creditlimit);
              this._CostingContract.controls['invoicecreditdays'].setValue(resultJSON.customerSiteContractDetail.invoicecreditdays);
              this._CostingContract.controls['minimumdc'].setValue(resultJSON.customerSiteContractDetail.minimumdc);
              this._CostingContract.controls['costtocompanydc'].setValue(resultJSON.customerSiteContractDetail.costtocompanydc);
              this._CostingContract.controls['costtoagentdc'].setValue(resultJSON.customerSiteContractDetail.costtoagentdc);
              this._CostingContract.controls['minimumdd'].setValue(resultJSON.customerSiteContractDetail.minimumdd);
              this._CostingContract.controls['costtocompanydd'].setValue(resultJSON.customerSiteContractDetail.costtoagentdd);
              this._CostingContract.controls['minimumac'].setValue(resultJSON.customerSiteContractDetail.minimumac);
              this._CostingContract.controls['costtocompanyac'].setValue(resultJSON.customerSiteContractDetail.costtocompanyac);
              this._CostingContract.controls['costtoagentac'].setValue(resultJSON.customerSiteContractDetail.costtoagentac);
              this._CostingContract.controls['odainclusiveorexclusivecode'].setValue(resultJSON.customerSiteContractDetail.odainclusiveorexclusivecode);
              this._CostingContract.controls['costtocompanyoda'].setValue(resultJSON.customerSiteContractDetail.costtocompanyoda);
              this._CostingContract.controls['costtoagentoda'].setValue(resultJSON.customerSiteContractDetail.costtoagentoda);
              this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerSiteContractDetail.flatodabasedoncode);
              if(resultJSON.lstGeneralContract != null)
              {
                this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
                this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
              }
              if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00805') {
                this._ArticleList = resultJSON.lstFlatODACharges;
                if(resultJSON.lstFlatODACharges != null)
                {
                  for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                    this._ArticleList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                    this._ArticleList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                    this._ArticleList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                    this._ArticleList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
                  }
                }
              }
              else if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00806') {
                this._KGList = resultJSON.lstFlatODACharges;
                if(resultJSON.lstFlatODACharges != null)
                {
                  for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                    this._KGList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                    this._KGList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                    this._KGList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                    this._KGList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
                  }
                }
              }
              this._RegionList = resultJSON.lstRegionContract;
              if(resultJSON.lstRegionContract != null)
              {
                for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
                  this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
                  this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
                  this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranch;
                  this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
                  this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregion;
                  this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
                  this._RegionList[i].article = resultJSON.lstRegionContract[i].article;
                  this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
                  this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetype;
                  this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
                  this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
                  this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetype;
                  this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;
                  this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
                  this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetype;
                  this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
                  this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
                  this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetype;
                  this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
                  this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].inclusiveorexclusivecode;
                  this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].inclusiveorexclusive;
                  this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
                  this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
                  if(resultJSON.lstRegionContract[i].lstDCDDACSlabs != null)
                  {
                    for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                      this._RegionList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                      this._RegionList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                      this._RegionList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                      this._RegionList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                      this._RegionList[i].lstDCDDACSlabs.Slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                      this._RegionList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
                    }
                  }
                }
              }
              console.log(this._RegionList);
              this._ArticleBasedList = resultJSON.lstArticleContract;
              if(resultJSON.lstArticleContract != null)
              {
                for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
                  this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
                  this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
                  this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranch;
                  this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
                  this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranch;
                  this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
                  this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].article;
                  this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
                  this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetype;
                  this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
                  this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
                  this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetype;
                  this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
                  this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
                  this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetype;
                  this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
                  this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
                  this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetype;
                  this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
                  this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].inclusiveorexclusivecode;
                  this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].inclusiveorexclusive;
                  this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
                  this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;
                  if(resultJSON.lstArticleContract[i].lstDCDDACSlabs != null)
                  {
                    for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                      this._ArticleBasedList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                      this._ArticleBasedList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                      this._ArticleBasedList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                      this._ArticleBasedList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                      this._ArticleBasedList[i].lstDCDDACSlabs.Slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                      this._ArticleBasedList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
                    }
                  }
                }
              }
              if(resultJSON.lstSlabContract != null)
              {
                this._SlabFormList = resultJSON.lstSlabContract;
                for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
                  this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
                  this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
                  this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranch;
                  this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
                  this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranch;
                  this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
                  this._SlabFormList[i].article = resultJSON.lstSlabContract[i].article;
                  this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
                  this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetype;
                  this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
                  this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
                  this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetype;
                  this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
                  this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
                  this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetype;
                  this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
                  this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
                  this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetype;
                  this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
                  this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].inclusiveorexclusivecode;
                  this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].inclusiveorexclusive;
                  this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
                  this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
                  if(resultJSON.lstSlabContract[i].lstDCDDACSlabs != null)
                  {
                    for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                      this._SlabFormList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                      this._SlabFormList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                      this._SlabFormList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                      this._SlabFormList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                      this._SlabFormList[i].lstDCDDACSlabs.Slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                      this._SlabFormList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
                    }
                  }
                }
              }
              if(resultJSON.lstTwoDContract != null)
              {
                this._2DList = resultJSON.lstTwoDContract;
                for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
                  this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
                  this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
                  this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranch;
                  this._2DList[i].toKM = resultJSON.lstTwoDContract[i].toKM;
                  this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
                  this._2DList[i].article = resultJSON.lstTwoDContract[i].article;
                  this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
                  this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetype;
                  this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
                  this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
                  this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetype;
                  this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
                  this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
                  this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetype;
                  this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
                  this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
                  this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetype;
                  this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
                  this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].inclusiveorexclusivecode;
                  this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].inclusiveorexclusive;
                  this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
                  this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
                  if(resultJSON.lstTwoDContract[i].lstDCDDACSlabs != null)
                  {
                    for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                      this._2DList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                      this._2DList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                      this._2DList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                      this._2DList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                      this._2DList[i].lstDCDDACSlabs.Slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                      this._2DList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
                    }
                  }
                }
              }

              if(resultJSON.lstAddOnCharge != null)
              {
                this.WayBillList = resultJSON.lstAddOnCharge;
                for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
                  this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
                  this.WayBillList[i].chargetype = resultJSON.lstAddOnCharge[i].chargetype;
                  this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
                  this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
                  this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetype;
                  this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].chargecodeid;
                  this.WayBillList[i].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargecodeid)[0].chargeName;
                  this.WayBillList[i].adrate = resultJSON.lstAddOnCharge[i].adrate;
                  this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
                  this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
                  this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printinothercharge;
                  this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
                  if(resultJSON.lstAddOnCharge[i].lstAddOnSlabs != null)
                  {
                    for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                      this.WayBillList[i].lstAddOnSlabs.Customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                      this.WayBillList[i].lstAddOnSlabs.Slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabfrom;
                      this.WayBillList[i].lstAddOnSlabs.Slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabto;
                      this.WayBillList[i].lstAddOnSlabs.Slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabrate;
                      this.WayBillList[i].lstAddOnSlabs.Slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabaddrate;
                      this.WayBillList[i].lstAddOnSlabs.Chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
                    }
                  }
                }
              }
            }
            
            ///////////////////////////////////------------------------Existing Vendor-------------------------/////////
            if(resultJSON.lstCustomerSiteVendor != null)
            {
              this.ExistingVendorList = resultJSON.lstCustomerSiteVendor
              for(var i = 0; i < resultJSON.lstCustomerSiteVendor.length; i++)
              {
                this.ExistingVendorList[i].vendorId =  resultJSON.lstCustomerSiteVendor[i].vendorId;
                this.ExistingVendorList[i].vendorName = resultJSON.lstCustomerSiteVendor[i].vendorName;
                this.ExistingVendorList[i].vendorRates = resultJSON.lstCustomerSiteVendor[i].vendorRates;
                this.ExistingVendorList[i].vendorStrength = resultJSON.lstCustomerSiteVendor[i].vendorStrength;
                this.ExistingVendorList[i].vendorPainPoint = resultJSON.lstCustomerSiteVendor[i].vendorPainPoint;                           
              }
            }
            
            ///////////////////////////////////----------------------------Trade Reference-----------------------------/////////
            if(resultJSON.lstCSTradeReferenceInside != null)
            {
              this.TempWithinCompanyList = resultJSON.lstCSTradeReferenceInside
              this.WithinCompanyList = resultJSON.lstCSTradeReferenceInside
              for(var i = 0; i < resultJSON.lstCSTradeReferenceInside.length; i++)
              {
                this.WithinCompanyList[i].tradeReferenceId =  resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].personName = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].designation = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].emailId = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
                this.WithinCompanyList[i].remarks = resultJSON.lstCSTradeReferenceInside[i].tradeReferenceId;
              }
            }
            if(resultJSON.lstCSTradeReferenceInside != null)
            {
              
              this.TempoutsideCompanyList = resultJSON.lstCSTradeReferenceOutside
              this.outsideCompanyList = resultJSON.lstCSTradeReferenceOutside

              for(var i = 0; i < resultJSON.lstCSTradeReferenceOutside.length; i++)
              {
                this.outsideCompanyList[i].tradeReferenceId =  resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceId;
                this.outsideCompanyList[i].tradeReferenceTypeCode = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceTypeCode;
                this.outsideCompanyList[i].tradeReferenceType = resultJSON.lstCSTradeReferenceOutside[i].tradeReferenceType;
                this.outsideCompanyList[i].personName = resultJSON.lstCSTradeReferenceOutside[i].personName;
                this.outsideCompanyList[i].designation = resultJSON.lstCSTradeReferenceOutside[i].designation;
                this.outsideCompanyList[i].emailId = resultJSON.lstCSTradeReferenceOutside[i].emailId;
                this.outsideCompanyList[i].phoneNo = resultJSON.lstCSTradeReferenceOutside[i].phoneNo;
                this.outsideCompanyList[i].remarks = resultJSON.lstCSTradeReferenceOutside[i].remarks;
              }
              
            }          
            

          
        }
        else {
          this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._CustomExceptionService.handleError(error) });
    }
  }
  

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 12;
      });
    }
  }
  //Customer Information
  CustomeronDocumentSelect(event) {
    this._LastAddedDocumentinCustomer = event.currentFiles[0];
    //  this.currentFileInSKU = event.currentFiles[0];
    // this._CustomerSiteform.get("pickuplocationphoto").setValue(this._LastAddedDocument.name);
    // document.clear();
  }
  GetCreditType(event) {
    var credittypearray = "";
    var credittypename = "";
    var selectedcredittype = event.value
    for (var i = 0; i < selectedcredittype.length; i++) {
      if (credittypearray == "") {
        credittypearray = selectedcredittype;
      }
      else {
        credittypearray = credittypearray + "," + selectedcredittype;
      }
    }
    this.CreditTypeCode = credittypearray
  }
  enterpincode(event) {
    var PinCode = this._CustomerAddressPickupform.get("pincode").value;
    if (PinCode.length == 6) {
      this.disablePinLocation = false
      this.pincodelocation = this._PincodeLocation.filter(f => f.pincode == PinCode);


      // console.log("tal",talukname)
    }
  }
  enterpincode1(event) {
    var PinCode1 = this._CustomerAddressBillingform.get("pincode").value;
    if (PinCode1.length == 6) {
      this.disablePinLocation1 = false
      this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
    }
  }
  OnChangePickupAddress(event) {
    if (event.checked == true) {
      this._CustomerAddressBillingform.controls['address'].setValue(this._CustomerAddressPickupform.controls['address'].value);
      this._CustomerAddressBillingform.controls['pincode'].setValue(this._CustomerAddressPickupform.controls['pincode'].value);
      this._CustomerAddressBillingform.controls['floortype'].setValue(this._CustomerAddressPickupform.controls['floortype'].value);
      var PinCode1 = this._CustomerAddressPickupform.get("pincode").value;
      this.pincodelocation1 = this._PincodeLocation1.filter(f => f.pincode == PinCode1);
      this.disablePinLocation1 = false
      var demo = this._CustomerAddressPickupform.controls['pincodelocation'].value.pincodeLocation
      this._CustomerAddressBillingform.controls['pincodelocation'].setValue(demo);
    }
    else {
      this.disablePinLocation1 = true
      this._CustomerAddressBillingform.reset();
    }
  }  

  OpenCustomerImage(model) {
    window.open(this.imageselect, "_blank");
  }

  showdocumentDialog(document: FileUpload, position1: string) {

  }
  checkspendhours(event) {
    var intime = this._CustomerSiteform.get("pickuplocationintime").value
    var outtime = this._CustomerSiteform.get("pickuplocationouttime").value
    console.log(outtime);
    var Spentime = outtime - intime
    // this._CustomerSiteform.get("pickuplocationintime").setValue(resultJSON.customerSiteDetail.pickuplocationintime)

    // this._CustomerSiteform.get("pickuplocationouttime").setValue(resultJSON.customerSiteDetail.pickuplocationouttime)
    // var spendtime = resultJSON.customerSiteDetail.pickuplocationouttime.getHours() - resultJSON.customerSiteDetail.pickuplocationintime.getHours()
    this._Tempform.get("totalspendtime").setValue(Spentime)
    // console.log("bh", spendtime);
  }
  //////////////////////////////----------GST Verificatiom------------ ////////////////////////
  ClickVerify() {
    var a = this._CustomerSiteform.get("validationbasedoncode").value;
    var b = this._CustomerSiteform.get("idNumber").value;
    //var c = this._TEMPForm.get("productid").value;
    var n = "a";
    if (this._CustomerSiteform.get("validationbasedoncode").value == 'MSC00799') {
      this._APIdService.getServiceDriving(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log("verification", resultJSON);
        if (resultJSON.message_code == "success") {
          this._CustomExceptionService.handleSuccess("Your document number verified successfully");
          this.GstValidationStatusCode = "MSC00011"
          // alert(resultJSON.message_code);
          // alert(resultJSON.data.permanent_address);
          // alert(resultJSON.data.permanent_zip);
          this._CustomerAddressPickupform.controls['pincode'].setValue(resultJSON.data.permanent_zip);
          this._CustomerAddressPickupform.controls['address'].setValue(resultJSON.data.permanent_address);
        } else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verificationfailed failed");
            // alert(resultJSON.message_code);
          }

      });
      //this._IsProgressSpinner = false; 
      //this._IsProgressSpinner = false; 

    }

    if (this._CustomerSiteform.get("validationbasedoncode").value == 'MSC00798') {
      this._APIdService.getServiceGST(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log(resultJSON);
        if (resultJSON.message_code == "success") {
          this._CustomExceptionService.handleSuccess("Your GST number verified successfully");
          this.GstValidationStatusCode = "MSC00011"
          //alert(resultJSON.message_code);
          //alert(resultJSON.data.address);
          var a = resultJSON.data.address.split(',');
          var b = a.length;
          var c = a[b - 1]
          //alert(c);
          this._CustomerAddressPickupform.controls['pincode'].setValue(c);
          this._CustomerAddressPickupform.controls['address'].setValue(resultJSON.data.address);
        }
        else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verificationfailed failed");
            // alert(resultJSON.message_code);
          }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
      });
    }
    if (this._CustomerSiteform.get("validationbasedoncode").value == "MSC00800") {
      this._APIdService.getServiceGOTP(this._CustomerSiteform.get("idNumber").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log(resultJSON);
        if (resultJSON.message_code == "success") {
          this._CustomExceptionService.handleSuccess("Your document number verified successfully");
          this.GstValidationStatusCode = "MSC00011"
          //alert(resultJSON.message_code);
          //alert(resultJSON.data.client_id);
          this._TempformAD.controls['client_id'].setValue(resultJSON.data.client_id);
        }
        else
          if (resultJSON.message == "Verification Failed") {
            this._CustomExceptionService.handleError("Your document number verificationfailed failed");
            // alert(resultJSON.message_code);
          }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
      });
    }
    // if (n == "z") {
    //   this._APIdService.getServiceVOTP("", "").subscribe((result) => {
    //     const resultJSON = JSON.parse(JSON.stringify(result));
    //     console.log(resultJSON);
    //     alert(resultJSON.message_code);
    //     alert(resultJSON.data.address.house + ", " + resultJSON.data.address.street + ", " + resultJSON.data.address.po + ", " + resultJSON.data.address.vtc + ", " + resultJSON.data.address.dist + " DT");
    //     alert(resultJSON.data.zip);
    //   }, error => {
    //     //this._IsProgressSpinner = false; 
    //     //this._IsProgressSpinner = false; 
    //   });
    // }

  }
  GSTStatusOnChange(event) {
    var gststatus = event.value
    if (gststatus == "MSC00795") {
      this._Basedon = this.Temp_Basedon.filter(f => f.metasubcode == "MSC00798");
    }
    if (gststatus == "MSC00796") {
      this._Basedon = this.Temp_Basedon.filter(f => f.metasubcode != "MSC00798");
    }

    console.log("sst", status)
    var a = this._CustomerSiteform.get("gstStatuscode").value;
    if (a == "MSC00795") {
      this.HideUnReg = true;
    }
    if (a == "MSC00796") {
      this.HideUnReg = false;
    }
  }

  DocOnChange() {
    //var a = this._TEMPForm.get("ValidationBased").value.;
    if (this._CustomerSiteform.get("validationbasedoncode").value == "MSC00800") {
      this.HideAadhar = false;
    }
    else {
      this.HideAadhar = true;
    }
  }
  ClickVerifyOTP() {
    if (this._TempformAD.get("client_id").value != "") {
      var a = this._TempformAD.get("client_id").value;
      //(<HTMLInputElement>document.getElementById("client_id")).value
      this._APIdService.getServiceVOTP(this._CustomerSiteform.get("client_id").value, this._TempformAD.get("AadharOTPVerification").value).subscribe((result) => {
        const resultJSON = JSON.parse(JSON.stringify(result));
        console.log(resultJSON);
        if (resultJSON.message_code == "success") {
          //alert(resultJSON.message_code);
          //alert(resultJSON.data.address.house+", "+resultJSON.data.address.street+", "+resultJSON.data.address.po+", "+resultJSON.data.address.vtc+", "+resultJSON.data.address.dist+" DT");
          //alert(resultJSON.data.zip);
          this._CustomerAddressPickupform.controls['pincode'].setValue(resultJSON.data.zip);
          this._CustomerAddressPickupform.controls['address'].setValue(resultJSON.data.address.house + ", " + resultJSON.data.address.street + ", " + resultJSON.data.address.po + ", " + resultJSON.data.address.vtc + ", " + resultJSON.data.address.dist + " DT");
        }
      }, error => {
        //this._IsProgressSpinner = false; 
        //this._IsProgressSpinner = false; 
      });
    }
  }
  // onEd() {
  //   alert("test");
  //   ace.config.set("fontSize", "14px");
  //   ace.config.set('basePath', 'https://unpkg.com/ace-builds@1.4.12/src-noconflict');
  //   const aceEditor = ace.edit(this.editor.nativeElement);
  //   aceEditor.getSession().setMode("ace/mode/json");
  //   var myObj = this.CompanyList;
  //   var myJSON = JSON.stringify(myObj);
  //   aceEditor.session.setValue(myJSON);
  // }
  enterpincodeSL(event) {
    var PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value;
    if (PinCode.length == 6) {
      this.disablePinLocation = false
      this.TempSLpincodelocation = this._TempSLPincodeLocation.filter(f => f.pincode == PinCode);
    }
  }
  showBasicDialog() {
    this.displayBasic = true;
  }
  ChangeQuote(event) {
    if (event == "PQT00057") {
      this.DisableMail = true
    }
    else {
      this.DisableMail = false
    }
  }
  ChangeFlatODAMapping(event) {
    var selectedid = event.value;
    if (selectedid.idflat == 1) {
      this.HideArticleODA = false
      this.HideTonnageODA = true
    }
    if (selectedid.idflat == 2) {
      this.HideTonnageODA = false
      this.HideArticleODA = true
    }
  }
  ChangeODAMapping(event) {
    var selectedid = event.value;
    if (selectedid.id == 1) {

      this.HideOpenTYpe = false
      this.HideFlatTYpe = true
      this.HideServiceable = true
      this.HideTranscationTYpe = true

      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 2) {
      this.HideOpenTYpe = true
      this.HideFlatTYpe = false
      this.HideServiceable = true
      this.HideTranscationTYpe = true
    }
    if (selectedid.id == 3) {
      this.HideServiceable = false
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideTranscationTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 4) {
      this.HideServiceable = false
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideTranscationTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }
    if (selectedid.id == 5) {
      this.HideTranscationTYpe = false
      this.HideServiceable = true
      this.HideOpenTYpe = true
      this.HideFlatTYpe = true
      this.HideArticleODA = true
      this.HideTonnageODA = true
    }

  }
  goBack(event) {
    this.router.navigate(['/vprequote']);
  }
  /////////////////------------Tab change Event Start--------------------//////////////////////
  TabClick(event) {
    var index = event.index;
    if(this.CustomersiteCode != null || this.CustomersiteCode != undefined || this.CustomersiteCode != "")
    {
      console.log("tab value", this._TempformforTab.get("TabName").value)
      if (this._TempformforTab.get("TabName").value == 0) {
        this.onSave()
      }
      if (this._TempformforTab.get("TabName").value == 1) {
        this.ServiceLocationAndOprerationSave();
      }
      if (this._TempformforTab.get("TabName").value == 2) {
        this.SKUSave();
      }
      if (this._TempformforTab.get("TabName").value == 3) {
        this.CustomerSiteCostAndContractSubmit();
      }
      if (this._TempformforTab.get("TabName").value == 4) {
        this.onsaveVendor()
      }
      if (this._TempformforTab.get("TabName").value == 5) {
        this.onsaveTrade()
      }
    }
    this._TempformforTab.controls['TabName'].setValue(index);
  }
  /////////////////------------Temp save and permanant save -------------//////////////////////
  onSave() {
    // this._submitted = true
    this._SelectedCreditType = this._CustomerSiteform.get("credittypecode").value
    console.log("mm", this._SelectedCreditType);

    console.log("len", this.ExistCustomerCI)
    
      this._CustomerSite = this._CustomerSiteform.value;
      this._CustomerSite.customercode = this.CustomerCode
      this._CustomerSite.customersitecode = this.CustomersiteCode
      if (this.creditCode == null) {
        this._CustomerSite.credittypecode = this.CreditTypeCode
      } else {
        this._CustomerSite.credittypecode = this.creditCode
      }

      this._CustomerSite.recordstatus = "MSC00001"
      this._CustomerSite.recordstatuscode = "MSC00001"
      this._CustomerSite.modifiedby = "Admin"
      this._CustomerSite.createdon = new Date()
      this._CustomerSite.accountingyear = new Date().getFullYear()
      this._CustomerSite.modifiedon = new Date()
      this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value;
      this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value;
      this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value;
      this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value;
      this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value;
      this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value;


      if (this.GstValidationStatusCode != undefined) {
        this._CustomerSite.gstValidationstatuscode = this.GstValidationStatusCode
      } else if (this._CustomerDetail.gstValidationstatuscode != null) {
        this._CustomerSite.gstValidationstatuscode = this._CustomerDetail.gstValidationstatuscode
      } else {
        this._CustomerSite.gstValidationstatuscode = "MSC00012"
      }



      // if (this._CustomerDetail.gstValidationstatuscode != null){
      //   this._CustomerSite.gstValidationstatuscode = this._CustomerDetail.gstValidationstatuscode
      // }else if(this.GstValidationStatusCode != undefined){
      //   this._CustomerSite.gstValidationstatuscode = this.GstValidationStatusCode
      // }else{
      //   this._CustomerSite.gstValidationstatuscode = "MSC00012"
      // }

      // if (this.GstValidationStatusCode != undefined) {
      //   this._CustomerSite.gstValidationstatuscode = this.GstValidationStatusCode
      // } else {
      //   this._CustomerSite.gstValidationstatuscode = "MSC00012"
      // }

      this._CustomerSite.gstValidationstatus = ""
      if (this._LastAddedDocumentinCustomer == undefined || this._LastAddedDocumentinCustomer == null) {
        this._CustomerSite.pickuplocationphotoURL = ""
      } else {
        this._CustomerSite.pickuplocationphotoURL = this._LastAddedDocumentinCustomer.name || ""
      }

      var l_CustomerAddress = new CustomerSiteAddress();
      // this._CustomerDetail.lstCustomerSiteAddress = []
      this._CustomerDetail.lstCustomerSiteAddress[0].addressid = this.addressid;
      this._CustomerDetail.lstCustomerSiteAddress[0].customersitecode = this.CustomersiteCode
      this._CustomerDetail.lstCustomerSiteAddress[0].addresstypecode = "PQT00031";
      this._CustomerDetail.lstCustomerSiteAddress[0].address = this._CustomerAddressPickupform.get("address").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].taluk = this._CustomerAddressPickupform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].pincode = this._CustomerAddressPickupform.get("pincode").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].floortypecode = this._CustomerAddressPickupform.get("floortype").value;
      this._CustomerDetail.lstCustomerSiteAddress[0].recordstatuscode = "MSC00001"


      this._CustomerDetail.lstCustomerSiteAddress[1].addressid = this.addressid1;
      this._CustomerDetail.lstCustomerSiteAddress[1].customersitecode = this.CustomersiteCode;
      this._CustomerDetail.lstCustomerSiteAddress[1].addresstypecode = "PQT00032";
      this._CustomerDetail.lstCustomerSiteAddress[1].address = this._CustomerAddressBillingform.get("address").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].taluk = this._CustomerAddressBillingform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].pincode = this._CustomerAddressBillingform.get("pincode").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].floortypecode = this._CustomerAddressBillingform.get("floortype").value;
      this._CustomerDetail.lstCustomerSiteAddress[1].recordstatuscode = "MSC00001"

      var l_CustomerContact = new CustomerSiteContact();
      this._CustomerSite.lstCustomerSiteContact[0].contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid;
      this._CustomerSite.lstCustomerSiteContact[0].customersitecode = this.CustomersiteCode;
      this._CustomerSite.lstCustomerSiteContact[0].contacttypecode = "PQT00034";
      this._CustomerSite.lstCustomerSiteContact[0].contactperson = this._CustomerContactPickform.get("contactperson").value;
      this._CustomerSite.lstCustomerSiteContact[0].designation = this._CustomerContactPickform.get("designation").value;
      this._CustomerSite.lstCustomerSiteContact[0].department = this._CustomerContactPickform.get("department").value;
      this._CustomerSite.lstCustomerSiteContact[0].phoneno = this._CustomerContactPickform.get("phoneno").value;
      this._CustomerSite.lstCustomerSiteContact[0].mobileno = this._CustomerContactPickform.get("mobileno").value;
      this._CustomerSite.lstCustomerSiteContact[0].emailid = this._CustomerContactPickform.get("emailid").value;
      this._CustomerSite.lstCustomerSiteContact[0].faxno = this._CustomerContactPickform.get("faxno").value;
      this._CustomerSite.lstCustomerSiteContact[0].recordstatuscode = "MSC00001";

      // var l_CustomerContactInvoice = new CustomerSiteContact();
      // this._CustomerSite.lstCustomerSiteContact[1].contactid = this._CustomerDetail.lstCustomerSiteContact[1].contactid;;
      // this._CustomerSite.lstCustomerSiteContact[1].customersitecode = this.CustomersiteCode;
      // this._CustomerSite.lstCustomerSiteContact[1].contacttypecode = "PQT00035";
      // this._CustomerSite.lstCustomerSiteContact[1].contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
      // this._CustomerSite.lstCustomerSiteContact[1].designation = this._CustomerContactInvoiceform.get("designation").value;
      // this._CustomerSite.lstCustomerSiteContact[1].department = this._CustomerContactInvoiceform.get("department").value;
      // this._CustomerSite.lstCustomerSiteContact[1].phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
      // this._CustomerSite.lstCustomerSiteContact[1].mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
      // this._CustomerSite.lstCustomerSiteContact[1].emailid = this._CustomerContactInvoiceform.get("emailid").value;
      // this._CustomerSite.lstCustomerSiteContact[1].faxno = this._CustomerContactInvoiceform.get("faxno").value;
      // this._CustomerSite.lstCustomerSiteContact[1].recordstatuscode = "MSC00001";
      // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactInvoice)
      // var l_CustomerContactOutgoing = new CustomerSiteContact();
      // this._CustomerSite.lstCustomerSiteContact[2].contactid = this._CustomerDetail.lstCustomerSiteContact[2].contactid;;
      // this._CustomerSite.lstCustomerSiteContact[2].customersitecode = this.CustomersiteCode;
      // this._CustomerSite.lstCustomerSiteContact[2].contacttypecode = "PQT00036";
      // this._CustomerSite.lstCustomerSiteContact[2].contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
      // this._CustomerSite.lstCustomerSiteContact[2].designation = this._CustomerContactOutgoingform.get("designation").value;
      // this._CustomerSite.lstCustomerSiteContact[2].department = this._CustomerContactOutgoingform.get("department").value;
      // this._CustomerSite.lstCustomerSiteContact[2].phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
      // this._CustomerSite.lstCustomerSiteContact[2].mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
      // this._CustomerSite.lstCustomerSiteContact[2].emailid = this._CustomerContactOutgoingform.get("emailid").value;
      // this._CustomerSite.lstCustomerSiteContact[2].faxno = this._CustomerContactOutgoingform.get("faxno").value;
      // this._CustomerSite.lstCustomerSiteContact[2].recordstatuscode = "MSC00001";
      // this.onEd()
      this.CusomerFile.push(this._LastAddedDocumentinCustomer)
      var CustomerSite = this.formconverstionCustomer(this.CusomerFile);
      this._CustomerInformationService.UpdateCustomerSite(CustomerSite).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("EDIT", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomerSiteCode = resutJSON.customerSiteDetail.customersitecode
          this.validationStatusCode = resutJSON.customerSiteDetail.gstValidationstatuscode
          //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          // this.reset()
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { //this._CustomExceptionService.handleError(error) 
      });
    
  }
  formconverstionCustomer(customerdocuments: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:


    for (var x in customerdocuments) {
      if (customerdocuments[x] != undefined) {
        //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
        //console.log("Index", index);
        //if (index != -1) {
        var NewFileName = customerdocuments[x].name || "";
        // p_documentdetails[index].attachmentname = NewFileName;
        // p_documentdetails[index].attachmenturl = NewFileName;
        formData.append('iFormFile', customerdocuments[x], NewFileName);
      }
    }
    var _CustomerSiteOBJ = {
      "CustomerSite": this._CustomerSite,
    };
    console.log(_CustomerSiteOBJ)
    var _CustomersiteFD = JSON.stringify(_CustomerSiteOBJ);
    console.log(_CustomersiteFD)
    formData.append('strCustomerSite', _CustomersiteFD);
    return (formData);

  }
  onSaveSubmit() {
    this._submitted = true
    this._SelectedCreditType = this._CustomerSiteform.get("credittypecode").value
    console.log("mm", this._SelectedCreditType);
    if (this._CustomerSiteform.valid && this._CustomerAddressPickupform.valid && this._CustomerAddressBillingform && this._CustomerContactPickform.valid
      ) {
        // && this._CustomerContactInvoiceform.valid && this._CustomerContactOutgoingform.valid
      console.log("len", this.ExistCustomerCI)
      if (this.ExistCustomerCI == null) {
        this._CustomerSite = this._CustomerSiteform.value;
        this._CustomerSite.customercode = this.CustomerCode
        this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value;
        this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value;
        this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value;
        this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value;
        this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value;
        this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value;
        this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value;
        this._CustomerSite.gstValidationstatuscode = "MSC00006"
        this._CustomerSite.gstValidationstatus = ""
        // this._CustomerSite.credittypecode = this.CreditTypeCode
        this._CustomerSite.credittypecode = this.CreditTypeCode
        // this._CustomerSite.credittypes = this.CreditTypeName
        this._CustomerSite.recordstatus = "MSC00001"
        this._CustomerSite.recordstatuscode = "MSC00001"
        this._CustomerSite.createdby = "Admin"
        this._CustomerSite.modifiedby = "Admin"
        this._CustomerSite.createdon = new Date()
        this._CustomerSite.modifiedon = new Date()
        this._CustomerSite.accountingyear = new Date().getFullYear()


        if (this._CustomerSite.lstCustomerSiteAddress == null) {
          this._CustomerSite.lstCustomerSiteAddress = [] = []
        }
        if (this._CustomerSite.lstCustomerSiteContact == null) {
          this._CustomerSite.lstCustomerSiteContact = [] = [];
        }


        var l_CustomerAddress = new CustomerSiteAddress();
        l_CustomerAddress.addressid = 0;
        l_CustomerAddress.customersitecode = "";
        l_CustomerAddress.addresstypecode = "PQT00031";
        l_CustomerAddress.address = this._CustomerAddressPickupform.get("address").value;
        l_CustomerAddress.taluk = this._CustomerAddressPickupform.get("pincodelocation").value.taluk;
        l_CustomerAddress.pincode = this._CustomerAddressPickupform.get("pincode").value;
        l_CustomerAddress.pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value;
        l_CustomerAddress.floortypecode = this._CustomerAddressPickupform.get("floortype").value;
        l_CustomerAddress.recordstatuscode = "MSC00001"
        this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerAddress)
        var l_CustomerBillingAddress = new CustomerSiteAddress();
        l_CustomerBillingAddress.addressid = 0;
        l_CustomerBillingAddress.customersitecode = "";
        l_CustomerBillingAddress.addresstypecode = "PQT00032";
        l_CustomerBillingAddress.address = this._CustomerAddressBillingform.get("address").value;
        l_CustomerBillingAddress.taluk = this._CustomerAddressBillingform.get("pincodelocation").value;
        l_CustomerBillingAddress.pincode = this._CustomerAddressBillingform.get("pincode").value;
        l_CustomerBillingAddress.pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value;
        l_CustomerBillingAddress.floortypecode = this._CustomerAddressBillingform.get("floortype").value;
        l_CustomerBillingAddress.recordstatuscode = "MSC00001"
        this._CustomerSite.lstCustomerSiteAddress.push(l_CustomerBillingAddress)
        var l_CustomerContact = new CustomerSiteContact();
        l_CustomerContact.contactid = 0;
        l_CustomerContact.customersitecode = "";
        l_CustomerContact.contacttypecode = "PQT00034";
        l_CustomerContact.contactperson = this._CustomerContactPickform.get("contactperson").value;
        l_CustomerContact.designation = this._CustomerContactPickform.get("designation").value;
        l_CustomerContact.department = this._CustomerContactPickform.get("department").value;
        l_CustomerContact.phoneno = this._CustomerContactPickform.get("phoneno").value;
        l_CustomerContact.mobileno = this._CustomerContactPickform.get("mobileno").value;
        l_CustomerContact.emailid = this._CustomerContactPickform.get("emailid").value;
        l_CustomerContact.faxno = this._CustomerContactPickform.get("faxno").value;
        l_CustomerContact.recordstatuscode = "MSC00001";
        this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContact)
        // var l_CustomerContactInvoice = new CustomerSiteContact();
        // l_CustomerContactInvoice.contactid = 0;
        // l_CustomerContactInvoice.customersitecode = "";
        // l_CustomerContactInvoice.contacttypecode = "PQT00035";
        // l_CustomerContactInvoice.contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
        // l_CustomerContactInvoice.designation = this._CustomerContactInvoiceform.get("designation").value;
        // l_CustomerContactInvoice.department = this._CustomerContactInvoiceform.get("department").value;
        // l_CustomerContactInvoice.phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
        // l_CustomerContactInvoice.mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
        // l_CustomerContactInvoice.emailid = this._CustomerContactInvoiceform.get("emailid").value;
        // l_CustomerContactInvoice.faxno = this._CustomerContactInvoiceform.get("faxno").value;
        // l_CustomerContact.recordstatuscode = "MSC00001";
        // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactInvoice)
        // var l_CustomerContactOutgoing = new CustomerSiteContact();
        // l_CustomerContactOutgoing.contactid = 0;
        // l_CustomerContactOutgoing.customersitecode = "";
        // l_CustomerContactOutgoing.contacttypecode = "PQT00036";
        // l_CustomerContactOutgoing.contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
        // l_CustomerContactOutgoing.designation = this._CustomerContactOutgoingform.get("designation").value;
        // l_CustomerContactOutgoing.department = this._CustomerContactOutgoingform.get("department").value;
        // l_CustomerContactOutgoing.phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
        // l_CustomerContactOutgoing.mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
        // l_CustomerContactOutgoing.emailid = this._CustomerContactOutgoingform.get("emailid").value;
        // l_CustomerContactOutgoing.faxno = this._CustomerContactOutgoingform.get("faxno").value;

        // l_CustomerContact.recordstatuscode = "MSC00001";
        // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactOutgoing)
        console.log("IN");
        this._CustomerInformationService.InsertCustomer(this._CustomerSite).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          console.log("save", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
            // this.ManageCustomersList = resutJSON.lstCustomer
            // this.reset()
          }
          else {
            this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { 
          //this._CustomExceptionService.handleError(error) 
        }
        );
      }
      else if (this.ExistCustomerCI != null) {
        this._CustomerSite = this._CustomerSiteform.value;
        this._CustomerSite.customercode = this.CustomerCode
        this._CustomerSite.customersitecode = this.CustomersiteCode
        // this._CustomerSite.credittypecode = ""
        this._CustomerSite.credittypecode = this.CreditTypeCode
        this._CustomerSite.recordstatus = "MSC00001"
        this._CustomerSite.recordstatuscode = "MSC00001"
        this._CustomerSite.modifiedby = "Admin"
        this._CustomerSite.modifiedon = new Date()
        this._CustomerSite.acquiredbycode = this._CustomerSiteform.get("acquiredbycode").value;
        this._CustomerSite.producttypecode = this._CustomerSiteform.get("producttypecode").value;
        this._CustomerSite.billingtocode = this._CustomerSiteform.get("billingtocode").value;
        this._CustomerSite.gstStatuscode = this._CustomerSiteform.get("gstStatuscode").value;
        this._CustomerSite.gstStatus = this._CustomerSiteform.get("gstStatuscode").value;
        this._CustomerSite.validationbasedoncode = this._CustomerSiteform.get("validationbasedoncode").value;
        this._CustomerSite.validationbasedon = this._CustomerSiteform.get("validationbasedoncode").value;
        this._CustomerSite.gstValidationstatuscode = "MSC00006"
        this._CustomerSite.gstValidationstatus = ""

        var l_CustomerAddress = new CustomerSiteAddress();
        // this._CustomerDetail.lstCustomerSiteAddress = []
        this._CustomerDetail.lstCustomerSiteAddress[0].addressid = this.addressid;
        this._CustomerDetail.lstCustomerSiteAddress[0].customersitecode = this.CustomersiteCode
        this._CustomerDetail.lstCustomerSiteAddress[0].addresstypecode = "PQT00031";
        this._CustomerDetail.lstCustomerSiteAddress[0].address = this._CustomerAddressPickupform.get("address").value;
        this._CustomerDetail.lstCustomerSiteAddress[0].taluk = this._CustomerAddressPickupform.get("pincodelocation").value;
        this._CustomerDetail.lstCustomerSiteAddress[0].pincode = this._CustomerAddressPickupform.get("pincode").value;
        this._CustomerDetail.lstCustomerSiteAddress[0].pincodelocation = this._CustomerAddressPickupform.get("pincodelocation").value;
        this._CustomerDetail.lstCustomerSiteAddress[0].floortypecode = this._CustomerAddressPickupform.get("floortype").value;
        this._CustomerDetail.lstCustomerSiteAddress[0].recordstatuscode = "MSC00001"


        this._CustomerDetail.lstCustomerSiteAddress[1].addressid = this.addressid1;
        this._CustomerDetail.lstCustomerSiteAddress[1].customersitecode = this.CustomersiteCode;
        this._CustomerDetail.lstCustomerSiteAddress[1].addresstypecode = "PQT00032";
        this._CustomerDetail.lstCustomerSiteAddress[1].address = this._CustomerAddressBillingform.get("address").value;
        this._CustomerDetail.lstCustomerSiteAddress[1].taluk = this._CustomerAddressBillingform.get("pincodelocation").value;
        this._CustomerDetail.lstCustomerSiteAddress[1].pincode = this._CustomerAddressBillingform.get("pincode").value;
        this._CustomerDetail.lstCustomerSiteAddress[1].pincodelocation = this._CustomerAddressBillingform.get("pincodelocation").value;
        this._CustomerDetail.lstCustomerSiteAddress[1].floortypecode = this._CustomerAddressBillingform.get("floortype").value;
        this._CustomerDetail.lstCustomerSiteAddress[1].recordstatuscode = "MSC00001"

        var l_CustomerContact = new CustomerSiteContact();
        this._CustomerSite.lstCustomerSiteContact[0].contactid = this._CustomerDetail.lstCustomerSiteContact[0].contactid;
        this._CustomerSite.lstCustomerSiteContact[0].customersitecode = this.CustomersiteCode;
        this._CustomerSite.lstCustomerSiteContact[0].contacttypecode = "PQT00034";
        this._CustomerSite.lstCustomerSiteContact[0].contactperson = this._CustomerContactPickform.get("contactperson").value;
        this._CustomerSite.lstCustomerSiteContact[0].designation = this._CustomerContactPickform.get("designation").value;
        this._CustomerSite.lstCustomerSiteContact[0].department = this._CustomerContactPickform.get("department").value;
        this._CustomerSite.lstCustomerSiteContact[0].phoneno = this._CustomerContactPickform.get("phoneno").value;
        this._CustomerSite.lstCustomerSiteContact[0].mobileno = this._CustomerContactPickform.get("mobileno").value;
        this._CustomerSite.lstCustomerSiteContact[0].emailid = this._CustomerContactPickform.get("emailid").value;
        this._CustomerSite.lstCustomerSiteContact[0].faxno = this._CustomerContactPickform.get("faxno").value;
        this._CustomerSite.lstCustomerSiteContact[0].recordstatuscode = "MSC00001";

        // var l_CustomerContactInvoice = new CustomerSiteContact();
        // this._CustomerSite.lstCustomerSiteContact[1].contactid = this._CustomerDetail.lstCustomerSiteContact[1].contactid;;
        // this._CustomerSite.lstCustomerSiteContact[1].customersitecode = this.CustomersiteCode;
        // this._CustomerSite.lstCustomerSiteContact[1].contacttypecode = "PQT00035";
        // this._CustomerSite.lstCustomerSiteContact[1].contactperson = this._CustomerContactInvoiceform.get("contactperson").value;
        // this._CustomerSite.lstCustomerSiteContact[1].designation = this._CustomerContactInvoiceform.get("designation").value;
        // this._CustomerSite.lstCustomerSiteContact[1].department = this._CustomerContactInvoiceform.get("department").value;
        // this._CustomerSite.lstCustomerSiteContact[1].phoneno = this._CustomerContactInvoiceform.get("phoneno").value;
        // this._CustomerSite.lstCustomerSiteContact[1].mobileno = this._CustomerContactInvoiceform.get("mobileno").value;
        // this._CustomerSite.lstCustomerSiteContact[1].emailid = this._CustomerContactInvoiceform.get("emailid").value;
        // this._CustomerSite.lstCustomerSiteContact[1].faxno = this._CustomerContactInvoiceform.get("faxno").value;
        // this._CustomerSite.lstCustomerSiteContact[1].recordstatuscode = "MSC00001";
        // this._CustomerSite.lstCustomerSiteContact.push(l_CustomerContactInvoice)
        // var l_CustomerContactOutgoing = new CustomerSiteContact();
        // this._CustomerSite.lstCustomerSiteContact[2].contactid = this._CustomerDetail.lstCustomerSiteContact[2].contactid;;
        // this._CustomerSite.lstCustomerSiteContact[2].customersitecode = this.CustomersiteCode;
        // this._CustomerSite.lstCustomerSiteContact[2].contacttypecode = "PQT00036";
        // this._CustomerSite.lstCustomerSiteContact[2].contactperson = this._CustomerContactOutgoingform.get("contactperson").value;
        // this._CustomerSite.lstCustomerSiteContact[2].designation = this._CustomerContactOutgoingform.get("designation").value;
        // this._CustomerSite.lstCustomerSiteContact[2].department = this._CustomerContactOutgoingform.get("department").value;
        // this._CustomerSite.lstCustomerSiteContact[2].phoneno = this._CustomerContactOutgoingform.get("phoneno").value;
        // this._CustomerSite.lstCustomerSiteContact[2].mobileno = this._CustomerContactOutgoingform.get("mobileno").value;
        // this._CustomerSite.lstCustomerSiteContact[2].emailid = this._CustomerContactOutgoingform.get("emailid").value;
        // this._CustomerSite.lstCustomerSiteContact[2].faxno = this._CustomerContactOutgoingform.get("faxno").value;
        // this._CustomerSite.lstCustomerSiteContact[2].recordstatuscode = "MSC00001";

        this._CustomerInformationService.UpdateCustomerSite(this._CustomerSite).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          console.log("EDIT", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            // this.reset()
          }
          else {
            //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { 
          //this._CustomExceptionService.handleError(error) 
        }
        );
      }
    }
  }
  ServiceLocationAndOprerationSubmit() {
    this._SLsubmitted = true;
    //alert();

    this._ServiceOpt = this._ServiceLocationAndOperation_Form.value;
    this._ServiceOpt.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    this._ServiceOpt.createdby = '1';
    /* this._ServiceOpt.servicelocationscode = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statecode;
     this._ServiceOpt.servicelocations = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statename;*/
    this._ServiceOpt.servicelocationscode = this._TempServiceLocationsCode;
    this._ServiceOpt.servicelocations = this._TempServiceLocations;
    this._ServiceOpt.tiercode = this._ServiceLocationAndOperation_Form.get("tiercode").value.metasubcode;
    this._ServiceOpt.tier = this._ServiceLocationAndOperation_Form.get("tiercode").value.metasubdescription;
    this._ServiceOpt.podrequirementcode = this._ServiceLocationAndOperation_Form.get("podrequirementcode").value.metasubcode;
    this._ServiceOpt.podrequirement = this._ServiceLocationAndOperation_Form.get("podrequirementcode").value.metasubdescription;
    this._ServiceOpt.bookingcutofftime = this._ServiceLocationAndOperation_Form.get("bookingcutofftime").value;
    this._ServiceOpt.vehicledeparturecutofftime = this._ServiceLocationAndOperation_Form.get("vehicledeparturecutofftime").value;
    this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("pickupcutofftime").value;
    this._ServiceOpt.odalocationcode = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.odalocation = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.customerlrcopycode = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.customerlrcopy = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.invoiceacknowledgementcode = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.invoiceacknowledgement = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.returnbookingcode = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.returnbooking = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.lstCustomerSiteSpecialDelivery = this.SpecialDeliveryList;
    this._ServiceOpt.isTemp = false;

    this._ServiceOpt.lstCustomerSiteTAT = this.TATDetails;
    //this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("acquiredbycode").value.metasubcode;
    console.log(this._ServiceOpt);    
    
      this._ServiceLocationAndOperationService.UpdateServiceLocOpt(this._ServiceOpt).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { this._CustomExceptionService.handleError(error) }
      );
    

  }
  ServiceLocationAndOprerationSave() {
    // this._SLsubmitted = true;
    //alert();

    this._ServiceOpt = this._ServiceLocationAndOperation_Form.value;
    this._ServiceOpt.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    this._ServiceOpt.createdby = '1';
    /* this._ServiceOpt.servicelocationscode = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statecode;
     this._ServiceOpt.servicelocations = this._ServiceLocationAndOperation_Form.get("servicelocationscode").value.statename;*/
    this._ServiceOpt.servicelocationscode = this._TempServiceLocationsCode
    this._ServiceOpt.servicelocations = this._TempServiceLocations
    this._ServiceOpt.tiercode = this._TempTierCode
    this._ServiceOpt.tier = this._TempTierName
    this._ServiceOpt.podrequirementcode = this._ServiceLocationAndOperation_Form.get("podrequirementcode").value;
    this._ServiceOpt.podrequirement = this._ServiceLocationAndOperation_Form.get("podrequirementcode").value;
    this._ServiceOpt.bookingcutofftime = this._ServiceLocationAndOperation_Form.get("bookingcutofftime").value;
    this._ServiceOpt.vehicledeparturecutofftime = this._ServiceLocationAndOperation_Form.get("vehicledeparturecutofftime").value;
    this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("pickupcutofftime").value;
    this._ServiceOpt.odalocationcode = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.odalocation = this._ServiceLocationAndOperation_Form.get("odalocation").value;
    this._ServiceOpt.customerlrcopycode = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.customerlrcopy = this._ServiceLocationAndOperation_Form.get("customerlrcopy").value;
    this._ServiceOpt.invoiceacknowledgementcode = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.invoiceacknowledgement = this._ServiceLocationAndOperation_Form.get("invoiceacknowledgement").value;
    this._ServiceOpt.returnbookingcode = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.returnbooking = this._ServiceLocationAndOperation_Form.get("returnbooking").value;
    this._ServiceOpt.isTemp = true;
    // this._ServiceOpt.lstCustomerSiteSpecialDelivery = this.SpecialDeliveryList;

    this._ServiceOpt.lstCustomerSiteTAT = this.TATDetails;
    //this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("acquiredbycode").value.metasubcode;
    // console.log(this._ServiceOpt);
    // alert(this._ServiceOpt);

   
      // this.onEd()
      this._ServiceLocationAndOperationService.UpdateServiceLocOpt(this._ServiceOpt).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("save", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { 
        //this._CustomExceptionService.handleError(error) 
      }
      );
    

  }
  SKUSubmit() {
    this._CustomerSKUList = this._SUK_Form.value;
    //this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;

    this._CustomerSKUList.lstCustomerSiteSKU = this._SUK_Form.value;
    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;
    //this._CustomerSiteSKUList[]=[];
    //this._CustomerSiteSKUList.Customersitecode = "CRS-202107-00002";
    //this._CustomerSKUList.customersitecode = 'CRS-202107-00002';
    this._CustomerSKUList.lstCustomerSiteSKU = this.SUKList;
    this._CustomerSKUList.isTemp = false;

    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this.SUKVolumeDistrubutionList;
    //this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("acquiredbycode").value.metasubcode;
    var CustomerSKU = this.SKUformconverstion(this._selectedDocuments);

    console.log(this._CustomerSKUList);
    //alert(this._CustomerSKUList);

   
      //this._CustomerSUKService.UpdateSUK(this._CustomerSKUList).subscribe((result) => {
      this._CustomerSUKService.create(CustomerSKU).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("Update", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { 
        //this._CustomExceptionService.handleError(error) 
      }
      );
    
  }
  SKUSave() {

    this._CustomerSKUList = this._SUK_Form.value;
    //this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;

    this._CustomerSKUList.lstCustomerSiteSKU = this._SUK_Form.value;
    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this._SUK_VolumeDistrubution_Form.value;
    //this._CustomerSiteSKUList[]=[];
    //this._CustomerSiteSKUList.Customersitecode = "CRS-202107-00002";
    //this._CustomerSKUList.customersitecode = 'CRS-202107-00002';
    this._CustomerSKUList.lstCustomerSiteSKU = this.SUKList;
    this._CustomerSKUList.isTemp = true;

    this._CustomerSKUList.lstCustomerSiteSKUVolumeDistribution = this.SUKVolumeDistrubutionList;
    //this._ServiceOpt.pickupcutofftime = this._ServiceLocationAndOperation_Form.get("acquiredbycode").value.metasubcode;
    var CustomerSKU = this.SKUformconverstion(this._selectedDocuments);

    console.log(this._CustomerSKUList);
    
    
      //this._CustomerSUKService.UpdateSUK(this._CustomerSKUList).subscribe((result) => {
      this._CustomerSUKService.create(CustomerSKU).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("Update", resutJSON)
        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          // this.ManageCustomersList = resutJSON.lstCustomer
          //this.reset()
        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }
      }, error => { 
        //this._CustomExceptionService.handleError(error)
       }
      );
    
  }
  onsaveTrade() {
    if (this.TempWithinCompanyList.length == 0 && this.TempoutsideCompanyList.length == 0) {
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _tradeindetail = new CustomerSiteTradeReference();
        _tradeindetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _tradeindetail.tradeReferenceId = 0
        _tradeindetail.tradeReferenceTypeCode = "PQT00053";
        _tradeindetail.tradeReferenceType = "";
        _tradeindetail.personName = this.WithinCompanyList[i].personName
        _tradeindetail.designation = this.WithinCompanyList[i].designation
        _tradeindetail.emailId = this.WithinCompanyList[i].emailId
        _tradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo
        _tradeindetail.experience = this.WithinCompanyList[i].experience
        _tradeindetail.remarks = this.WithinCompanyList[i].remarks
        _tradeindetail.isTemp = true

        this.CompanyList.push(_tradeindetail);
      }
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _tradeourdetail = new CustomerSiteTradeReference();
        _tradeourdetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _tradeourdetail.tradeReferenceId = 0
        _tradeourdetail.tradeReferenceTypeCode = "PQT00054";
        _tradeourdetail.tradeReferenceType = ""
        _tradeourdetail.personName = this.outsideCompanyList[i].personName
        _tradeourdetail.designation = this.outsideCompanyList[i].designation
        _tradeourdetail.emailId = this.outsideCompanyList[i].emailId
        _tradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo
        _tradeourdetail.experience = this.outsideCompanyList[i].experience
        _tradeourdetail.remarks = this.outsideCompanyList[i].remarks
        _tradeourdetail.isTemp = true
        this.CompanyList.push(_tradeourdetail);
      }
      // this.onEd()
      this._TradereferenceService.UpsertCustomerSiteTradeReference(this.CompanyList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          //this._CustomExceptionService.handleError(error); 
        });
    }
    if (this.TempWithinCompanyList.length > 0 && this.TempoutsideCompanyList.length > 0) {
      this.TempWithinCompanyList = []
      //this.TempWithinCompanyList = this.WithinCompanyList;
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _temptradeindetail = new CustomerSiteTradeReference();
        _temptradeindetail.customersitecode = this.WithinCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeindetail.tradeReferenceId = this.WithinCompanyList[i].tradeReferenceId || 0
        _temptradeindetail.tradeReferenceTypeCode = this.WithinCompanyList[i].tradeReferenceTypeCode || "PQT00053";
        _temptradeindetail.tradeReferenceType = this.WithinCompanyList[i].tradeReferenceType;
        _temptradeindetail.personName = this.WithinCompanyList[i].personName
        _temptradeindetail.designation = this.WithinCompanyList[i].designation
        _temptradeindetail.emailId = this.WithinCompanyList[i].emailId
        _temptradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo
        _temptradeindetail.experience = this.WithinCompanyList[i].experience
        _temptradeindetail.remarks = this.WithinCompanyList[i].remarks
        _temptradeindetail.isTemp = true


        this.TempWithinCompanyList.push(_temptradeindetail);
      }
      console.log(this.TempWithinCompanyList);
      // // this.TempoutsideCompanyList = []
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _temptradeourdetail = new CustomerSiteTradeReference();
        _temptradeourdetail.customersitecode = this.outsideCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeourdetail.tradeReferenceId = this.outsideCompanyList[i].tradeReferenceId || 0
        _temptradeourdetail.tradeReferenceTypeCode = this.outsideCompanyList[i].tradeReferenceTypeCode || "PQT00054"
        _temptradeourdetail.tradeReferenceType = this.outsideCompanyList[i].tradeReferenceType
        _temptradeourdetail.personName = this.outsideCompanyList[i].personName
        _temptradeourdetail.designation = this.outsideCompanyList[i].designation
        _temptradeourdetail.emailId = this.outsideCompanyList[i].emailId
        _temptradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo
        _temptradeourdetail.experience = this.outsideCompanyList[i].experience
        _temptradeourdetail.remarks = this.outsideCompanyList[i].remarks
        _temptradeourdetail.isTemp = true
        this.TempWithinCompanyList.push(_temptradeourdetail);
        console.log(this.TempWithinCompanyList);
      }
      // this.onEd()
      this._TradereferenceService.UpsertCustomerSiteTradeReference(this.TempWithinCompanyList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          //this._CustomExceptionService.handleError(error); 
        });
      console.log("edit", this.CompanyList);
    }

  }
  onSubmitTrade(LEVELAPPROVALSTATE) {
    console.log(this._CustomerSiteform.get("pickuplocationintime").value)
    console.log(this._CustomerSiteform.get("pickuplocationouttime").value)
    if (this._CustomerSiteform.value.pickuplocationintime.getTime() == this._CustomerSiteform.value.pickuplocationouttime.getTime()) {
      // this._CustomerSiteform.value.pickuplocationintime.getHours()
      this._CustomExceptionService.handleError("In time and Out time should not be same in Customer Information");
      this.selectedtabquote = 0;
      return;
    }
    if (this.validationStatusCode != "MSC00011") {
      this._CustomExceptionService.handleError("GST validation not completed");
      this.selectedtabquote = 0;
      return;
    }
    // || this._CustomerContactInvoiceform.invalid || this._CustomerContactOutgoingform.invalid
    if (this._CustomerSiteform.invalid || this._CustomerAddressPickupform.invalid || this._CustomerAddressBillingform.invalid || this._CustomerContactPickform.invalid
     
    ) {

      this._submitted = true
      this.selectedtabquote = 0;
      this._CustomExceptionService.handleError("please fill all details in customer information");
      return;
    }
    if (this._ServiceLocationAndOperation_Form.invalid && this.SpecialDeliveryList.length == 0 && this.TATDetails.length == 0) {
      this._SLsubmitted = true
      this.selectedtabquote = 1;
      this._CustomExceptionService.handleError("please fill all details in Location and operations");
      return;
    }
    if (this.SUKList.length == 0 && this.SUKVolumeDistrubutionList.length == 0) {
      this.selectedtabquote = 2;
      this._CustomExceptionService.handleError("please fill all details in SKU");
      return;
    }
    for (var i = 0; i < this.ExistingVendorList.length; i++) {
      if (this.ExistingVendorList[i].vendorName == "" || this.ExistingVendorList[i].vendorRates == "" || this.ExistingVendorList[i].vendorStrength == "" ||
        this.ExistingVendorList[i].vendorPainPoint == "") {
        this.selectedtabquote = 4;
        this._CustomExceptionService.handleWarning("Please enter all the details");
        return;
      }
    }

    for (var i = 0; i < this.WithinCompanyList.length; i++) {
      if (this.WithinCompanyList[i].personName == "" || this.WithinCompanyList[i].designation == "" || this.WithinCompanyList[i].emailId == "" ||
        this.WithinCompanyList[i].phoneNo == "" || this.WithinCompanyList[i].experience == null || this.WithinCompanyList[i].remarks == "") {
        this.selectedtabquote = 4;
        this._CustomExceptionService.handleWarning("Please enter all the details");
        return;
      } else
        if (this.outsideCompanyList[i].personName == "" || this.outsideCompanyList[i].designation == "" || this.outsideCompanyList[i].emailId == "" ||
          this.outsideCompanyList[i].phoneNo == "" || this.outsideCompanyList[i].experience == null || this.outsideCompanyList[i].remarks == "") {
          this.selectedtabquote = 4;
          this._CustomExceptionService.handleWarning("Please enter all the details");
          return;
        }

    }

    // if (this.ExistingVendorList.length == 0) {


    //   this._CustomExceptionService.handleError("please fill all details in Existing Vendor");
    //   return;
    // }
    // if (this.WithinCompanyList.length == 0 && this.outsideCompanyList.length == 0) {
    //   // this.selectedtabquote = 4;
    //   this._CustomExceptionService.handleError("please fill all details in Trade Reference");
    //   return;
    // }
    if (this.TempWithinCompanyList.length == 0 && this.TempoutsideCompanyList.length == 0) {
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _tradeindetail = new CustomerSiteTradeReference();
        _tradeindetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _tradeindetail.tradeReferenceId = 0
        _tradeindetail.tradeReferenceTypeCode = "PQT00053";
        _tradeindetail.tradeReferenceType = "";
        _tradeindetail.personName = this.WithinCompanyList[i].personName
        _tradeindetail.designation = this.WithinCompanyList[i].designation
        _tradeindetail.emailId = this.WithinCompanyList[i].emailId
        _tradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo
        _tradeindetail.experience = this.WithinCompanyList[i].experience
        _tradeindetail.remarks = this.WithinCompanyList[i].remarks
        _tradeindetail.isTemp = true

        this.CompanyList.push(_tradeindetail);
      }
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _tradeourdetail = new CustomerSiteTradeReference();
        _tradeourdetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _tradeourdetail.tradeReferenceId = 0
        _tradeourdetail.tradeReferenceTypeCode = "PQT00054";
        _tradeourdetail.tradeReferenceType = ""
        _tradeourdetail.personName = this.outsideCompanyList[i].personName
        _tradeourdetail.designation = this.outsideCompanyList[i].designation
        _tradeourdetail.emailId = this.outsideCompanyList[i].emailId
        _tradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo
        _tradeourdetail.experience = this.outsideCompanyList[i].experience
        _tradeourdetail.remarks = this.outsideCompanyList[i].remarks
        _tradeourdetail.isTemp = true
        this.CompanyList.push(_tradeourdetail);
      }
      // this.onEd()
      // var _TradeReferenceOBJ = {
      //   "lstCSTradeReference": this.CompanyList,
      //   "approval": "",
      // };
      this._approval.APPROVALID = this._approvalid;
      this._approval.WORKFLOWID = this._workflowid;
      this._approval.LEVELAPPROVALSTATE = LEVELAPPROVALSTATE;
      this._approval.Remarks = this._Comments;
      this._approval.lstCustomerSiteTradeReference = this.CompanyList;

      this._ApprovalService.Approval(this._approval).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));
        console.log("savetrade", resutJSON)

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
          this._buttonHide = true;
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          this._CustomExceptionService.handleError(error); 
        });
    }
    if (this.TempWithinCompanyList.length > 0 && this.TempoutsideCompanyList.length > 0) {
      this.TempWithinCompanyList = []
      //this.TempWithinCompanyList = this.WithinCompanyList;
      for (var i = 0; i < this.WithinCompanyList.length; i++) {
        var _temptradeindetail = new CustomerSiteTradeReference();
        _temptradeindetail.customersitecode = this.WithinCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeindetail.tradeReferenceId = this.WithinCompanyList[i].tradeReferenceId || 0
        _temptradeindetail.tradeReferenceTypeCode = this.WithinCompanyList[i].tradeReferenceTypeCode || "PQT00053";
        _temptradeindetail.tradeReferenceType = this.WithinCompanyList[i].tradeReferenceType;
        _temptradeindetail.personName = this.WithinCompanyList[i].personName
        _temptradeindetail.designation = this.WithinCompanyList[i].designation
        _temptradeindetail.emailId = this.WithinCompanyList[i].emailId
        _temptradeindetail.phoneNo = this.WithinCompanyList[i].phoneNo
        _temptradeindetail.experience = this.WithinCompanyList[i].experience
        _temptradeindetail.remarks = this.WithinCompanyList[i].remarks
        _temptradeindetail.isTemp = true


        this.TempWithinCompanyList.push(_temptradeindetail);
      }
      console.log(this.TempWithinCompanyList);
      // // this.TempoutsideCompanyList = []
      for (var i = 0; i < this.outsideCompanyList.length; i++) {
        var _temptradeourdetail = new CustomerSiteTradeReference();
        _temptradeourdetail.customersitecode = this.outsideCompanyList[i].customersitecode || this._CustomerSiteCode || this.CustomersiteCode;
        _temptradeourdetail.tradeReferenceId = this.outsideCompanyList[i].tradeReferenceId || 0
        _temptradeourdetail.tradeReferenceTypeCode = this.outsideCompanyList[i].tradeReferenceTypeCode || "PQT00054"
        _temptradeourdetail.tradeReferenceType = this.outsideCompanyList[i].tradeReferenceType
        _temptradeourdetail.personName = this.outsideCompanyList[i].personName
        _temptradeourdetail.designation = this.outsideCompanyList[i].designation
        _temptradeourdetail.emailId = this.outsideCompanyList[i].emailId
        _temptradeourdetail.phoneNo = this.outsideCompanyList[i].phoneNo
        _temptradeourdetail.experience = this.outsideCompanyList[i].experience
        _temptradeourdetail.remarks = this.outsideCompanyList[i].remarks
        _temptradeourdetail.isTemp = true
        this.TempWithinCompanyList.push(_temptradeourdetail);
        console.log(this.TempWithinCompanyList);
      }
      this._approval.APPROVALID = this._approvalid;
      this._approval.WORKFLOWID = this._workflowid;
      this._approval.LEVELAPPROVALSTATE = LEVELAPPROVALSTATE;
      this._approval.Remarks = this._Comments;
      this._approval.lstCustomerSiteTradeReference = this.TempWithinCompanyList;

      // var _TradeReferenceOBJ_ = {
      //   "lstCSTradeReference": this.TempWithinCompanyList,
      //   "approval": "",
      // };
      // this.onEd()
      this._ApprovalService.Approval(this._approval).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
          this._buttonHide = true;
        }
        else {
          this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          this._CustomExceptionService.handleError(error); 
        });
      console.log("edit", this.CompanyList);
    }


  }
  onsaveVendor() {
    // for(var i=0;i<this.ExistingVendorList.length;i++){


    // if (this.ExistingVendorList[i].vendorName == null && this.ExistingVendorList[i].vendorRates && this.ExistingVendorList[i].vendorStrength &&
    //   this.ExistingVendorList[i].vendorPainPoint) {
    //   this.selectedtabquote = 4;
    //   this._CustomExceptionService.handleWarning("Please enter all the details");
    //   return;
    // }
    // }
    this._ExistingVendordetails = [];
    if (this.TempExistingVendorList.length == 0) {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        var _vendordetail = new CustomerSiteVendor();
        _vendordetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _vendordetail.vendorId = 0;
        _vendordetail.vendorName = this.ExistingVendorList[i].vendorName
        _vendordetail.vendorRates = this.ExistingVendorList[i].vendorRates
        _vendordetail.vendorStrength = this.ExistingVendorList[i].vendorStrength
        _vendordetail.vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint
        _vendordetail.isTemp = true

        this._ExistingVendordetails.push(_vendordetail);
        this._ExistingvendorService.UpsertCustomerSiteVendor(this._ExistingVendordetails).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));

          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
          }
          else {
            //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }

        },
          error => { 
            //this._CustomExceptionService.handleError(error); 
          });
      }
    }
    if (this.TempExistingVendorList.length > 0) {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        // var _vendordetail = new CustomerSiteVendor();
        this.ExistingVendorList[i].customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        this.ExistingVendorList[i].vendorId = this.ExistingVendorList[i].vendorId;
        this.ExistingVendorList[i].vendorName = this.ExistingVendorList[i].vendorName
        this.ExistingVendorList[i].vendorRates = this.ExistingVendorList[i].vendorRates
        this.ExistingVendorList[i].vendorStrength = this.ExistingVendorList[i].vendorStrength
        this.ExistingVendorList[i].vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint
        this.ExistingVendorList[i].isTemp = true

        // this._ExistingVendordetails.push(this.ExistingVendorList);
      }
      // this.onEd()

      this._ExistingvendorService.UpsertCustomerSiteVendor(this.ExistingVendorList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);


        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          //this._CustomExceptionService.handleError(error); 
        });
    }
  }
  onSubmitVendor() {
    this._ExistingVendordetails = [];
    if (this.TempExistingVendorList.length == 0) {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        var _vendordetail = new CustomerSiteVendor();
        _vendordetail.customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        _vendordetail.vendorId = 0;
        _vendordetail.vendorName = this.ExistingVendorList[i].vendorName
        _vendordetail.vendorRates = this.ExistingVendorList[i].vendorRates
        _vendordetail.vendorStrength = this.ExistingVendorList[i].vendorStrength
        _vendordetail.vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint
        _vendordetail.isTemp = false

        this._ExistingVendordetails.push(_vendordetail);
        this._ExistingvendorService.UpsertCustomerSiteVendor(this._ExistingVendordetails).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));

          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);
          }
          else {
            //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }

        },
          error => { 
            //this._CustomExceptionService.handleError(error); 
          });
      }
    }
    if (this.TempExistingVendorList.length > 0) {
      for (var i = 0; i < this.ExistingVendorList.length; i++) {
        // var _vendordetail = new CustomerSiteVendor();
        this.ExistingVendorList[i].customersitecode = this._CustomerSiteCode || this.CustomersiteCode
        this.ExistingVendorList[i].vendorId = this.ExistingVendorList[i].vendorId;
        this.ExistingVendorList[i].vendorName = this.ExistingVendorList[i].vendorName
        this.ExistingVendorList[i].vendorRates = this.ExistingVendorList[i].vendorRates
        this.ExistingVendorList[i].vendorStrength = this.ExistingVendorList[i].vendorStrength
        this.ExistingVendorList[i].vendorPainPoint = this.ExistingVendorList[i].vendorPainPoint
        this.ExistingVendorList[i].isTemp = false

        // this._ExistingVendordetails.push(this.ExistingVendorList);
      }
      // this.onEd()

      this._ExistingvendorService.UpsertCustomerSiteVendor(this.ExistingVendorList).subscribe((result) => {
        const resutJSON = JSON.parse(JSON.stringify(result));

        if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
          //this._CustomExceptionService.handleSuccess(usererrors.Saved_Success_00);


        }
        else {
          //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
        }

      },
        error => { 
          //this._CustomExceptionService.handleError(error); 
        });
    }
  }
  ///////////////---------Add new row in vendor grid-------/////////////////
  AddNewSlab() {
    if (this.ExistingVendorList.length < 2) {
      var l_Vendordetail = new CustomerSiteVendor();
      l_Vendordetail.vendorId = 0;
      l_Vendordetail.vendorName = ""
      l_Vendordetail.vendorRates = ""
      l_Vendordetail.vendorStrength = ""
      l_Vendordetail.vendorPainPoint = ""
      this.ExistingVendorList.push(l_Vendordetail);
    }
  }
  RemoveNewSlab(pSlabdetail: CustomerSiteVendor) {
    // var index = this.ExistingVendorList.indexOf(pSlabdetail);
    //   this.ExistingVendorList.splice(index, 1);
    //   this.AddNewSlab();
    if (this.ExistingVendorList.length > 1) {
      var index = this.ExistingVendorList.indexOf(pSlabdetail);
      this.ExistingVendorList.splice(index, 1)
    }
    else {
      var index = this.ExistingVendorList.indexOf(pSlabdetail);
      this.ExistingVendorList.splice(index, 1);
      this.AddNewSlab();
    }
  }
  ////////////--------- Trade Reference--------------///////////////////
  AddWithinSlab() {
    var l_withinlist = new CustomerSiteTradeReference();
    l_withinlist.tradeReferenceId = 0;
    l_withinlist.tradeReferenceTypeCode = "";
    l_withinlist.tradeReferenceType = "";
    l_withinlist.personName = "";
    l_withinlist.designation = "";
    l_withinlist.emailId = "";
    l_withinlist.phoneNo = "";
    l_withinlist.remarks = "";
    this.WithinCompanyList.push(l_withinlist);
  }
  RemoveWithinSlab(pSlabdetail: CustomerSiteTradeReference) {
    if (this.WithinCompanyList.length > 1) {
      var index = this.WithinCompanyList.indexOf(pSlabdetail);
      this.WithinCompanyList.splice(index, 1)
    }
    else {
      var index = this.WithinCompanyList.indexOf(pSlabdetail);
      this.WithinCompanyList.splice(index, 1);
      this.AddWithinSlab();
    }
  }
  AddWithOutSlab() {
    var l_withoutlist = new CustomerSiteTradeReference();
    l_withoutlist.tradeReferenceId = 0;
    l_withoutlist.tradeReferenceTypeCode = "";
    l_withoutlist.tradeReferenceType = "";
    l_withoutlist.personName = "";
    l_withoutlist.designation = "";
    l_withoutlist.emailId = "";
    l_withoutlist.phoneNo = "";
    l_withoutlist.remarks = "";
    this.outsideCompanyList.push(l_withoutlist);
  }
  RemoveWithOutSlab(pSlabdetail: CustomerSiteTradeReference) {
    if (this.outsideCompanyList.length > 1) {
      var index = this.outsideCompanyList.indexOf(pSlabdetail);
      this.outsideCompanyList.splice(index, 1)
    }
    else {
      var index = this.outsideCompanyList.indexOf(pSlabdetail);
      this.outsideCompanyList.splice(index, 1);
      this.AddWithOutSlab();
    }
  }
  /////////////////---------------SERVICE LOCATION & SKU-----------///////////////////
  selectFile(event): void {
    this.selectedFiles = event.target.files;
  }
  exportExcel() {
    let SalesInvoicePOSList = this.GetVolumeDistributionList();
    this.exportUtility.exportExcel(SalesInvoicePOSList, 'Special Delivery', 'xlsx');
  }

  exportExcelTAT() {
    let SalesInvoicePOSList = this.GetexportExcelTATList();
    this.exportUtility.exportExcel(SalesInvoicePOSList, 'TAT Detials', 'xlsx');
  }

  GetexportExcelTATList() {
    let TATList = [];
    this.TATDetails = [] = [];
    if (this.TATDetails.length == 0) {
      let TATDetails: any = {};
      TATDetails["Basedon"] = "";
      TATDetails["Fromlocation"] = "";
      TATDetails["Tolocation"] = "";
      TATDetails["Tatindays"] = "";
      TATList.push(TATDetails);
    }
    this.TATDetails.forEach(element => {
      let _TATDetails: any = {};
      _TATDetails["Basedon"] = element.Basedon;
      _TATDetails["Fromlocation"] = element.Fromlocation;
      _TATDetails["Tolocation"] = element.Tolocation;
      _TATDetails["Tatindays"] = element.Tatindays;
      TATList.push(_TATDetails);
    });
    return TATList;
  }
  GetVolumeDistributionList() {
    let SalesInvoicePOSList = [];
    this.SpecialDeliveryList = [] = [];
    if (this.SpecialDeliveryList.length == 0) {
      let SpecialDeliveryList: any = {};
      SpecialDeliveryList["SpecialDeliverytypecode"] = "";
      SpecialDeliveryList["ContactPerson"] = "";
      SpecialDeliveryList["MobileNo"] = "";
      SpecialDeliveryList["EmailID"] = "";
      SpecialDeliveryList["Address"] = "";
      SpecialDeliveryList["Floor"] = "";
      SpecialDeliveryList["PinCode"] = "";
      SpecialDeliveryList["PincodeLocation"] = "";
      SalesInvoicePOSList.push(SpecialDeliveryList);
    }
    this.SpecialDeliveryList.forEach(element => {
      let SpecialDeliveryList: any = {};
      SpecialDeliveryList["SpecialDeliverytype"] = element.SpecialDeliverytype;
      SpecialDeliveryList["ContactPerson"] = element.ContactPerson;
      SpecialDeliveryList["MobileNo"] = element.MobileNo;
      SpecialDeliveryList["EmailID"] = element.EmailID;
      SpecialDeliveryList["Address"] = element.Address;
      SpecialDeliveryList["Floor"] = element.Floortype;
      SpecialDeliveryList["PinCode"] = element.PinCode;
      SpecialDeliveryList["PincodeLocation"] = element.PincodeLocation;
      SalesInvoicePOSList.push(SpecialDeliveryList);
    });
    return SalesInvoicePOSList;
  }
  upload() {
    this.currentFile = this.selectedFiles.item(0);;
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.currentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this.VolumeReferList = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      //this.selectedFiles  = [];    
      console.log(arraylist)
      this.SpecialDeliveryList = this.VolumeReferList
      for (var i = 0; i < this.VolumeReferList.length; i++) {
        this.SpecialDeliveryList[i].SpecialDeliverytypecode = this.VolumeReferList[i].SpecialDeliverytypecode
        this.SpecialDeliveryList[i].SpecialDeliverytype = this.VolumeReferList[i].SpecialDeliverytype
        this.SpecialDeliveryList[i].ContactPerson = this.VolumeReferList[i].ContactPerson
        this.SpecialDeliveryList[i].MobileNo = this.VolumeReferList[i].MobileNo
        this.SpecialDeliveryList[i].EmailID = this.VolumeReferList[i].EmailID
        this.SpecialDeliveryList[i].Address = this.VolumeReferList[i].Address
        this.SpecialDeliveryList[i].Floortype = this.VolumeReferList[i].Floortype
        this.SpecialDeliveryList[i].Floortypecode = this.VolumeReferList[i].Floortypecode
        this.SpecialDeliveryList[i].PinCode = this.VolumeReferList[i].PinCode
        this.SpecialDeliveryList[i].PincodeLocation = this.VolumeReferList[i].PincodeLocation
      }
    }
  }
  RemoveVariant(RowIndex) {
    //alert(RowIndex);
    if (this.SpecialDeliveryList.length > 1) {
      var index = this.SpecialDeliveryList.indexOf(RowIndex);
      this.SpecialDeliveryList.splice(index, 1)
    }
    else {
      var index = this.SpecialDeliveryList.indexOf(RowIndex);
      this.SpecialDeliveryList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }

  RemoveTAT(RowIndex) {
    //alert(RowIndex);
    if (this.TATDetails.length > 1) {
      var index = this.TATDetails.indexOf(RowIndex);
      this.TATDetails.splice(index, 1)
    }
    else {
      var index = this.TATDetails.indexOf(RowIndex);
      this.TATDetails.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }

  AddSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = true;
    /*if (this.addressRowIndex > -1) {
      this._ServiceLocationAndOperation_SpecialDelivery_Form[this.addressRowIndex] = this._ServiceLocationAndOperation_SpecialDelivery_Form.value;
      }
      else*/
    /*alert(this.SpecialDeliveryList.length);
    if(this.SpecialDeliveryList.length > 0){
  var SpecialDeliveryListTemp_:any={};
  //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
  SpecialDeliveryListTemp_.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value.metasubcode,
  SpecialDeliveryListTemp_.ContactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
  SpecialDeliveryListTemp_.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
  SpecialDeliveryListTemp_.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
  SpecialDeliveryListTemp_.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
  SpecialDeliveryListTemp_.PinCode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,
  //SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value,

  SpecialDeliveryListTemp_.Floor = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value.metasubcode,
  SpecialDeliveryListTemp_.PincodeLocation ="123";
  //SpecialDeliveryListTemp.SpecialDelivery = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value;
  this.SpecialDeliveryList.push(SpecialDeliveryListTemp_);
  /*this.SpecialDeliveryList.SpecialDelivery= this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDelivery").value
  this.SpecialDeliveryList.ContactPerson= this.VolumeReferList[i].ContactPerson
  this.SpecialDeliveryList.MobileNo= this.VolumeReferList[i].MobileNo
  this.SpecialDeliveryList.EmailID= this.VolumeReferList[i].EmailID
  this.SpecialDeliveryList[i].Address= this.VolumeReferList[i].Address
  this.SpecialDeliveryList[i].Floor= this.VolumeReferList[i].Floor
  this.SpecialDeliveryList[i].PinCode= this.VolumeReferList[i].PinCode
  this.SpecialDeliveryList[i].PincodeLocation= this.VolumeReferList[i].PincodeLocation
    }
    else{*/
    if (this._ServiceLocationAndOperation_SpecialDelivery_Form.valid) {


      var SpecialDeliveryListTemp: any = {};

      /* PincodeLocation: any,
       Floor: any,
       PinCode: any,
       Address: any,
       EmailID: any,
       MobileNo: any,
       ContactPerson: any,
       SpecialDelivery: any;*/
      //this.SpecialDeliveryList(this._ServiceLocationAndOperation_SpecialDelivery_Form);
      var Taluk = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value
      var TalukName = (this._TempSLPincodeLocation.filter(f => f.pincode == Taluk)[0].taluk);
      var deliverytype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      var DeliverTypeName = (this._SpecialDelivery || []).filter(f => f.metasubcode == deliverytype)[0].metasubdescription;
      var Floortype = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value
      var FloortypeName = (this._SLFloorType || []).filter(f => f.metasubcode == Floortype)[0].metasubdescription;


      SpecialDeliveryListTemp.SpecialDeliverytypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("SpecialDeliverytypecode").value;
      SpecialDeliveryListTemp.SpecialDeliverytype = DeliverTypeName
      SpecialDeliveryListTemp.contactPerson = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("ContactPerson").value,
        SpecialDeliveryListTemp.MobileNo = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("MobileNo").value,
        SpecialDeliveryListTemp.EmailID = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("EmailID").value,
        SpecialDeliveryListTemp.Address = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Address").value,
        SpecialDeliveryListTemp.pincode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PinCode").value,


        SpecialDeliveryListTemp.Taluk = TalukName,
        SpecialDeliveryListTemp.Floortypecode = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("Floor").value,
        SpecialDeliveryListTemp.Floortype = FloortypeName;
      //SpecialDeliveryListTemp.PincodeLocation ="123";
      SpecialDeliveryListTemp.PincodeLocation = this._ServiceLocationAndOperation_SpecialDelivery_Form.get("PincodeLocation").value;
      this.SpecialDeliveryList.push(SpecialDeliveryListTemp);
      this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
      this._SLSpecialDeliverysubmitted = false;
      // }
    }
  }
  AddTAT() {
    this._SLTATsubmitted = true;
    if (this._ServiceLocationAndOperation_TATDetails_Form.valid) {
      if (this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value != this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value) {

        var TATListTemp: any = {};
        var BasedOn = this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").value;
        var BasedOnName = (this._TatBased || []).filter(f => f.metasubcode == BasedOn)[0].metasubdescription;

        var FromLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        var FromLocName = (this._Location || []).filter(f => f.branchcode == FromLoc)[0].branchname;

        var ToLoc = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        var ToLocName = (this._Location || []).filter(f => f.branchcode == ToLoc)[0].branchname;

        TATListTemp.Basedoncode = this._ServiceLocationAndOperation_TATDetails_Form.get("Basedoncode").value;
        TATListTemp.Basedon = BasedOnName
        TATListTemp.Fromlocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Fromlocationcode").value;
        TATListTemp.Fromlocation = FromLocName
        TATListTemp.Tolocationcode = this._ServiceLocationAndOperation_TATDetails_Form.get("Tolocationcode").value;
        TATListTemp.Tolocation = ToLocName
        TATListTemp.Tatindays = this._ServiceLocationAndOperation_TATDetails_Form.get("Tatindays").value;
        this.TATDetails.push(TATListTemp);
        this._ServiceLocationAndOperation_TATDetails_Form.reset();
        this._SLTATsubmitted = false
      }
      else {
        this._CustomExceptionService.handleError("Please change Fromlocation or Tolocation. These are same.");
      }
    }
  }
  TATselectFile(event): void {
    this.TATselectedFiles = event.target.files;
  }
  TATupload() {
    this.TATcurrentFile = this.TATselectedFiles.item(0);
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.TATcurrentFile);
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
      var arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      this._TATListTemp = XLSX.utils.sheet_to_json(worksheet, { raw: true })
      //this.selectedFiles  = [];    
      console.log(arraylist)
      this.TATDetails = this._TATListTemp
      for (var i = 0; i < this._TATListTemp.length; i++) {
        this.TATDetails[i].Basedoncode = this._TATListTemp[i].Basedoncode
        this.TATDetails[i].Basedon = this._TATListTemp[i].Basedon
        this.TATDetails[i].Fromlocationcode = this._TATListTemp[i].Fromlocationcode
        this.TATDetails[i].Fromlocation = this._TATListTemp[i].Fromlocation
        this.TATDetails[i].Tolocationcode = this._TATListTemp[i].Tolocationcode
        this.TATDetails[i].Tolocation = this._TATListTemp[i].Tolocation
        //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
        this.TATDetails[i].Tatindays = this._TATListTemp[i].Tatindays
      }
    }
  }

  GetServiceLocations(event) {

    var ServiceLocationsCode = "";
    var ServiceLocationsName = "";
    var selectedServiceLocations = event.value
    for (var i = 0; i < selectedServiceLocations.length; i++) {
      if (ServiceLocationsCode == "") {
        ServiceLocationsCode = selectedServiceLocations
        // ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        ServiceLocationsCode = ServiceLocationsCode + "," + selectedServiceLocations
        // ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempServiceLocationsCode = ServiceLocationsCode
    this._TempServiceLocations = ServiceLocationsName
    //  console.log("refv",selectedcredittype.metasubcode);

  }
  GetTier(event) {
    var TierCode = "";
    var TierName = "";
    //var ServiceLocationsName = "";
    var selectedTier = event.value
    for (var i = 0; i < selectedTier.length; i++) {
      if (TierCode == "") {
        TierCode = selectedTier;
        // TierName = selectedTier[i].metasubdescription;
        //ServiceLocationsName = selectedServiceLocations[i].statename;
      }
      else {
        TierCode = TierCode + "," + selectedTier
        // TierName = TierName + "," + selectedTier[i].metasubdescription;
        //ServiceLocationsName = ServiceLocationsName + "," + selectedServiceLocations[i].statename;
      }

    }
    this._TempTierCode = TierCode
    this._TempTierName = TierCode
  }
  ClearSpecialDelivery() {
    this._SLSpecialDeliverysubmitted = false;
    this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
  }
  ClearTAT() {
    this._SLTATsubmitted = false;
    this._ServiceLocationAndOperation_TATDetails_Form.reset();
  }
  ServiceLocationAndOprerationLoad() {
    this._ServiceLocationAndOperationService.ServiceLocationAndOperationServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        alert(resultJSON.lstFloorType);
        this._ServiceLocation = resultJSON.lstServiceLocation;
        this._Tier = resultJSON.lstTier;
        this._Requirments = resultJSON.lstPODRequirement;
        this._SpecialDelivery = resultJSON.lstSpecialDeliveryType;
        this._SLFloorType = resultJSON.lstFloorType;
        this._TempSLPincodeLocation = resultJSON.lstPincodeLocation;
        this._TatBased = resultJSON.lstTATBasedOn;
        this._Location = resultJSON.lstTATLocation;
        this._ODALocations = resultJSON.lstYesNo;
        var temp = "true"
        var CustCode = this._CustomerSiteCode || this.CustomersiteCode
        this._ServiceLocationAndOperationService.GetById(CustCode).subscribe((result: any) => {
          const resultJSON = result;//JSON.parse(JSON.stringify(result));
          console.log("getid", result);
          if (resultJSON.tranStatus.result == true) {
            //alert(resultJSON);

            this.ExistCustomerSL = resultJSON.customerSiteOperationDetail;
            if (resultJSON.customerSiteOperationDetail == null) {

            } else {
              var splitServiceLocation = resultJSON.customerSiteOperationDetail.servicelocations.split(',');              
              const servicelocations = [];
              for (i = 0; i < splitServiceLocation.length; i++) {
                servicelocations.push(splitServiceLocation[i]);
              }
              var servicelocationsCode: string[] = [];
              Object.keys(servicelocations).map((Index) => {
                servicelocationsCode.push(servicelocations[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._selectedServiceLocation = servicelocationsCode;
              var splittier = resultJSON.customerSiteOperationDetail.tiercode.split(',');
              const tier = [];
              for (i = 0; i < splittier.length; i++) {
                tier.push(splittier[i]);
              }
              var tierCode: string[] = [];
              Object.keys(tier).map((Index) => {
                tierCode.push(tier[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._selectedtier = tierCode;
              this._TempServiceLocationsCode = resultJSON.customerSiteOperationDetail.servicelocations;
              this._TempTierCode = resultJSON.customerSiteOperationDetail.tiercode;

              //this._ServiceLocationAndOperation_Form.get("tiercode").setValue(this._Tier.find(f => f.metasubcode === resultJSON.customerSiteOperationDetail.tiercode));
              this._ServiceLocationAndOperation_Form.get("podrequirementcode").setValue(resultJSON.customerSiteOperationDetail.podrequirementcode);
              this._ServiceLocationAndOperation_Form.controls['bookingcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.bookingcutofftime));
              this._ServiceLocationAndOperation_Form.controls['vehicledeparturecutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.vehicledeparturecutofftime));
              this._ServiceLocationAndOperation_Form.controls['pickupcutofftime'].setValue(new Date(resultJSON.customerSiteOperationDetail.pickupcutofftime));
              this._ServiceLocationAndOperation_Form.controls['odalocation'].setValue(resultJSON.customerSiteOperationDetail.odalocationcode);
              this._ServiceLocationAndOperation_Form.controls['customerlrcopy'].setValue(resultJSON.customerSiteOperationDetail.customerlrcopycode);
              this._ServiceLocationAndOperation_Form.controls['invoiceacknowledgement'].setValue(resultJSON.customerSiteOperationDetail.invoiceacknowledgementcode);
              this._ServiceLocationAndOperation_Form.controls['returnbooking'].setValue(resultJSON.customerSiteOperationDetail.returnbookingcode);
              this.SpecialDeliveryList = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery.length; i++) {
                this.SpecialDeliveryList[i].SpecialDeliverytypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytypecode
                this.SpecialDeliveryList[i].SpecialDeliverytype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].specialDeliverytype
                this.SpecialDeliveryList[i].contactPerson = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].contactPerson
                this.SpecialDeliveryList[i].MobileNo = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].mobileNo
                this.SpecialDeliveryList[i].EmailID = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].emailID
                this.SpecialDeliveryList[i].Address = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].address
                this.SpecialDeliveryList[i].pincode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincode
                this.SpecialDeliveryList[i].PincodeLocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].pincodeLocation
                this.SpecialDeliveryList[i].Floortypecode = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortypecode
                this.SpecialDeliveryList[i].Floortype = resultJSON.customerSiteOperationDetail.lstCustomerSiteSpecialDelivery[i].floortype
              }
              this.TATDetails = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT;
              for (var i = 0; i < resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT.length; i++) {
                this.TATDetails[i].Basedoncode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedoncode
                this.TATDetails[i].Basedon = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].basedon
                this.TATDetails[i].Fromlocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocationcode
                this.TATDetails[i].Fromlocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].fromlocation
                this.TATDetails[i].Tolocationcode = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocationcode
                this.TATDetails[i].Tolocation = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tolocation
                //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
                this.TATDetails[i].Tatindays = resultJSON.customerSiteOperationDetail.lstCustomerSiteTAT[i].tatindays
              }
            }
          }

          else {
            this.ExistCustomerSL = null;
          }
        }, error => {
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._CustomExceptionService.handleError(error);
    });
  }
  SKULoad() {
    this._CustomerSUKService.SUKServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        var temp = "true"
        this._Uom = resultJSON.lstSKUUom;
        this._Hub = resultJSON.lstHub;
        var CustCode = this._CustomerSiteCode || this.CustomersiteCode
        this._CustomerSUKService.GetById(CustCode).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          console.log(resultJSON);
          if (resultJSON.tranStatus.result == true) {

            this.ExistCustomerSUK = resultJSON.lstCustomerSiteSKU;

            this.SUKList = resultJSON.lstCustomerSiteSKU;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKU.length; i++) {
              this.SUKList[i].SkuType = resultJSON.lstCustomerSiteSKU[i].skuType
              this.SUKList[i].SkuUom = resultJSON.lstCustomerSiteSKU[i].skuUom
              this.SUKList[i].SkuUomCode = resultJSON.lstCustomerSiteSKU[i].skuUomCode
              this.SUKList[i].SkuLength = resultJSON.lstCustomerSiteSKU[i].skuLength
              this.SUKList[i].SkuBreadth = resultJSON.lstCustomerSiteSKU[i].skuBreadth
              this.SUKList[i].SkuHeight = resultJSON.lstCustomerSiteSKU[i].skuHeight
              this.SUKList[i].CftBasedOn = resultJSON.lstCustomerSiteSKU[i].cftBasedOn
              this.SUKList[i].CftWeight = resultJSON.lstCustomerSiteSKU[i].cftWeight
              this.SUKList[i].ContributionPercentage = resultJSON.lstCustomerSiteSKU[i].contributionPercentage
              this.SUKList[i].SkuPhotoURL_ = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL
              //var splitURL = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.split('CustomerSiteSKU_SKULocation');              
              //var URLName =splitURL[1]; 
              var filename = resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.substring(resultJSON.lstCustomerSiteSKU[i].skuPhotoURL.lastIndexOf('/') + 1);
              this.SUKList[i].SkuPhotoURLName = filename;
              this.SUKList[i].SkuPhotoFORMFILE = null
              this.SUKList[i].Customersitecode = resultJSON.lstCustomerSiteSKU[i].customersitecode;
              //this.SUKList[i].Floortype= resultJSON.lstCustomerSiteSpecialDelivery[i].floortype
            }
            this.SUKVolumeDistrubutionList = resultJSON.lstCustomerSiteSKUVolumeDistribution;
            for (var i = 0; i < resultJSON.lstCustomerSiteSKUVolumeDistribution.length; i++) {
              this.SUKVolumeDistrubutionList[i].Hub = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hub
              this.SUKVolumeDistrubutionList[i].HubCode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].hubCode
              this.SUKVolumeDistrubutionList[i].VolumeDistributionPercentage = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].volumeDistributionPercentage
              this.SUKVolumeDistrubutionList[i].Customersitecode = resultJSON.lstCustomerSiteSKUVolumeDistribution[i].customersitecode;
              /*this.SUKVolumeDistrubutionList[i].Fromlocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocationcode
              this.SUKVolumeDistrubutionList[i].Fromlocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].fromlocation
              this.SUKVolumeDistrubutionList[i].Tolocationcode= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocationcode
              this.SUKVolumeDistrubutionList[i].Tolocation= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tolocation*/
              //this.TATDetails[i].PinCode= this._TATListTemp[i].PinCode
              //this.SUKVolumeDistrubutionList[i].Tatindays= resultJSON.lstCustomerSiteSKUVolumeDistribution[i].tatindays
            }


          }
          else {
            this.ExistCustomerSUK = null;
          }
        }, error => {
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._CustomExceptionService.handleError(error);
    });
  }
  onDocumentSelect(event) {
    this.currentFileInSKU = event.currentFiles[0];
    //document.clear();
  }
  onDocumentClear() {
    this.documentimage = null;
    this.currentFileInSKU = null;
  }
  AddSUK() {
    this._SUKsubmitted = true;
    this.tempQuantity = parseFloat(this.QuantityPer) + parseFloat(this._SUK_Form.get("ContributionPercentage").value)
    if (parseFloat(this.tempQuantity) < 100) {
      // this.QuantityPer = this._SUK_Form.get("ContributionPercentage").value;


      if (this._SUK_Form.valid && this.currentFileInSKU == undefined) {
        this._CustomExceptionService.handleWarning("please select image");
        return
      }
      else {



        // var sum = quantityper 
        // if (this._SUK_Form.get("ContributionPercentage").value == 100) {

        var _attachmentname = ""
        if (this.SUKList.length > 0) {
          this.SUKList.every((item) => {
            for (var i = 0; i < this.SUKList.length; i++) {
              _attachmentname = this.SUKList[i].SkuPhotoURL;
              if (_attachmentname == this.SUKList[i].SkuPhotoURL) {
                this._CustomExceptionService.handleWarning("Document Already Uploaded!");
                return
              }
            }
          });
        }


        //documentdetail.attachmenturl = URL.createObjectURL(this._LastAddedDocument);
        this.documentimage = this._DomSanitizationService.bypassSecurityTrustUrl(URL.createObjectURL(this.currentFileInSKU));
        //documentdetail.attachmentname = this._LastAddedDocument.name;
        /*this.currentFileInSKU= this.selectedFilesInSKU.item(0);     
        //let fileToUpload = this.currentFileInSKU;
        const formData = new FormData();
        //formData.append('file', fileToUpload, fileToUpload.name);
        formData.append('file', this.currentFileInSKU, this.currentFileInSKU.name);*/
        var SUKListTemp: any = {};
        SUKListTemp.SkuType = this._SUK_Form.get("SkuType").value;
        SUKListTemp.SkuUomCode = this._SUK_Form.get("SkuUom").value;
        var UOM = this._SUK_Form.get("SkuUom").value;
        var UOMName = (this._Uom || []).filter(f => f.metasubcode == UOM)[0].metasubdescription;
        SUKListTemp.SkuUom = UOMName
        SUKListTemp.SkuLength = this._SUK_Form.get("SkuLength").value;
        SUKListTemp.SkuBreadth = this._SUK_Form.get("SkuBreadth").value;
        SUKListTemp.SkuHeight = this._SUK_Form.get("SkuHeight").value;
        SUKListTemp.CftBasedOn = this._SUK_Form.get("CftBasedOn").value;
        SUKListTemp.CftWeight = this._SUK_Form.get("CftWeight").value;
        SUKListTemp.ContributionPercentage = this._SUK_Form.get("ContributionPercentage").value;
        //SUKListTemp.SkuPhotoFORMFILE = formData;
        //SUKListTemp.SkuPhotoURL = null;
        SUKListTemp.SkuPhotoURL_ = URL.createObjectURL(this.currentFileInSKU);
        SUKListTemp.SkuPhotoURL = this.currentFileInSKU.name;
        SUKListTemp.SkuPhotoURLName = URL.createObjectURL(this.currentFileInSKU);

        SUKListTemp.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SUKListTemp.skuId = 0
        this.SUKList.push(SUKListTemp);
        var Tempquantity = this.QuantityPer
        var Quantity = parseFloat(this.QuantityPer) + parseFloat(SUKListTemp.ContributionPercentage);

        this.QuantityPer = Quantity;
        this._selectedDocuments.push(this.currentFileInSKU);
        this._SUK_Form.reset();
        this._SUKsubmitted = false;
        this.ClearSUK();
        // }
        // else {
        //   this._CustomExceptionService.handleError("Contribution Percentage is not 100%");
      }
    } else {
      this._CustomExceptionService.handleWarning("your contribution % should be not greater than 100");
    }
  }
  RemoveSUK(RowIndex) {
    //alert(RowIndex);
    if (this.SUKList.length > 1) {
      var index = this.SUKList.indexOf(RowIndex);
      this.SUKList.splice(index, 1)
    }
    else {
      var index = this.SUKList.indexOf(RowIndex);
      this.SUKList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }
  ClearSUK() {
    this._SUKsubmitted = false;
    this._ServiceLocationAndOperation_SpecialDelivery_Form.reset();
  }
  AddSUKVolumeDistrubution() {
    this._SUKVolumeDistrubutionsubmitted = true;
    this.tempQuantitypercentage = parseFloat(this.volumeQuantity) + parseFloat(this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value)
    if (parseFloat(this.tempQuantitypercentage) < 100) {
      if (this._SUK_VolumeDistrubution_Form.valid) {
        // if (this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value == 100) {
        var SUKVolumeDistrubutionListTemp: any = {};
        SUKVolumeDistrubutionListTemp.HubCode = this._SUK_VolumeDistrubution_Form.get("Hub").value;
        var HUB = this._SUK_VolumeDistrubution_Form.get("Hub").value;
        var HubName = (this._Hub || []).filter(f => f.branchcode == HUB)[0].branchname;
        SUKVolumeDistrubutionListTemp.Hub = HubName;
        SUKVolumeDistrubutionListTemp.VolumeDistributionPercentage = this._SUK_VolumeDistrubution_Form.get("VolumeDistributionPercentage").value;
        SUKVolumeDistrubutionListTemp.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        SUKVolumeDistrubutionListTemp.createdby = "1";
        var volQuantity = parseFloat(this.volumeQuantity) + parseFloat(SUKVolumeDistrubutionListTemp.VolumeDistributionPercentage);

        this.volumeQuantity = volQuantity;
        this.SUKVolumeDistrubutionList.push(SUKVolumeDistrubutionListTemp);
        this._SUK_VolumeDistrubution_Form.reset();
        this._SUKVolumeDistrubutionsubmitted = false
      }
    }
    else {
      this._CustomExceptionService.handleWarning("your percentage of quantity should be not greater than 100");
    }
  }
  ClearSUKVolumeDistrubution() {
    this._SUKVolumeDistrubutionsubmitted = false;
    this._ServiceLocationAndOperation_TATDetails_Form.reset();
  }
  RemoveSUKVolumeDistrubution(RowIndex) {
    //alert(RowIndex);
    if (this.SUKVolumeDistrubutionList.length > 1) {
      var index = this.SUKVolumeDistrubutionList.indexOf(RowIndex);
      this.SUKVolumeDistrubutionList.splice(index, 1)
    }
    else {
      var index = this.SUKVolumeDistrubutionList.indexOf(RowIndex);
      this.SUKVolumeDistrubutionList.splice(index, 1);
      //this.AddNewSlab('');
      //this.MinimumRange = false;
    }
  }
  SKUformconverstion(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:
    for (var x in documents) {

      //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
      //console.log("Index", index);
      //if (index != -1) {
      var NewFileName = documents[x].name;
      // p_documentdetails[index].attachmentname = NewFileName;
      // p_documentdetails[index].attachmenturl = NewFileName;
      formData.append('files', documents[x], NewFileName);
      //}
    }
    var _SULOBJ = {
      "lstCustomerSiteSKU": this.SUKList,
      "lstCustomerSiteSKUVolumeDistribution": this.SUKVolumeDistrubutionList,
    };
    var _SUKFD = JSON.stringify(_SULOBJ);
    formData.append('strSKU', _SUKFD);
    return (formData);
  }
  CFTCal() {
    if (this._SUK_Form.get("SkuLength").value != "" && this._SUK_Form.get("SkuBreadth").value != "" && this._SUK_Form.get("SkuHeight").value != "" && this._SUK_Form.get("SkuUom").value != "") {
      var cal = 0
      var l = parseFloat(this._SUK_Form.get("SkuLength").value);
      var b = parseFloat(this._SUK_Form.get("SkuBreadth").value);
      var h = parseFloat(this._SUK_Form.get("SkuHeight").value);
      var bo = parseFloat(this._SUK_Form.get("CftBasedOn").value);
      if (this._SUK_Form.get("SkuUom").value == "PQT00052") {
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 1728;
      }
      else if (this._SUK_Form.get("SkuUom").value == "PQT00050") {
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 28316.846592;
      }
      else {
        //PQT00051
        //cal = ((parseFloat(this._SUK_Form.get("SkuLength").value)/100) * (parseFloat(this._SUK_Form.get("SkuBreadth").value)/100) * (parseFloat(this._SUK_Form.get("SkuHeight").value)/100) * parseFloat(this._SUK_Form.get("CftBasedOn").value.name)) / 28316.846592;
        cal = (parseFloat(this._SUK_Form.get("SkuLength").value) * parseFloat(this._SUK_Form.get("SkuBreadth").value) * parseFloat(this._SUK_Form.get("SkuHeight").value) * parseFloat(this._SUK_Form.get("CftBasedOn").value)) / 28316846.592;
      }

      /*this._SUK_Form.get("SkuLength").value;
      this._SUK_Form.get("SkuBreadth").value;
      this._SUK_Form.get("SkuHeight").value;
      this._SUK_Form.get("CftBasedOn").value.name;
      this._SUK_Form.get("SkuUom").value.metasubdescription*/
      this._SUK_Form.controls['CftWeight'].setValue(cal.toFixed(2));
    }
    else {
      this._CustomExceptionService.handleError("");
    }
  }
  OpenImage(model) {
    window.open(model.SkuPhotoURL_, "_blank");
  }
  /////////////////////---------------Cost and Contract --------------////////////////////////////

  CustomerSiteCostAndContractLoad() {
    this._CustomerSiteCostAndContractService.CustomerSiteCostAndContractServiceInit().subscribe((result) => {
      const resultJSON = JSON.parse(JSON.stringify(result));
      console.log(resultJSON);
      if (resultJSON.tranStatus.result == true) {
        this._BillingBranch = resultJSON.lstBranch;
        this._FlatOdaList = resultJSON.lstFlatODABasedOn;
        this._ContractType = resultJSON.lstContractType;
        this._InclusiveExclusive = resultJSON.lstODAInclusiveOrExclusive;
        this._State = resultJSON.lstRegion;
        this._ODAChargesAgree = resultJSON.lstYesNo;
        this._ODACalculationMode = resultJSON.lstODACalculationMode;
        this._ToBranch = resultJSON.lstBranch;
        this._ArticleName = resultJSON.lstArticle;
        this._RateType = resultJSON.lstRateType;
        this._DCRateType = resultJSON.lstDCRateType;
        this._DDRateType = resultJSON.lstDDRateType;
        this._ArticleChargeCode = resultJSON.lstACRateType;
        this._AddonCharges = resultJSON.lstAddOnChargeType;
        this._AddOnChargeType = resultJSON.lstAddOnChargeType;
        //this._Hub = resultJSON.lstHub;
        var CustCode = this._CustomerSiteCode || this.CustomersiteCode
        this._CustomerSiteCostAndContractService.GetById(CustCode).subscribe((result) => {
          const resultJSON = JSON.parse(JSON.stringify(result));
          console.log(resultJSON);
          if (resultJSON.tranStatus.result == true) {
            this.ExistCustomerContract = resultJSON;
            //this._CostingContract = resultJSON.customerSiteContractDetail;
            //this._CostingContract.setValue(resultJSON.customerSiteContractDetail);
            //this._CustomerSiteContractGeneralForm.setValue(resultJSON.lstGeneralContract[0]);

            if (resultJSON.customerSiteContractDetail.contracttypescode != null) {
              var splitContractTypes = resultJSON.customerSiteContractDetail.contracttypescode.split(',');
              var ContractTypesCode: string[] = [];
              Object.keys(splitContractTypes).map((Index) => {
                ContractTypesCode.push(splitContractTypes[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._ContractTypes = ContractTypesCode;
            }
            if (resultJSON.customerSiteContractDetail.opentypeodastatescode != null) {
              var splitState = resultJSON.customerSiteContractDetail.opentypeodastatescode.split(',');
              var StateCode: string[] = [];
              Object.keys(splitState).map((Index) => {
                StateCode.push(splitState[Index]);
                //selectedsuppllierArray.push(updateJSON.productsupplierdetails[Index]);
              });
              this._StateNG = StateCode;
            }

            for (var i = 0; i < splitContractTypes.length; i++) {
              if (splitContractTypes[i] == 'MSC00081') {
                this.HideGeneralRate = true
              }
              if (splitContractTypes[i] == 'MSC00083') {
                this.HideArticleBased = true
              }
              if (splitContractTypes[i] == 'MSC00082') {
                this.HideRegionLevel = true
              }
              if (splitContractTypes[i] == 'MSC00084') {
                this.HideSlab = true
              }
              if (splitContractTypes[i] == 'MSC00104') {
                this.Hide2DRate = true
              }
            }
            this._contracttypescode = resultJSON.customerSiteContractDetail.contracttypescode;
            this._contracttypes_ = resultJSON.customerSiteContractDetail.contracttypescode;
            console.log(this._contracttypes_);
            this._StateCode = resultJSON.customerSiteContractDetail.opentypeodastatescode;

            /*this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);
            this._CostingContract.controls['bookingcutofftime'].setValue(resultJSON.customerSiteContractDetail.);*/
            this._CostingContract.controls['billingbranchcode'].setValue(resultJSON.customerSiteContractDetail.billingbranchcode);
            this._CostingContract.controls['fuelpriceperltr'].setValue(resultJSON.customerSiteContractDetail.fuelpriceperltr);
            this._CostingContract.controls['quotedrateperqtlperkm'].setValue(resultJSON.customerSiteContractDetail.quotedrateperqtlperkm);
            this._CostingContract.controls['minimumfreight'].setValue(resultJSON.customerSiteContractDetail.minimumfreight);
            this._CostingContract.controls['minimumchargeableweight'].setValue(resultJSON.customerSiteContractDetail.minimumchargeableweight);
            this._CostingContract.controls['minimumvsc'].setValue(resultJSON.customerSiteContractDetail.minimumvsc);
            this._CostingContract.controls['expectedsales'].setValue(resultJSON.customerSiteContractDetail.expectedsales);
            this._CostingContract.controls['creditlimit'].setValue(resultJSON.customerSiteContractDetail.creditlimit);
            this._CostingContract.controls['invoicecreditdays'].setValue(resultJSON.customerSiteContractDetail.invoicecreditdays);
            this._CostingContract.controls['minimumdc'].setValue(resultJSON.customerSiteContractDetail.minimumdc);
            this._CostingContract.controls['costtocompanydc'].setValue(resultJSON.customerSiteContractDetail.costtocompanydc);
            this._CostingContract.controls['costtoagentdc'].setValue(resultJSON.customerSiteContractDetail.costtoagentdc);
            this._CostingContract.controls['minimumdd'].setValue(resultJSON.customerSiteContractDetail.minimumdd);
            this._CostingContract.controls['costtocompanydd'].setValue(resultJSON.customerSiteContractDetail.costtoagentdd);
            this._CostingContract.controls['minimumac'].setValue(resultJSON.customerSiteContractDetail.minimumac);
            this._CostingContract.controls['costtocompanyac'].setValue(resultJSON.customerSiteContractDetail.costtocompanyac);
            this._CostingContract.controls['costtoagentac'].setValue(resultJSON.customerSiteContractDetail.costtoagentac);
            this._CostingContract.controls['odainclusiveorexclusivecode'].setValue(resultJSON.customerSiteContractDetail.odainclusiveorexclusivecode);
            this._CostingContract.controls['costtocompanyoda'].setValue(resultJSON.customerSiteContractDetail.costtocompanyoda);
            this._CostingContract.controls['costtoagentoda'].setValue(resultJSON.customerSiteContractDetail.costtoagentoda);
            this._CostingContract.controls['flatodabasedoncode'].setValue(resultJSON.customerSiteContractDetail.flatodabasedoncode);

            this._CustomerSiteContractGeneralForm.controls['rateperqtlperkm'].setValue(resultJSON.lstGeneralContract[0].rateperqtlperkm);
            this._CustomerSiteContractGeneralForm.controls['odacalculationmodecode'].setValue(resultJSON.lstGeneralContract[0].odacalculationmodecode);
            if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00805') {
              this._ArticleList = resultJSON.lstFlatODACharges;
              for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                this._ArticleList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                this._ArticleList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                this._ArticleList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                this._ArticleList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
              }
            }
            else if (resultJSON.customerSiteContractDetail.flatodabasedoncode == 'MSC00806') {
              this._KGList = resultJSON.lstFlatODACharges;
              for (var i = 0; i < resultJSON.lstFlatODACharges.length; i++) {
                this._KGList[i].customersitecode = resultJSON.lstFlatODACharges[i].customersitecode;
                this._KGList[i].flatodachargefrom = resultJSON.lstFlatODACharges[i].flatodachargefrom;
                this._KGList[i].flatodachargeto = resultJSON.lstFlatODACharges[i].flatodachargeto;
                this._KGList[i].flatodacharges = resultJSON.lstFlatODACharges[i].flatodacharges;
              }
            }
            this._RegionList = resultJSON.lstRegionContract;
            for (var i = 0; i < resultJSON.lstRegionContract.length; i++) {
              this._RegionList[i].customersitecode = resultJSON.lstRegionContract[i].customersitecode;
              this._RegionList[i].frombranchcode = resultJSON.lstRegionContract[i].frombranchcode;
              this._RegionList[i].frombranch = resultJSON.lstRegionContract[i].frombranch;
              this._RegionList[i].toregioncode = resultJSON.lstRegionContract[i].toregioncode;
              this._RegionList[i].toregion = resultJSON.lstRegionContract[i].toregion;
              this._RegionList[i].articlecode = resultJSON.lstRegionContract[i].articlecode;
              this._RegionList[i].article = resultJSON.lstRegionContract[i].article;
              this._RegionList[i].ratetypecode = resultJSON.lstRegionContract[i].ratetypecode;
              this._RegionList[i].ratetype = resultJSON.lstRegionContract[i].ratetype;
              this._RegionList[i].rate = resultJSON.lstRegionContract[i].rate;
              this._RegionList[i].dcratetypecode = resultJSON.lstRegionContract[i].dcratetypecode;
              this._RegionList[i].dcratetype = resultJSON.lstRegionContract[i].dcratetype;
              this._RegionList[i].dcrate = resultJSON.lstRegionContract[i].dcrate;
              this._RegionList[i].ddratetypecode = resultJSON.lstRegionContract[i].ddratetypecode;
              this._RegionList[i].ddratetype = resultJSON.lstRegionContract[i].ddratetype;
              this._RegionList[i].ddrate = resultJSON.lstRegionContract[i].ddrate;
              this._RegionList[i].acratetypecode = resultJSON.lstRegionContract[i].acratetypecode;
              this._RegionList[i].acratetype = resultJSON.lstRegionContract[i].acratetype;
              this._RegionList[i].acrate = resultJSON.lstRegionContract[i].acrate;
              this._RegionList[i].inclusiveorexclusivecode = resultJSON.lstRegionContract[i].inclusiveorexclusivecode;
              this._RegionList[i].inclusiveorexclusive = resultJSON.lstRegionContract[i].inclusiveorexclusive;
              this._RegionList[i].isneedreversebooking = resultJSON.lstRegionContract[i].isneedreversebooking;
              this._RegionList[i].lstDCDDACSlabs = resultJSON.lstRegionContract[i].lstDCDDACSlabs;
              for (var j = 0; j < resultJSON.lstRegionContract[i].lstDCDDACSlabs.length; j++) {
                this._RegionList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].customersitecode;
                this._RegionList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].contracttypecode;
                this._RegionList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].chargetypecode;
                this._RegionList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabfrom;
                this._RegionList[i].lstDCDDACSlabs.Slabto = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabrate;
                this._RegionList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstRegionContract[i].lstDCDDACSlabs[j].slabto;
              }
            }
            console.log(this._RegionList);

            this._ArticleBasedList = resultJSON.lstArticleContract;
            for (var i = 0; i < resultJSON.lstArticleContract.length; i++) {
              this._ArticleBasedList[i].customersitecode = resultJSON.lstArticleContract[i].customersitecode;
              this._ArticleBasedList[i].frombranchcode = resultJSON.lstArticleContract[i].frombranchcode;
              this._ArticleBasedList[i].frombranch = resultJSON.lstArticleContract[i].frombranch;
              this._ArticleBasedList[i].tobranchcode = resultJSON.lstArticleContract[i].tobranchcode;
              this._ArticleBasedList[i].tobranch = resultJSON.lstArticleContract[i].tobranch;
              this._ArticleBasedList[i].articlecode = resultJSON.lstArticleContract[i].articlecode;
              this._ArticleBasedList[i].article = resultJSON.lstArticleContract[i].article;
              this._ArticleBasedList[i].ratetypecode = resultJSON.lstArticleContract[i].ratetypecode;
              this._ArticleBasedList[i].ratetype = resultJSON.lstArticleContract[i].ratetype;
              this._ArticleBasedList[i].rate = resultJSON.lstArticleContract[i].rate;
              this._ArticleBasedList[i].dcratetypecode = resultJSON.lstArticleContract[i].dcratetypecode;
              this._ArticleBasedList[i].dcratetype = resultJSON.lstArticleContract[i].dcratetype;
              this._ArticleBasedList[i].dcrate = resultJSON.lstArticleContract[i].dcrate;
              this._ArticleBasedList[i].ddratetypecode = resultJSON.lstArticleContract[i].ddratetypecode;
              this._ArticleBasedList[i].ddratetype = resultJSON.lstArticleContract[i].ddratetype;
              this._ArticleBasedList[i].ddrate = resultJSON.lstArticleContract[i].ddrate;
              this._ArticleBasedList[i].acratetypecode = resultJSON.lstArticleContract[i].acratetypecode;
              this._ArticleBasedList[i].acratetype = resultJSON.lstArticleContract[i].acratetype;
              this._ArticleBasedList[i].acrate = resultJSON.lstArticleContract[i].acrate;
              this._ArticleBasedList[i].inclusiveorexclusivecode = resultJSON.lstArticleContract[i].inclusiveorexclusivecode;
              this._ArticleBasedList[i].inclusiveorexclusive = resultJSON.lstArticleContract[i].inclusiveorexclusive;
              this._ArticleBasedList[i].isneedreversebooking = resultJSON.lstArticleContract[i].isneedreversebooking;
              this._ArticleBasedList[i].lstDCDDACSlabs = resultJSON.lstArticleContract[i].lstDCDDACSlabs;
              for (var j = 0; j < resultJSON.lstArticleContract[i].lstDCDDACSlabs.length; j++) {
                this._ArticleBasedList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].customersitecode;
                this._ArticleBasedList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].contracttypecode;
                this._ArticleBasedList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].chargetypecode;
                this._ArticleBasedList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabfrom;
                this._ArticleBasedList[i].lstDCDDACSlabs.Slabto = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabrate;
                this._ArticleBasedList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstArticleContract[i].lstDCDDACSlabs[j].slabto;
              }
            }

            this._SlabFormList = resultJSON.lstSlabContract;
            for (var i = 0; i < resultJSON.lstSlabContract.length; i++) {
              this._SlabFormList[i].customersitecode = resultJSON.lstSlabContract[i].customersitecode;
              this._SlabFormList[i].frombranchcode = resultJSON.lstSlabContract[i].frombranchcode;
              this._SlabFormList[i].frombranch = resultJSON.lstSlabContract[i].frombranch;
              this._SlabFormList[i].tobranchcode = resultJSON.lstSlabContract[i].tobranchcode;
              this._SlabFormList[i].tobranch = resultJSON.lstSlabContract[i].tobranch;
              this._SlabFormList[i].articlecode = resultJSON.lstSlabContract[i].articlecode;
              this._SlabFormList[i].article = resultJSON.lstSlabContract[i].article;
              this._SlabFormList[i].ratetypecode = resultJSON.lstSlabContract[i].ratetypecode;
              this._SlabFormList[i].ratetype = resultJSON.lstSlabContract[i].ratetype;
              this._SlabFormList[i].rate = resultJSON.lstSlabContract[i].rate;
              this._SlabFormList[i].dcratetypecode = resultJSON.lstSlabContract[i].dcratetypecode;
              this._SlabFormList[i].dcratetype = resultJSON.lstSlabContract[i].dcratetype;
              this._SlabFormList[i].dcrate = resultJSON.lstSlabContract[i].dcrate;
              this._SlabFormList[i].ddratetypecode = resultJSON.lstSlabContract[i].ddratetypecode;
              this._SlabFormList[i].ddratetype = resultJSON.lstSlabContract[i].ddratetype;
              this._SlabFormList[i].ddrate = resultJSON.lstSlabContract[i].ddrate;
              this._SlabFormList[i].acratetypecode = resultJSON.lstSlabContract[i].acratetypecode;
              this._SlabFormList[i].acratetype = resultJSON.lstSlabContract[i].acratetype;
              this._SlabFormList[i].acrate = resultJSON.lstSlabContract[i].acrate;
              this._SlabFormList[i].inclusiveorexclusivecode = resultJSON.lstSlabContract[i].inclusiveorexclusivecode;
              this._SlabFormList[i].inclusiveorexclusive = resultJSON.lstSlabContract[i].inclusiveorexclusive;
              this._SlabFormList[i].isneedreversebooking = resultJSON.lstSlabContract[i].isneedreversebooking;
              this._SlabFormList[i].lstDCDDACSlabs = resultJSON.lstSlabContract[i].lstDCDDACSlabs;
              for (var j = 0; j < resultJSON.lstSlabContract[i].lstDCDDACSlabs.length; j++) {
                this._SlabFormList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].customersitecode;
                this._SlabFormList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].contracttypecode;
                this._SlabFormList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].chargetypecode;
                this._SlabFormList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabfrom;
                this._SlabFormList[i].lstDCDDACSlabs.Slabto = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabrate;
                this._SlabFormList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstSlabContract[i].lstDCDDACSlabs[j].slabto;
              }
            }

            this._2DList = resultJSON.lstTwoDContract;
            for (var i = 0; i < resultJSON.lstTwoDContract.length; i++) {
              this._2DList[i].customersitecode = resultJSON.lstTwoDContract[i].customersitecode;
              this._2DList[i].frombranchcode = resultJSON.lstTwoDContract[i].frombranchcode;
              this._2DList[i].frombranch = resultJSON.lstTwoDContract[i].frombranch;
              this._2DList[i].toKM = resultJSON.lstTwoDContract[i].toKM;
              this._2DList[i].articlecode = resultJSON.lstTwoDContract[i].articlecode;
              this._2DList[i].article = resultJSON.lstTwoDContract[i].article;
              this._2DList[i].ratetypecode = resultJSON.lstTwoDContract[i].ratetypecode;
              this._2DList[i].ratetype = resultJSON.lstTwoDContract[i].ratetype;
              this._2DList[i].rate = resultJSON.lstTwoDContract[i].rate;
              this._2DList[i].dcratetypecode = resultJSON.lstTwoDContract[i].dcratetypecode;
              this._2DList[i].dcratetype = resultJSON.lstTwoDContract[i].dcratetype;
              this._2DList[i].dcrate = resultJSON.lstTwoDContract[i].dcrate;
              this._2DList[i].ddratetypecode = resultJSON.lstTwoDContract[i].ddratetypecode;
              this._2DList[i].ddratetype = resultJSON.lstTwoDContract[i].ddratetype;
              this._2DList[i].ddrate = resultJSON.lstTwoDContract[i].ddrate;
              this._2DList[i].acratetypecode = resultJSON.lstTwoDContract[i].acratetypecode;
              this._2DList[i].acratetype = resultJSON.lstTwoDContract[i].acratetype;
              this._2DList[i].acrate = resultJSON.lstTwoDContract[i].acrate;
              this._2DList[i].inclusiveorexclusivecode = resultJSON.lstTwoDContract[i].inclusiveorexclusivecode;
              this._2DList[i].inclusiveorexclusive = resultJSON.lstTwoDContract[i].inclusiveorexclusive;
              this._2DList[i].isneedreversebooking = resultJSON.lstTwoDContract[i].isneedreversebooking;
              this._2DList[i].lstDCDDACSlabs = resultJSON.lstTwoDContract[i].lstDCDDACSlabs;
              for (var j = 0; j < resultJSON.lstTwoDContract[i].lstDCDDACSlabs.length; j++) {
                this._2DList[i].lstDCDDACSlabs.Customersitecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].customersitecode;
                this._2DList[i].lstDCDDACSlabs.Contracttypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].contracttypecode;
                this._2DList[i].lstDCDDACSlabs.Chargetypecode = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].chargetypecode;
                this._2DList[i].lstDCDDACSlabs.Slabfrom = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabfrom;
                this._2DList[i].lstDCDDACSlabs.Slabto = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabrate;
                this._2DList[i].lstDCDDACSlabs.Slabrate = resultJSON.lstTwoDContract[i].lstDCDDACSlabs[j].slabto;
              }
            }


            this.WayBillList = resultJSON.lstAddOnCharge;
            for (var i = 0; i < resultJSON.lstAddOnCharge.length; i++) {
              this.WayBillList[i].customersitecode = resultJSON.lstAddOnCharge[i].customersitecode;
              this.WayBillList[i].chargetype = resultJSON.lstAddOnCharge[i].chargetype;
              this.WayBillList[i].chargetypecode = resultJSON.lstAddOnCharge[i].chargetypecode;
              this.WayBillList[i].chargeratetypecode = resultJSON.lstAddOnCharge[i].chargeratetypecode;
              this.WayBillList[i].chargeratetype = resultJSON.lstAddOnCharge[i].chargeratetype;
              this.WayBillList[i].chargecodeid = resultJSON.lstAddOnCharge[i].chargecodeid;
              this.WayBillList[i].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == resultJSON.lstAddOnCharge[i].chargecodeid)[0].chargeName;
              this.WayBillList[i].adrate = resultJSON.lstAddOnCharge[i].adrate;
              this.WayBillList[i].inclusiveorexclusivecode = resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode;
              this.WayBillList[i].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == resultJSON.lstAddOnCharge[i].inclusiveorexclusivecode)[0].metasubdescription;
              this.WayBillList[i].printinothercharge = resultJSON.lstAddOnCharge[i].printinothercharge;
              this.WayBillList[i].lstAddOnSlabs = resultJSON.lstAddOnCharge[i].lstAddOnSlabs;
              for (var j = 0; j < resultJSON.lstAddOnCharge[i].lstAddOnSlabs.length; j++) {
                this.WayBillList[i].lstAddOnSlabs.Customersitecode = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].customersitecode;
                this.WayBillList[i].lstAddOnSlabs.Slabfrom = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabfrom;
                this.WayBillList[i].lstAddOnSlabs.Slabto = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabto;
                this.WayBillList[i].lstAddOnSlabs.Slabrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabrate;
                this.WayBillList[i].lstAddOnSlabs.Slabaddrate = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Slabaddrate;
                this.WayBillList[i].lstAddOnSlabs.Chargecodeid = resultJSON.lstAddOnCharge[i].lstAddOnSlabs[j].Chargecodeid;
              }
            }

          }
          else {
            this.ExistCustomerContract = null;
          }
        }, error => {
          this._CustomExceptionService.handleError(error);
        });
      }
    }, error => {
      this._CustomExceptionService.handleError(error);
    });
  }
  CustomerSiteCostAndContractSubmit() {
    var errorsmg = "";
    var selectedcontracttype = this._contracttypescode.split(',');
    for (var i = 0; i < selectedcontracttype.length; i++) {
      if (selectedcontracttype[i] == 'MSC00083') {
        //this.HideArticleBased = true
        if (this._ArticleBasedList.length == 0) {
          errorsmg = "Please add the values in Article Based Tab. "
        }
      }
      if (selectedcontracttype[i] == 'MSC00082') {
        //this.HideRegionLevel = true
        if (this._RegionList.length == 0) {
          errorsmg = "Please add the values in Region Level Tab. "
        }
      }
      if (selectedcontracttype[i] == 'MSC00084') {
        //this.HideSlab = true
        if (this._SlabFormList.length == 0) {
          errorsmg = "Please add the values in Slab Tab. "
        }
      }
      if (selectedcontracttype[i] == 'MSC00104') {
        //this.Hide2DRate = true
        if (this._2DList.length == 0) {
          errorsmg = "Please add the values in 2D Tab. "
        }
      }
    }

    if (this.WayBillList.length == 0) {
      errorsmg = "Please add the values in Way bill Tab. "
    }



    if (errorsmg == "") {
      this.CustomerSiteContractList = this._CostingContract.value;
      this.CustomerSiteContractList.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this.CustomerSiteContractList.opentypeodastatescode = this._StateCode;
      this.CustomerSiteContractList.contracttypescode = this._contracttypescode;
      this.CustomerSiteContractList.contracttypes = this._contracttypes_;
      if (this.currentFileContract != null) {
        this.CustomerSiteContractList.communicationmaildocumentURL = this.currentFileContract.name;
      }
      var lstGeneralContract: any = [];
      var TemplstGeneralContract: any = {};
      if (this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value != null && this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value != null) {
        TemplstGeneralContract.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        TemplstGeneralContract.rateperqtlperkm = this._CustomerSiteContractGeneralForm.get("rateperqtlperkm").value;
        TemplstGeneralContract.odacalculationmodecode = this._CustomerSiteContractGeneralForm.get("odacalculationmodecode").value;
        TemplstGeneralContract.odacalculationmode = (this._ODACalculationMode || []).filter(f => f.metasubcode == TemplstGeneralContract.odacalculationmodecode)[0].metasubdescription;
        lstGeneralContract.push(TemplstGeneralContract);
        this.CustomerSiteContractList.lstGeneralContract = lstGeneralContract;
      }
      this.CustomerSiteContractList.lstRegionContract = this._RegionList;
      this.CustomerSiteContractList.lstArticleContract = this._ArticleBasedList;
      this.CustomerSiteContractList.lstSlabContract = this._SlabFormList;
      this.CustomerSiteContractList.lstTwoDContract = this._2DList;
      this.CustomerSiteContractList.lstAddOnCharge = this.WayBillList;

      if (this._CostingContract.get("flatodabasedoncode").value == 'MSC00805') {
        this.CustomerSiteContractList.lstFlatODACharges = this._ArticleList;
      }
      else if (this._CostingContract.get("flatodabasedoncode").value == 'MSC00806') {
        this.CustomerSiteContractList.lstFlatODACharges = this._KGList;
      }
      if (this.currentFileContract != null) {
        this._selectedDocumentsContract.push(this.currentFileContract);
      }
      var CustomerContract = this.formconverstionContract(this._selectedDocumentsContract);


      
        //this._CustomerSUKService.UpdateSUK(this._CustomerSKUList).subscribe((result) => {
        this._CustomerSiteCostAndContractService.edit(CustomerContract).subscribe((result) => {
          const resutJSON = JSON.parse(JSON.stringify(result));
          console.log("Update", resutJSON)
          if (resutJSON.tranStatus.result == true && (resutJSON != null || resutJSON != undefined)) {
            //this._CustomExceptionService.handleSuccess(usererrors.Update_Success_04);
            // this.ManageCustomersList = resutJSON.lstCustomer
            //this.reset()
          }
          else {
            //this._CustomExceptionService.handleError(resutJSON.tranStatus.lstErrorItem[0].message);
          }
        }, error => { 
          //this._CustomExceptionService.handleError(error) 
        }
        );
      
    }
    else {
      this._CustomExceptionService.handleError(errorsmg)
    }
  }

  formconverstionContract(documents: File[]) {
    let time = new Date();
    const formData: FormData = new FormData();
    //TimeStamp Add:
    for (var x in documents) {

      //var index = p_documentdetails.findIndex(obj => obj.attachmentname == documents[x].name);
      //console.log("Index", index);
      //if (index != -1) {
      var NewFileName = documents[x].name;
      // p_documentdetails[index].attachmentname = NewFileName;
      // p_documentdetails[index].attachmenturl = NewFileName;
      formData.append('iFormFile', documents[x], NewFileName);
      //}
    }
    var _ContractOBJ = {
      "CustomerSiteContract": this.CustomerSiteContractList,
    };
    var _ContractFD = JSON.stringify(_ContractOBJ);
    formData.append('strCustomerSiteContract', _ContractFD);
    return (formData);
  }


  ChangeContractType(event) {
    this.HideGeneralRate = false
    this.HideArticleBased = false
    this.HideRegionLevel = false
    this.HideSlab = false
    this.Hide2DRate = false
    var selectedid = event.value;
    var contracttypescode = "";
    var contracttypes = "";
    for (var i = 0; i < selectedid.length; i++) {
      if (selectedid[i] == 'MSC00081') {
        this.HideGeneralRate = true
      }
      if (selectedid[i] == 'MSC00083') {
        this.HideArticleBased = true
      }
      if (selectedid[i] == 'MSC00082') {
        this.HideRegionLevel = true
      }
      if (selectedid[i] == 'MSC00084') {
        this.HideSlab = true
      }
      if (selectedid[i] == 'MSC00104') {
        this.Hide2DRate = true
      }

      if (contracttypescode == "") {
        contracttypescode = selectedid[i];
        contracttypes = (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
      else {
        contracttypescode = contracttypescode + "," + selectedid[i];
        contracttypes = contracttypes + "," + (this._ContractType || []).filter(f => f.metasubcode == selectedid[i])[0].metasubdescription;
      }
    }

    this._contracttypescode = contracttypescode
    this._contracttypes_ = contracttypes
  }

  onChangeState(event) {
    var selectedid = event.value;
    var statecode = "";
    for (var i = 0; i < selectedid.length; i++) {
      if (statecode == "") {
        statecode = selectedid[i];
      }
      else {
        statecode = statecode + "," + selectedid[i];
      }
    }
    this._StateCode = statecode
  }

  onDocumentSelectContract(event) {
    this.currentFileContract = event.currentFiles[0];
    //document.clear();
  }
  //---------------- Region Level -------------------//

  showBasicDialogDCRate() {
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00098' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate = true;
    }
    if (this._RegionLevelForm.get("dcratetypecode").value == 'MSC00099' || this._RegionLevelForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG = true;
    }

  }
  addRowDCRate() {
    if (this._FromDCPiece != "" && this._ToDCPiece != "" && this._RateDCPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece;
      _DCPieceTemp.ToPiece = this._ToDCPiece;
      _DCPieceTemp.Rate = this._RateDCPiece;
      this._DCPiece.push(_DCPieceTemp);
      this.ClearRowDCRate();
    }
  }
  ClearRowDCRate() {
    this._FromDCPiece = "";
    this._ToDCPiece = "";
    this._RateDCPiece = "";
  }
  addRowDCRateKG() {
    if (this._FromDCKG != "" && this._ToDCKG != "" && this._RateDCKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG;
      _DCPieceGKTemp.ToPiece = this._ToDCKG;
      _DCPieceGKTemp.Rate = this._RateDCKG;
      this._DCKG.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }
  ClearRowDCRateKG() {
    this._FromDCKG = "";
    this._ToDCKG = "";
    this._RateDCKG = "";
  }
  showBasicDialogDDRate() {
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00095' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate = true;
    }
    if (this._RegionLevelForm.get("ddratetypecode").value == 'MSC00096' || this._RegionLevelForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG = true;
    }

  }
  addRowDDRate() {
    if (this._FromDDPiece != "" && this._ToDDPiece != "" && this._RateDDPiece != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece;
      _DDPieceTemp.ToPiece = this._ToDDPiece;
      _DDPieceTemp.Rate = this._RateDDPiece;
      this._DDPiece.push(_DDPieceTemp);
      this.ClearRowDCRate();
    }
  }
  ClearRowDDRate() {
    this._FromDDPiece = "";
    this._ToDDPiece = "";
    this._RateDDPiece = "";
  }
  addRowDDRateKG() {
    if (this._FromDDKG != "" && this._ToDDKG != "" && this._RateDDKG != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG;
      _DDPieceGKTemp.ToPiece = this._ToDDKG;
      _DDPieceGKTemp.Rate = this._RateDDKG;
      this._DDKG.push(_DDPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }
  ClearRowDDRateKG() {
    this._FromDDKG = "";
    this._ToDDKG = "";
    this._RateDDKG = "";
  }
  showBasicDialogACRate() {
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00635') {
      this.displayACRate = true;
    }
    if (this._RegionLevelForm.get("acratetypecode").value == 'MSC00634') {
      this.displayACRateKG = true;
    }

  }
  addRowACRate() {
    if (this._FromACPiece != "" && this._ToACPiece != "" && this._RateACPiece != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPiece;
      _DCPieceTemp.ToPiece = this._ToACPiece;
      _DCPieceTemp.Rate = this._RateACPiece;
      this._ACPiece.push(_DCPieceTemp);
      this.ClearRowACRate();
    }
  }
  ClearRowACRate() {
    this._FromACPiece = "";
    this._ToACPiece = "";
    this._RateACPiece = "";
  }
  addRowACRateKG() {
    if (this._FromACKG != "" && this._ToACKG != "" && this._RateACKG != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKG;
      _DCPieceGKTemp.ToPiece = this._ToACKG;
      _DCPieceGKTemp.Rate = this._RateACKG;
      this._ACKG.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG();
    }
  }
  ClearRowACRateKG() {
    this._FromACKG = "";
    this._ToACKG = "";
    this._RateACKG = "";
  }
  ArticleChargeCode(event) {

  }
  showBasicDialogArticleChargeCode() {
    this.displayACRateType = true;
  }
  onRowSelectPopupArticleChargeCode(event: any) {
    var row = event.data;
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.charge_Code);
    this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    //this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    this.displayACRateType = false;
  }
  addRowRegion() {
    this._RegionLevelFormsubmitted = true;
    var __RegionListTemp: any = {};
    __RegionListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    __RegionListTemp.frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
    __RegionListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == __RegionListTemp.frombranchcode)[0].branchname;
    __RegionListTemp.toregioncode = this._RegionLevelForm.get("toregioncode").value;
    __RegionListTemp.toregion = (this._State || []).filter(f => f.regioncode == __RegionListTemp.toregioncode)[0].regionname;
    __RegionListTemp.articlecode = this._RegionLevelForm.get("articlecode").value;
    __RegionListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == __RegionListTemp.articlecode)[0].articlename;
    __RegionListTemp.ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
    __RegionListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == __RegionListTemp.ratetypecode)[0].metasubdescription;
    __RegionListTemp.rate = this._RegionLevelForm.get("rate").value;
    __RegionListTemp.dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
    __RegionListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == __RegionListTemp.dcratetypecode)[0].metasubdescription;
    __RegionListTemp.dcrate = this._RegionLevelForm.get("dcrate").value;
    __RegionListTemp.ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
    __RegionListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == __RegionListTemp.ddratetypecode)[0].metasubdescription;
    __RegionListTemp.ddrate = this._RegionLevelForm.get("ddrate").value;
    __RegionListTemp.acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
    __RegionListTemp.acratetype = this._RegionLevelForm.get("acratetypecode").value;
    __RegionListTemp.acrate = this._RegionLevelForm.get("acrate").value;
    __RegionListTemp.inclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
    __RegionListTemp.inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == __RegionListTemp.inclusiveorexclusivecode)[0].chargeName;
    __RegionListTemp.isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
    //__RegionListTemp._DCKG = this._DCKG;
    //__RegionListTemp._DDKG = this._DDKG;
    //__RegionListTemp._DDPiece = this._DDPiece;
    //__RegionListTemp._DCPiece = this._DCPiece;

    var _lstDCDDACSlabsTemp = []

    if (this._DCPiece.length > 0) {
      for (var i = 0; i < this._DCPiece.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPiece.Contracttypecode = "MSC00082";
        _tempDCPiece.Chargetypecode = "MSC00107";
        _tempDCPiece.Slabfrom = this._DCPiece[i].FromPiece;
        _tempDCPiece.Slabto = this._DCPiece[i].ToPiece;
        _tempDCPiece.Slabrate = this._DCPiece[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCPiece);
      }
    }
    if (this._DCKG.length > 0) {
      for (var i = 0; i < this._DCKG.length; i++) {
        var _tempDCKG: any = {};
        _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCKG.Contracttypecode = "MSC00082";
        _tempDCKG.Chargetypecode = "MSC00107";
        _tempDCKG.Slabfrom = this._DCKG[i].FromPiece;
        _tempDCKG.Slabto = this._DCKG[i].ToPiece;
        _tempDCKG.Slabrate = this._DCKG[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCKG);
      }
    }

    if (this._DDPiece.length > 0) {
      for (var i = 0; i < this._DDPiece.length; i++) {
        var _tempDDPiece: any = {};
        _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDPiece.Contracttypecode = "MSC00082";
        _tempDDPiece.Chargetypecode = "MSC00108";
        _tempDDPiece.Slabfrom = this._DDPiece[i].FromPiece;
        _tempDDPiece.Slabto = this._DDPiece[i].ToPiece;
        _tempDDPiece.Slabrate = this._DDPiece[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDPiece);
      }
    }
    if (this._DDKG.length > 0) {
      for (var i = 0; i < this._DDKG.length; i++) {
        var _tempDDKG: any = {};
        _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDKG.Contracttypecode = "MSC00082";
        _tempDDKG.Chargetypecode = "MSC00108";
        _tempDDKG.Slabfrom = this._DDKG[i].FromPiece;
        _tempDDKG.Slabto = this._DDKG[i].ToPiece;
        _tempDDKG.Slabrate = this._DDKG[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDKG);
      }
    }

    if (this._ACPiece.length > 0) {
      for (var i = 0; i < this._ACPiece.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00082";
        _tempACPiece.Chargetypecode = "MSC00421";
        _tempACPiece.Slabfrom = this._ACPiece[i].FromPiece;
        _tempACPiece.Slabto = this._ACPiece[i].ToPiece;
        _tempACPiece.Slabrate = this._ACPiece[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._ACKG.length > 0) {
      for (var i = 0; i < this._ACKG.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00082";
        _tempACKG.Chargetypecode = "MSC00421";
        _tempACKG.Slabfrom = this._ACKG[i].FromPiece;
        _tempACKG.Slabto = this._ACKG[i].ToPiece;
        _tempACKG.Slabrate = this._ACKG[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }


    __RegionListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;
    this._RegionList.push(__RegionListTemp);
    //this.ClearRowRegion();
  }
  ClearRowRegion() {
    this._RegionLevelFormsubmitted = false;
    this._RegionLevelForm.reset();
    this._DCKG = [];
    this._DDKG = [];
    this._DDPiece = []
    this._DCPiece = [];
    this._ACKG = [];
    this._ACPiece = [];
  }

  onChangeDCRateType() {


  }
  onChangeDDRateType() {

  }
  Remove_DCPiece(RowIndex) {
    if (this._DCPiece.length > 1) {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1)
    }
    else {
      var index = this._DCPiece.indexOf(RowIndex);
      this._DCPiece.splice(index, 1);
    }
  }
  Remove_DCKG(RowIndex) {
    if (this._DCKG.length > 1) {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1)
    }
    else {
      var index = this._DCKG.indexOf(RowIndex);
      this._DCKG.splice(index, 1);
    }
  }
  Remove_DDPiece(RowIndex) {
    if (this._DDPiece.length > 1) {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1)
    }
    else {
      var index = this._DDPiece.indexOf(RowIndex);
      this._DDPiece.splice(index, 1);
    }
  }
  Remove_DDKG(RowIndex) {
    if (this._DDKG.length > 1) {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1)
    }
    else {
      var index = this._DDKG.indexOf(RowIndex);
      this._DDKG.splice(index, 1);
    }
  }

  Remove_ACPiece(RowIndex) {
    if (this._ACPiece.length > 1) {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1)
    }
    else {
      var index = this._ACPiece.indexOf(RowIndex);
      this._ACPiece.splice(index, 1);
    }
  }
  Remove_ACKG(RowIndex) {
    if (this._ACKG.length > 1) {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1)
    }
    else {
      var index = this._ACKG.indexOf(RowIndex);
      this._ACKG.splice(index, 1);
    }
  }
  Remove_RegionList(RowIndex) {
    if (this._RegionList.length > 1) {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1)
    }
    else {
      var index = this._RegionList.indexOf(RowIndex);
      this._RegionList.splice(index, 1);
    }
  }
  onRowSelect_RegionList(row: CustomerSiteContractRegion, index) {
    debugger;
    console.log(row);
    this._RegionIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._RegionIndex);
    this._RegionLevelForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._RegionLevelForm.controls['toregioncode'].setValue(row.toregioncode);
    this._RegionLevelForm.controls['articlecode'].setValue(row.articlecode);
    this._RegionLevelForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._RegionLevelForm.controls['rate'].setValue(row.rate);
    this._RegionLevelForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._RegionLevelForm.controls['dcrate'].setValue(row.dcrate);
    this._RegionLevelForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._RegionLevelForm.controls['ddrate'].setValue(row.ddrate);
    this._RegionLevelForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._RegionLevelForm.controls['acrate'].setValue(row.acrate);
    this._RegionLevelForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._RegionLevelForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.dcratetypecode == 'MSC00095' || row.dcratetypecode == 'MSC00629') {
            this._DDPiece.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00096' || row.dcratetypecode == 'MSC00630') {
            this._DDKG.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.dcratetypecode == 'MSC00635') {
            this._ACPiece.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00634') {
            this._ACPiece.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowRegion = false;
    this._addRowRegion = true;

  }
  updateRowRegion() {
    //var __RegionListTemp: any = {};
    if (this._RegionIndex != null) {
      this._RegionLevelFormsubmitted = true;
      var ii = this._RegionIndex;
      this._RegionList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._RegionList[ii].frombranchcode = this._RegionLevelForm.get("frombranchcode").value;
      this._RegionList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._RegionLevelForm.get("frombranchcode").value)[0].branchname;
      this._RegionList[ii].toregioncode = this._RegionLevelForm.get("toregioncode").value;
      this._RegionList[ii].toregion = (this._State || []).filter(f => f.regioncode == this._RegionLevelForm.get("toregioncode").value)[0].regionname;
      this._RegionList[ii].articlecode = this._RegionLevelForm.get("articlecode").value;
      this._RegionList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._RegionLevelForm.get("articlecode").value)[0].articlename;
      this._RegionList[ii].ratetypecode = this._RegionLevelForm.get("ratetypecode").value;
      this._RegionList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].rate = this._RegionLevelForm.get("rate").value;
      this._RegionList[ii].dcratetypecode = this._RegionLevelForm.get("dcratetypecode").value;
      this._RegionList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("dcratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].dcrate = this._RegionLevelForm.get("dcrate").value;
      this._RegionList[ii].ddratetypecode = this._RegionLevelForm.get("ddratetypecode").value;
      this._RegionList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._RegionLevelForm.get("ddratetypecode").value)[0].metasubdescription;
      this._RegionList[ii].ddrate = this._RegionLevelForm.get("ddrate").value;
      this._RegionList[ii].acratetypecode = this._RegionLevelForm.get("acratetypecode").value;
      this._RegionList[ii].acratetype = this._RegionLevelForm.get("acratetypecode").value;
      this._RegionList[ii].acrate = this._RegionLevelForm.get("acrate").value;
      this._RegionList[ii].inclusiveorexclusivecode = this._RegionLevelForm.get("inclusiveorexclusivecode").value;
      this._RegionList[ii].inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == this._RegionLevelForm.get("inclusiveorexclusivecode").value)[0].chargeName;
      this._RegionList[ii].isneedreversebooking = this._RegionLevelForm.get("isneedreversebooking").value || false;
      //__RegionListTemp._DCKG = this._DCKG;
      //__RegionListTemp._DDKG = this._DDKG;
      //__RegionListTemp._DDPiece = this._DDPiece;
      //__RegionListTemp._DCPiece = this._DCPiece;

      var _lstDCDDACSlabsTemp = []

      if (this._DCPiece.length > 0) {
        for (var i = 0; i < this._DCPiece.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Contracttypecode = "MSC00082";
          _tempDCPiece.Chargetypecode = "MSC00107";
          _tempDCPiece.Slabfrom = this._DCPiece[i].FromPiece;
          _tempDCPiece.Slabto = this._DCPiece[i].ToPiece;
          _tempDCPiece.Slabrate = this._DCPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG.length > 0) {
        for (var i = 0; i < this._DCKG.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Contracttypecode = "MSC00082";
          _tempDCKG.Chargetypecode = "MSC00107";
          _tempDCKG.Slabfrom = this._DCKG[i].FromPiece;
          _tempDCKG.Slabto = this._DCKG[i].ToPiece;
          _tempDCKG.Slabrate = this._DCKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece.length > 0) {
        for (var i = 0; i < this._DDPiece.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.Contracttypecode = "MSC00082";
          _tempDDPiece.Chargetypecode = "MSC00108";
          _tempDDPiece.Slabfrom = this._DDPiece[i].FromPiece;
          _tempDDPiece.Slabto = this._DDPiece[i].ToPiece;
          _tempDDPiece.Slabrate = this._DDPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG.length > 0) {
        for (var i = 0; i < this._DDKG.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.Contracttypecode = "MSC00082";
          _tempDDKG.Chargetypecode = "MSC00108";
          _tempDDKG.Slabfrom = this._DDKG[i].FromPiece;
          _tempDDKG.Slabto = this._DDKG[i].ToPiece;
          _tempDDKG.Slabrate = this._DDKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece.length > 0) {
        for (var i = 0; i < this._ACPiece.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00082";
          _tempACPiece.Chargetypecode = "MSC00421";
          _tempACPiece.Slabfrom = this._ACPiece[i].FromPiece;
          _tempACPiece.Slabto = this._ACPiece[i].ToPiece;
          _tempACPiece.Slabrate = this._ACPiece[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG.length > 0) {
        for (var i = 0; i < this._ACKG.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00082";
          _tempACKG.Chargetypecode = "MSC00421";
          _tempACKG.Slabfrom = this._ACKG[i].FromPiece;
          _tempACKG.Slabto = this._ACKG[i].ToPiece;
          _tempACKG.Slabrate = this._ACKG[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      this._RegionList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;
      //this._RegionList.push(__RegionListTemp);
      console.log(this._RegionList);
      this._RegionIndex = null;
      this.ClearRowRegion();
      this._updateRowRegion = true;
      this._addRowRegion = false;
    }
  }

  //---------------- Article Based -------------------//


  showBasicDialogDCRateAB() {
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateAB = true;
    }
    if (this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGAB = true;
    }

  }
  addRowDCRateAB() {
    if (this._FromDCPieceAB != "" && this._ToDCPieceAB != "" && this._RateDCPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceAB;
      _DCPieceTemp.ToPiece = this._ToDCPieceAB;
      _DCPieceTemp.Rate = this._RateDCPieceAB;
      this._DCPieceAB.push(_DCPieceTemp);
      this.ClearRowDCRateAB();
    }
  }
  ClearRowDCRateAB() {
    this._FromDCPieceAB = "";
    this._ToDCPieceAB = "";
    this._RateDCPieceAB = "";
  }
  addRowDCRateKGAB() {
    if (this._FromDCKGAB != "" && this._ToDCKGAB != "" && this._RateDCKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGAB;
      _DCPieceGKTemp.ToPiece = this._ToDCKGAB;
      _DCPieceGKTemp.Rate = this._RateDCKGAB;
      this._DCKGAB.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGAB();
    }
  }
  ClearRowDCRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
  }
  showBasicDialogDDRateAB() {
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00095' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateAB = true;
    }
    if (this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00096' || this._ArticleBasedForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGAB = true;
    }

  }
  addRowDDRateAB() {
    if (this._FromDDPieceAB != "" && this._ToDDPieceAB != "" && this._RateDDPieceAB != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceAB;
      _DDPieceTemp.ToPiece = this._ToDDPieceAB;
      _DDPieceTemp.Rate = this._RateDDPieceAB;
      this._DDPieceAB.push(_DDPieceTemp);
      this.ClearRowDCRateAB();
    }
  }
  ClearRowDDRateAB() {
    this._FromDDPieceAB = "";
    this._ToDDPieceAB = "";
    this._RateDDPieceAB = "";
  }
  addRowDDRateKGAB() {
    if (this._FromDDKGAB != "" && this._ToDDKGAB != "" && this._RateDDKGAB != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGAB;
      _DDPieceGKTemp.ToPiece = this._ToDDKGAB;
      _DDPieceGKTemp.Rate = this._RateDDKGAB;
      this._DDKGAB.push(_DDPieceGKTemp);
      this.ClearRowDCRateKGAB();
    }
  }
  ClearRowDDRateKGAB() {
    this._FromDDKGAB = "";
    this._ToDDKGAB = "";
    this._RateDDKGAB = "";
  }
  showBasicDialogACRateAB() {
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00098' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00631') {
      this.displayACRateAB = true;
    }
    if (this._ArticleBasedForm.get("acratetypecode").value == 'MSC00099' || this._ArticleBasedForm.get("acratetypecode").value == 'MSC00632') {
      this.displayACRateKGAB = true;
    }

  }
  addRowACRateAB() {
    if (this._FromACPieceAB != "" && this._ToACPieceAB != "" && this._RateACPieceAB != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceAB;
      _DCPieceTemp.ToPiece = this._ToACPieceAB;
      _DCPieceTemp.Rate = this._RateACPieceAB;
      this._ACPieceAB.push(_DCPieceTemp);
      this.ClearRowACRateAB();
    }
  }
  ClearRowACRateAB() {
    this._FromACPieceAB = "";
    this._ToACPieceAB = "";
    this._RateACPieceAB = "";
  }
  addRowACRateKGAB() {
    if (this._FromACKGAB != "" && this._ToACKGAB != "" && this._RateACKGAB != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGAB;
      _DCPieceGKTemp.ToPiece = this._ToACKGAB;
      _DCPieceGKTemp.Rate = this._RateACKGAB;
      this._ACKGAB.push(_DCPieceGKTemp);
      this.ClearRowACRateKGAB();
    }
  }
  ClearRowACRateKGAB() {
    this._FromDCKGAB = "";
    this._ToDCKGAB = "";
    this._RateDCKGAB = "";
  }
  ArticleChargeCodeAB(event) {

  }
  showBasicDialogArticleChargeCodeAB() {
    this.displayACRateTypeAB = true;
  }
  onRowSelectPopupArticleChargeCodeAB(event: any) {
    var row = event.data;
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.charge_Code);
    this._ArticleBasedForm.controls['acrate'].setValue(row.rate);
    //this._ArticleBasedForm.controls['acrate'].setValue(row.rate);
    this.displayACRateTypeAB = false;
  }
  addRowArticleBase() {
    this._ArticleBasedFormsubmitted = true;
    var _ArticleBaseListTemp: any = {};
    _ArticleBaseListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    _ArticleBaseListTemp.frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
    _ArticleBaseListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.frombranchcode)[0].branchname;
    _ArticleBaseListTemp.tobranchcode = this._ArticleBasedForm.get("tobranchcode").value;
    _ArticleBaseListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _ArticleBaseListTemp.tobranchcode)[0].branchname;
    _ArticleBaseListTemp.articlecode = this._ArticleBasedForm.get("articlecode").value;
    _ArticleBaseListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _ArticleBaseListTemp.articlecode)[0].articlename;
    _ArticleBaseListTemp.ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
    _ArticleBaseListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ratetypecode)[0].metasubdescription;
    _ArticleBaseListTemp.rate = this._ArticleBasedForm.get("rate").value;
    _ArticleBaseListTemp.dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
    _ArticleBaseListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.dcratetypecode)[0].metasubdescription;
    _ArticleBaseListTemp.dcrate = this._ArticleBasedForm.get("dcrate").value;
    _ArticleBaseListTemp.ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
    _ArticleBaseListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _ArticleBaseListTemp.ddratetypecode)[0].metasubdescription;
    _ArticleBaseListTemp.ddrate = this._ArticleBasedForm.get("ddrate").value;
    _ArticleBaseListTemp.acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
    _ArticleBaseListTemp.acratetype = this._ArticleBasedForm.get("acratetypecode").value;
    _ArticleBaseListTemp.acrate = this._ArticleBasedForm.get("acrate").value;
    _ArticleBaseListTemp.inclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
    _ArticleBaseListTemp.inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == _ArticleBaseListTemp.inclusiveorexclusivecode)[0].chargeName;
    _ArticleBaseListTemp.isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;
    // _ArticleBaseListTemp._DCKG = this._DCKGAB;
    // _ArticleBaseListTemp._DDKG = this._DDKGAB;
    // _ArticleBaseListTemp._DDPiece = this._DDPieceAB;
    // _ArticleBaseListTemp._DCPiece = this._DCPieceAB;
    // _ArticleBaseListTemp._ACKG = this._ACKGAB;
    // _ArticleBaseListTemp._ACPiece = this._ACPieceAB;

    var _lstDCDDACSlabsTemp = []

    if (this._DCPieceAB.length > 0) {
      for (var i = 0; i < this._DCPieceAB.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPiece.Contracttypecode = "MSC00083";
        _tempDCPiece.Chargetypecode = "MSC00107";
        _tempDCPiece.Slabfrom = this._DCPieceAB[i].FromPiece;
        _tempDCPiece.Slabto = this._DCPieceAB[i].ToPiece;
        _tempDCPiece.Slabrate = this._DCPieceAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCPiece);
      }
    }
    if (this._DCKGAB.length > 0) {
      for (var i = 0; i < this._DCKGAB.length; i++) {
        var _tempDCKG: any = {};
        _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCKG.Contracttypecode = "MSC00083";
        _tempDCKG.Chargetypecode = "MSC00107";
        _tempDCKG.Slabfrom = this._DCKGAB[i].FromPiece;
        _tempDCKG.Slabto = this._DCKGAB[i].ToPiece;
        _tempDCKG.Slabrate = this._DCKGAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCKG);
      }
    }

    if (this._DDPieceAB.length > 0) {
      for (var i = 0; i < this._DDPieceAB.length; i++) {
        var _tempDDPiece: any = {};
        _tempDDPiece.Customersitecode =this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDPiece.Contracttypecode = "MSC00083";
        _tempDDPiece.Chargetypecode = "MSC00108";
        _tempDDPiece.Slabfrom = this._DDPieceAB[i].FromPiece;
        _tempDDPiece.Slabto = this._DDPieceAB[i].ToPiece;
        _tempDDPiece.Slabrate = this._DDPieceAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDPiece);
      }
    }
    if (this._DDKGAB.length > 0) {
      for (var i = 0; i < this._DDKGAB.length; i++) {
        var _tempDDKG: any = {};
        _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDKG.Contracttypecode = "MSC00083";
        _tempDDKG.Chargetypecode = "MSC00108";
        _tempDDKG.Slabfrom = this._DDKGAB[i].FromPiece;
        _tempDDKG.Slabto = this._DDKGAB[i].ToPiece;
        _tempDDKG.Slabrate = this._DDKGAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDKG);
      }
    }

    if (this._ACPieceAB.length > 0) {
      for (var i = 0; i < this._ACPieceAB.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00083";
        _tempACPiece.Chargetypecode = "MSC00421";
        _tempACPiece.Slabfrom = this._ACPieceAB[i].FromPiece;
        _tempACPiece.Slabto = this._ACPieceAB[i].ToPiece;
        _tempACPiece.Slabrate = this._ACPieceAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._ACKGAB.length > 0) {
      for (var i = 0; i < this._ACKGAB.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00083";
        _tempACKG.Chargetypecode = "MSC00421";
        _tempACKG.Slabfrom = this._ACKGAB[i].FromPiece;
        _tempACKG.Slabto = this._ACKGAB[i].ToPiece;
        _tempACKG.Slabrate = this._ACKGAB[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }



    _ArticleBaseListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;


    this._ArticleBasedList.push(_ArticleBaseListTemp);
    this.ClearRowArticleBase();




  }
  ClearRowArticleBase() {
    this._ArticleBasedFormsubmitted = false;
    this._ArticleBasedForm.reset();
    this._DCKGAB = [];
    this._DDKGAB = [];
    this._DDPieceAB = []
    this._DCPieceAB = [];
    this._ACKGAB = [];
    this._ACPieceAB = [];
  }

  onChangeDCRateTypeAB() {


  }
  onChangeDDRateTypeAB() {

  }

  Remove_DCPieceAB(RowIndex) {
    if (this._DCPieceAB.length > 1) {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1)
    }
    else {
      var index = this._DCPieceAB.indexOf(RowIndex);
      this._DCPieceAB.splice(index, 1);
    }
  }
  Remove_DCKGAB(RowIndex) {
    if (this._DCKGAB.length > 1) {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1)
    }
    else {
      var index = this._DCKGAB.indexOf(RowIndex);
      this._DCKGAB.splice(index, 1);
    }
  }
  Remove_DDPieceAB(RowIndex) {
    if (this._DDPieceAB.length > 1) {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1)
    }
    else {
      var index = this._DDPieceAB.indexOf(RowIndex);
      this._DDPieceAB.splice(index, 1);
    }
  }
  Remove_DDKGAB(RowIndex) {
    if (this._DDKGAB.length > 1) {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1)
    }
    else {
      var index = this._DDKGAB.indexOf(RowIndex);
      this._DDKGAB.splice(index, 1);
    }
  }
  Remove_ACPieceAB(RowIndex) {
    if (this._ACPieceAB.length > 1) {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1)
    }
    else {
      var index = this._ACPieceAB.indexOf(RowIndex);
      this._ACPieceAB.splice(index, 1);
    }
  }
  Remove_ACKGAB(RowIndex) {
    if (this._ACKGAB.length > 1) {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1)
    }
    else {
      var index = this._ACKGAB.indexOf(RowIndex);
      this._ACKGAB.splice(index, 1);
    }
  }
  Remove_ArticleBasedList(RowIndex) {
    if (this._ArticleBasedList.length > 1) {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1)
    }
    else {
      var index = this._ArticleBasedList.indexOf(RowIndex);
      this._ArticleBasedList.splice(index, 1);
    }
  }
  onRowSelect_ArticleBasedList(row: CustomerSiteContractArticle, index) {
    debugger;
    console.log(row);
    this._ArticleBasedIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._ArticleBasedIndex);
    this._ArticleBasedForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._ArticleBasedForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._ArticleBasedForm.controls['articlecode'].setValue(row.articlecode);
    this._ArticleBasedForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._ArticleBasedForm.controls['rate'].setValue(row.rate);
    this._ArticleBasedForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._ArticleBasedForm.controls['dcrate'].setValue(row.dcrate);
    this._ArticleBasedForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._ArticleBasedForm.controls['ddrate'].setValue(row.ddrate);
    this._ArticleBasedForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._ArticleBasedForm.controls['acrate'].setValue(row.acrate);
    this._ArticleBasedForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._ArticleBasedForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);
    /////_ArticleBasedFormLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstDCDDACSlabs  != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceAB.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGAB.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.dcratetypecode == 'MSC00095' || row.dcratetypecode == 'MSC00629') {
            this._DDPieceAB.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00096' || row.dcratetypecode == 'MSC00630') {
            this._DDKGAB.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.dcratetypecode == 'MSC00635') {
            this._ACPieceAB.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00634') {
            this._ACPieceAB.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowArticleBased = false;
    this._addRowArticleBased = true;
  }

  updateRowArticleBase() {
    if (this._ArticleBasedIndex != null) {
      this._ArticleBasedFormsubmitted = true;
      var ii = this._RegionIndex;
      this._ArticleBasedList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._ArticleBasedList[ii].frombranchcode = this._ArticleBasedForm.get("frombranchcode").value;
      this._ArticleBasedList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._ArticleBasedForm.get("frombranchcode").value)[0].branchname;
      this._ArticleBasedList[ii].toregioncode = this._ArticleBasedForm.get("toregioncode").value;
      this._ArticleBasedList[ii].toregion = (this._State || []).filter(f => f.regioncode == this._ArticleBasedForm.get("toregioncode").value)[0].regionname;
      this._ArticleBasedList[ii].articlecode = this._ArticleBasedForm.get("articlecode").value;
      this._ArticleBasedList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._ArticleBasedForm.get("articlecode").value)[0].articlename;
      this._ArticleBasedList[ii].ratetypecode = this._ArticleBasedForm.get("ratetypecode").value;
      this._ArticleBasedList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].rate = this._ArticleBasedForm.get("rate").value;
      this._ArticleBasedList[ii].dcratetypecode = this._ArticleBasedForm.get("dcratetypecode").value;
      this._ArticleBasedList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("dcratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].dcrate = this._ArticleBasedForm.get("dcrate").value;
      this._ArticleBasedList[ii].ddratetypecode = this._ArticleBasedForm.get("ddratetypecode").value;
      this._ArticleBasedList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._ArticleBasedForm.get("ddratetypecode").value)[0].metasubdescription;
      this._ArticleBasedList[ii].ddrate = this._ArticleBasedForm.get("ddrate").value;
      this._ArticleBasedList[ii].acratetypecode = this._ArticleBasedForm.get("acratetypecode").value;
      this._ArticleBasedList[ii].acratetype = this._ArticleBasedForm.get("acratetypecode").value;
      this._ArticleBasedList[ii].acrate = this._ArticleBasedForm.get("acrate").value;
      this._ArticleBasedList[ii].inclusiveorexclusivecode = this._ArticleBasedForm.get("inclusiveorexclusivecode").value;
      this._ArticleBasedList[ii].inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == this._ArticleBasedForm.get("inclusiveorexclusivecode").value)[0].chargeName;
      this._ArticleBasedList[ii].isneedreversebooking = this._ArticleBasedForm.get("isneedreversebooking").value || false;


      var _lstDCDDACSlabsTemp = []

      if (this._DCPieceAB.length > 0) {
        for (var i = 0; i < this._DCPieceAB.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Contracttypecode = "MSC00083";
          _tempDCPiece.Chargetypecode = "MSC00107";
          _tempDCPiece.Slabfrom = this._DCPieceAB[i].FromPiece;
          _tempDCPiece.Slabto = this._DCPieceAB[i].ToPiece;
          _tempDCPiece.Slabrate = this._DCPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGAB.length > 0) {
        for (var i = 0; i < this._DCKGAB.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Contracttypecode = "MSC00083";
          _tempDCKG.Chargetypecode = "MSC00107";
          _tempDCKG.Slabfrom = this._DCKGAB[i].FromPiece;
          _tempDCKG.Slabto = this._DCKGAB[i].ToPiece;
          _tempDCKG.Slabrate = this._DCKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceAB.length > 0) {
        for (var i = 0; i < this._DDPieceAB.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.Contracttypecode = "MSC00083";
          _tempDDPiece.Chargetypecode = "MSC00108";
          _tempDDPiece.Slabfrom = this._DDPieceAB[i].FromPiece;
          _tempDDPiece.Slabto = this._DDPieceAB[i].ToPiece;
          _tempDDPiece.Slabrate = this._DDPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGAB.length > 0) {
        for (var i = 0; i < this._DDKGAB.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.Contracttypecode = "MSC00083";
          _tempDDKG.Chargetypecode = "MSC00108";
          _tempDDKG.Slabfrom = this._DDKGAB[i].FromPiece;
          _tempDDKG.Slabto = this._DDKGAB[i].ToPiece;
          _tempDDKG.Slabrate = this._DDKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceAB.length > 0) {
        for (var i = 0; i < this._ACPieceAB.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00083";
          _tempACPiece.Chargetypecode = "MSC00421";
          _tempACPiece.Slabfrom = this._ACPieceAB[i].FromPiece;
          _tempACPiece.Slabto = this._ACPieceAB[i].ToPiece;
          _tempACPiece.Slabrate = this._ACPieceAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGAB.length > 0) {
        for (var i = 0; i < this._ACKGAB.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00083";
          _tempACKG.Chargetypecode = "MSC00421";
          _tempACKG.Slabfrom = this._ACKGAB[i].FromPiece;
          _tempACKG.Slabto = this._ACKGAB[i].ToPiece;
          _tempACKG.Slabrate = this._ACKGAB[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }



      this._ArticleBasedList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._ArticleBasedIndex = null;
      this._updateRowArticleBased = true;
      this._addRowArticleBased = false;
      this.ClearRowArticleBase();

    }
  }

  //---------------- Slab -------------------//

  showBasicDialogSlab() {
    if (this._SlabForm.get("ratetypecode").value == '') {
      this.displaySlab = true;
    }
    if (this._SlabForm.get("ratetypecode").value == '') {
      this.displayKGSlab = true;
    }
  }
  addRowRateSlab() {
    if (this._FromPieceSlab != "" && this._ToPieceSlab != "" && this._RatePieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceSlab;
      _DCPieceTemp.ToPiece = this._ToPieceSlab;
      _DCPieceTemp.Rate = this._RatePieceSlab;
      this._PieceSlab.push(_DCPieceTemp);
      this.ClearRowRateSlab();
    }
  }
  ClearRowRateSlab() {
    this._FromPieceSlab = "";
    this._ToPieceSlab = "";
    this._RatePieceSlab = "";
  }
  addRowRateKGSlab() {
    if (this._FromKGSlab != "" && this._ToKGSlab != "" && this._RateKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToKGSlab;
      _DCPieceGKTemp.Rate = this._RateKGSlab;
      this._KGSlab.push(_DCPieceGKTemp);
      this.ClearRowRateKGSlab();
    }
  }
  ClearRowRateKGSlab() {
    this._FromKGSlab = "";
    this._ToKGSlab = "";
    this._RateKGSlab = "";
  }
  showBasicDialogDCRateSlab() {
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00098' || this._SlabForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRateSlab = true;
    }
    if (this._SlabForm.get("dcratetypecode").value == 'MSC00099' || this._SlabForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKGSlab = true;
    }

  }
  addRowDCRateSlab() {
    if (this._FromDCPieceSlab != "" && this._ToDCPieceSlab != "" && this._RateDCPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPieceSlab;
      _DCPieceTemp.ToPiece = this._ToDCPieceSlab;
      _DCPieceTemp.Rate = this._RateDCPieceSlab;
      this._DCPieceSlab.push(_DCPieceTemp);
      this.ClearRowDCRateSlab();
    }
  }
  ClearRowDCRateSlab() {
    this._FromDCPieceSlab = "";
    this._ToDCPieceSlab = "";
    this._RateDCPieceSlab = "";
  }
  addRowDCRateKGSlab() {
    if (this._FromDCKGSlab != "" && this._ToDCKGSlab != "" && this._RateDCKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToDCKGSlab;
      _DCPieceGKTemp.Rate = this._RateDCKGSlab;
      this._DCKGSlab.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowDCRateKGSlab() {
    this._FromDCKGSlab = "";
    this._ToDCKGSlab = "";
    this._RateDCKGSlab = "";
  }
  showBasicDialogDDRateSlab() {
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00095' || this._SlabForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRateSlab = true;
    }
    if (this._SlabForm.get("ddratetypecode").value == 'MSC00096' || this._SlabForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKGSlab = true;
    }

  }
  addRowDDRateSlab() {
    if (this._FromDDPieceSlab != "" && this._ToDDPieceSlab != "" && this._RateDDPieceSlab != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPieceSlab;
      _DDPieceTemp.ToPiece = this._ToDDPieceSlab;
      _DDPieceTemp.Rate = this._RateDDPieceSlab;
      this._DDPieceSlab.push(_DDPieceTemp);
      this.ClearRowDCRateSlab();
    }
  }
  ClearRowDDRateSlab() {
    this._FromDDPieceSlab = "";
    this._ToDDPieceSlab = "";
    this._RateDDPieceSlab = "";
  }
  addRowDDRateKGSlab() {
    if (this._FromDDKGSlab != "" && this._ToDDKGSlab != "" && this._RateDDKGSlab != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKGSlab;
      _DDPieceGKTemp.ToPiece = this._ToDDKGSlab;
      _DDPieceGKTemp.Rate = this._RateDDKGSlab;
      this._DDKGSlab.push(_DDPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowDDRateKGSlab() {
    this._FromDDKGSlab = "";
    this._ToDDKGSlab = "";
    this._RateDDKGSlab = "";
  }
  showBasicDialogACRateSlab() {
    this.displayACRateSlab = true;
    //this.displayACRateKGSlab=true;
  }
  addRowACRateSlab() {
    if (this._FromACPieceSlab != "" && this._ToACPieceSlab != "" && this._RateACPieceSlab != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromACPieceSlab;
      _DCPieceTemp.ToPiece = this._ToACPieceSlab;
      _DCPieceTemp.Rate = this._RateACPieceSlab;
      this._ACPieceSlab.push(_DCPieceTemp);
      this.ClearRowACRateSlab();
    }
  }
  ClearRowACRateSlab() {
    this._FromACPieceSlab = "";
    this._ToACPieceSlab = "";
    this._RateACPieceSlab = "";
  }
  addRowACRateKGSlab() {
    if (this._FromACKGSlab != "" && this._ToACKGSlab != "" && this._RateACKGSlab != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromACKGSlab;
      _DCPieceGKTemp.ToPiece = this._ToACKGSlab;
      _DCPieceGKTemp.Rate = this._RateACKGSlab;
      this._ACKGSlab.push(_DCPieceGKTemp);
      this.ClearRowDCRateKGSlab();
    }
  }
  ClearRowACRateKGSlab() {
    this._FromACKGSlab = "";
    this._ToACKGSlab = "";
    this._RateACKGSlab = "";
  }
  ArticleChargeCodeSlab(event) {

  }
  showBasicDialogArticleChargeCodeSlab() {
    this.displayACRateTypeSlab = true;
  }
  onRowSelectPopupArticleChargeCodeSlab(event: any) {
    var row = event.data;
    this._SlabForm.controls['acratetypecode'].setValue(row.charge_Code);
    this._SlabForm.controls['acrate'].setValue(row.rate);
    //this._SlabForm.controls['acrate'].setValue(row.rate);
    this.displayACRateType = false;
  }
  addRowSlab() {
    this._SlabFormsubmitted = true;
    var _SlabFormListTemp: any = {};
    _SlabFormListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    _SlabFormListTemp.frombranchcode = this._SlabForm.get("frombranchcode").value;
    _SlabFormListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.frombranchcode)[0].branchname;
    _SlabFormListTemp.tobranchcode = this._SlabForm.get("tobranchcode").value;
    _SlabFormListTemp.tobranch = (this._BillingBranch || []).filter(f => f.branchcode == _SlabFormListTemp.tobranchcode)[0].branchname;
    _SlabFormListTemp.articlecode = this._SlabForm.get("articlecode").value;
    _SlabFormListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _SlabFormListTemp.articlecode)[0].articlename;
    _SlabFormListTemp.ratetypecode = this._SlabForm.get("ratetypecode").value;
    _SlabFormListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == _SlabFormListTemp.ratetypecode)[0].metasubdescription;
    _SlabFormListTemp.rate = this._SlabForm.get("rate").value;
    _SlabFormListTemp.dcratetypecode = this._SlabForm.get("dcratetypecode").value;
    _SlabFormListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.dcratetypecode)[0].metasubdescription;
    _SlabFormListTemp.dcrate = this._SlabForm.get("dcrate").value;
    _SlabFormListTemp.ddratetypecode = this._SlabForm.get("ddratetypecode").value;
    _SlabFormListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _SlabFormListTemp.ddratetypecode)[0].metasubdescription;
    _SlabFormListTemp.ddrate = this._SlabForm.get("ddrate").value;
    _SlabFormListTemp.acratetypecode = this._SlabForm.get("acratetypecode").value;
    _SlabFormListTemp.acratetype = this._SlabForm.get("acratetypecode").value;
    _SlabFormListTemp.acrate = this._SlabForm.get("acrate").value;
    _SlabFormListTemp.inclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
    _SlabFormListTemp.inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == _SlabFormListTemp.inclusiveorexclusivecode)[0].chargeName;
    _SlabFormListTemp.isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;
    /* _SlabFormListTemp._DCKG = this._DCKGSlab;
     _SlabFormListTemp._DDKG = this._DDKGSlab;
     _SlabFormListTemp._DDPiece = this._DDPieceSlab;
     _SlabFormListTemp._DCPiece = this._DCPieceSlab;
     _SlabFormListTemp._ACKG = this._ACKGSlab;    
     _SlabFormListTemp._ACPiece = this._ACPieceSlab;
     _SlabFormListTemp._SlabKG = this._KGSlab;    
     _SlabFormListTemp._SlabPiece = this._PieceSlab;*/

    var _lstDCDDACSlabsTemp = []
    if (this._DCPieceSlab.length > 0) {
      for (var i = 0; i < this._DCPieceSlab.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPiece.Contracttypecode = "MSC00084";
        _tempDCPiece.Chargetypecode = "MSC00107";
        _tempDCPiece.Slabfrom = this._DCPieceSlab[i].FromPiece;
        _tempDCPiece.Slabto = this._DCPieceSlab[i].ToPiece;
        _tempDCPiece.Slabrate = this._DCPieceSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCPiece);
      }
    }
    if (this._DCKGSlab.length > 0) {
      for (var i = 0; i < this._DCKGSlab.length; i++) {
        var _tempDCKG: any = {};
        _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCKG.Contracttypecode = "MSC00084";
        _tempDCKG.Chargetypecode = "MSC00107";
        _tempDCKG.Slabfrom = this._DCKGSlab[i].FromPiece;
        _tempDCKG.Slabto = this._DCKGSlab[i].ToPiece;
        _tempDCKG.Slabrate = this._DCKGSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCKG);
      }
    }

    if (this._DDPieceSlab.length > 0) {
      for (var i = 0; i < this._DDPieceSlab.length; i++) {
        var _tempDDPiece: any = {};
        _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDPiece.Contracttypecode = "MSC00084";
        _tempDDPiece.Chargetypecode = "MSC00108";
        _tempDDPiece.Slabfrom = this._DDPieceSlab[i].FromPiece;
        _tempDDPiece.Slabto = this._DDPieceSlab[i].ToPiece;
        _tempDDPiece.Slabrate = this._DDPieceSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDPiece);
      }
    }
    if (this._DDKGSlab.length > 0) {
      for (var i = 0; i < this._DDKGSlab.length; i++) {
        var _tempDDKG: any = {};
        _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDKG.Contracttypecode = "MSC00084";
        _tempDDKG.Chargetypecode = "MSC00108";
        _tempDDKG.Slabfrom = this._DDKGSlab[i].FromPiece;
        _tempDDKG.Slabto = this._DDKGSlab[i].ToPiece;
        _tempDDKG.Slabrate = this._DDKGSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDKG);
      }
    }

    if (this._ACPieceSlab.length > 0) {
      for (var i = 0; i < this._ACPieceSlab.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00084";
        _tempACPiece.Chargetypecode = "MSC00421";
        _tempACPiece.Slabfrom = this._ACPieceSlab[i].FromPiece;
        _tempACPiece.Slabto = this._ACPieceSlab[i].ToPiece;
        _tempACPiece.Slabrate = this._ACPieceSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._ACKGSlab.length > 0) {
      for (var i = 0; i < this._ACKGSlab.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00084";
        _tempACKG.Chargetypecode = "MSC00421";
        _tempACKG.Slabfrom = this._ACKGSlab[i].FromPiece;
        _tempACKG.Slabto = this._ACKGSlab[i].ToPiece;
        _tempACKG.Slabrate = this._ACKGSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }

    if (this._ACPieceSlab.length > 0) {
      for (var i = 0; i < this._ACPieceSlab.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00084";
        _tempACPiece.Chargetypecode = "Piece";
        _tempACPiece.Slabfrom = this._ACPieceSlab[i].FromPiece;
        _tempACPiece.Slabto = this._ACPieceSlab[i].ToPiece;
        _tempACPiece.Slabrate = this._ACPieceSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._KGSlab.length > 0) {
      for (var i = 0; i < this._KGSlab.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00084";
        _tempACKG.Chargetypecode = "KG";
        _tempACKG.Slabfrom = this._KGSlab[i].FromPiece;
        _tempACKG.Slabto = this._KGSlab[i].ToPiece;
        _tempACKG.Slabrate = this._KGSlab[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }
    _SlabFormListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

    this._SlabFormList.push(_SlabFormListTemp);
    this.ClearRowSlab();
  }
  ClearRowSlab() {
    this._SlabFormsubmitted = false;
    this._SlabForm.reset();
    this._DCKGSlab = [];
    this._DDKGSlab = [];
    this._DDPieceSlab = []
    this._DCPieceSlab = [];
    this._ACKGSlab = [];
    this._ACPieceSlab = [];
    this._KGSlab = [];
    this._PieceSlab = [];
  }

  onChangeDCRateTypeSlab() {


  }
  onChangeDDRateTypeSlab() {

  }

  Remove_PieceSlab(RowIndex) {
    if (this._PieceSlab.length > 1) {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1)
    }
    else {
      var index = this._PieceSlab.indexOf(RowIndex);
      this._PieceSlab.splice(index, 1);
    }
  }

  Remove_KGSlab(RowIndex) {
    if (this._KGSlab.length > 1) {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1)
    }
    else {
      var index = this._KGSlab.indexOf(RowIndex);
      this._KGSlab.splice(index, 1);
    }
  }
  Remove_DCPieceSlab(RowIndex) {
    if (this._DCPieceSlab.length > 1) {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DCPieceSlab.indexOf(RowIndex);
      this._DCPieceSlab.splice(index, 1);
    }
  }

  Remove_DCKGSlab(RowIndex) {
    if (this._DCKGSlab.length > 1) {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1)
    }
    else {
      var index = this._DCKGSlab.indexOf(RowIndex);
      this._DCKGSlab.splice(index, 1);
    }
  }
  Remove_DDPieceSlab(RowIndex) {
    if (this._DDPieceSlab.length > 1) {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1)
    }
    else {
      var index = this._DDPieceSlab.indexOf(RowIndex);
      this._DDPieceSlab.splice(index, 1);
    }
  }
  Remove_DDKGSlab(RowIndex) {
    if (this._DDKGSlab.length > 1) {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1)
    }
    else {
      var index = this._DDKGSlab.indexOf(RowIndex);
      this._DDKGSlab.splice(index, 1);
    }
  }
  Remove_ACPieceSlab(RowIndex) {
    if (this._ACPieceSlab.length > 1) {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1)
    }
    else {
      var index = this._ACPieceSlab.indexOf(RowIndex);
      this._ACPieceSlab.splice(index, 1);
    }
  }

  Remove_ACKGSlab(RowIndex) {
    if (this._ACKGSlab.length > 1) {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1)
    }
    else {
      var index = this._ACKGSlab.indexOf(RowIndex);
      this._ACKGSlab.splice(index, 1);
    }
  }

  onRowSelect_SlabFormList(row: CustomerSiteContractSlab, index) {
    debugger;
    console.log(row);
    this._SlabIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._SlabIndex);
    this._SlabForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._SlabForm.controls['tobranchcode'].setValue(row.tobranchcode);
    this._SlabForm.controls['articlecode'].setValue(row.articlecode);
    this._SlabForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._SlabForm.controls['rate'].setValue(row.rate);
    this._SlabForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._SlabForm.controls['dcrate'].setValue(row.dcrate);
    this._SlabForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._SlabForm.controls['ddrate'].setValue(row.ddrate);
    this._SlabForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._SlabForm.controls['acrate'].setValue(row.acrate);
    this._SlabForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._SlabForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);

    if (row.lstDCDDACSlabs  != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPieceSlab.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKGSlab.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.dcratetypecode == 'MSC00095' || row.dcratetypecode == 'MSC00629') {
            this._DDPieceSlab.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00096' || row.dcratetypecode == 'MSC00630') {
            this._DDKGSlab.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.dcratetypecode == 'MSC00635') {
            this._ACPieceSlab.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00634') {
            this._ACPieceSlab.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRowSlab = false;
    this._addRowSlab = true;

  }
  updateRowSlab() {
    if (this._SlabIndex != null) {
      this._SlabFormsubmitted = true;
      var ii = this._SlabIndex;
      this._SlabFormList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._SlabFormList[ii].frombranchcode = this._SlabForm.get("frombranchcode").value;
      this._SlabFormList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._SlabForm.get("frombranchcode").value)[0].branchname;
      this._SlabFormList[ii].toregioncode = this._SlabForm.get("toregioncode").value;
      this._SlabFormList[ii].toregion = (this._State || []).filter(f => f.regioncode == this._SlabForm.get("toregioncode").value)[0].regionname;
      this._SlabFormList[ii].articlecode = this._SlabForm.get("articlecode").value;
      this._SlabFormList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._SlabForm.get("articlecode").value)[0].articlename;
      this._SlabFormList[ii].ratetypecode = this._SlabForm.get("ratetypecode").value;
      this._SlabFormList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._SlabForm.get("ratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].rate = this._SlabForm.get("rate").value;
      this._SlabFormList[ii].dcratetypecode = this._SlabForm.get("dcratetypecode").value;
      this._SlabFormList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._SlabForm.get("dcratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].dcrate = this._SlabForm.get("dcrate").value;
      this._SlabFormList[ii].ddratetypecode = this._SlabForm.get("ddratetypecode").value;
      this._SlabFormList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._SlabForm.get("ddratetypecode").value)[0].metasubdescription;
      this._SlabFormList[ii].ddrate = this._SlabForm.get("ddrate").value;
      this._SlabFormList[ii].acratetypecode = this._SlabForm.get("acratetypecode").value;
      this._SlabFormList[ii].acratetype = this._SlabForm.get("acratetypecode").value;
      this._SlabFormList[ii].acrate = this._SlabForm.get("acrate").value;
      this._SlabFormList[ii].inclusiveorexclusivecode = this._SlabForm.get("inclusiveorexclusivecode").value;
      this._SlabFormList[ii].inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == this._SlabForm.get("inclusiveorexclusivecode").value)[0].chargeName;
      this._SlabFormList[ii].isneedreversebooking = this._SlabForm.get("isneedreversebooking").value || false;

      var _lstDCDDACSlabsTemp = []
      if (this._DCPieceSlab.length > 0) {
        for (var i = 0; i < this._DCPieceSlab.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Contracttypecode = "MSC00084";
          _tempDCPiece.Chargetypecode = "MSC00107";
          _tempDCPiece.Slabfrom = this._DCPieceSlab[i].FromPiece;
          _tempDCPiece.Slabto = this._DCPieceSlab[i].ToPiece;
          _tempDCPiece.Slabrate = this._DCPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKGSlab.length > 0) {
        for (var i = 0; i < this._DCKGSlab.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Contracttypecode = "MSC00084";
          _tempDCKG.Chargetypecode = "MSC00107";
          _tempDCKG.Slabfrom = this._DCKGSlab[i].FromPiece;
          _tempDCKG.Slabto = this._DCKGSlab[i].ToPiece;
          _tempDCKG.Slabrate = this._DCKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPieceSlab.length > 0) {
        for (var i = 0; i < this._DDPieceSlab.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.Contracttypecode = "MSC00084";
          _tempDDPiece.Chargetypecode = "MSC00108";
          _tempDDPiece.Slabfrom = this._DDPieceSlab[i].FromPiece;
          _tempDDPiece.Slabto = this._DDPieceSlab[i].ToPiece;
          _tempDDPiece.Slabrate = this._DDPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKGSlab.length > 0) {
        for (var i = 0; i < this._DDKGSlab.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.Contracttypecode = "MSC00084";
          _tempDDKG.Chargetypecode = "MSC00108";
          _tempDDKG.Slabfrom = this._DDKGSlab[i].FromPiece;
          _tempDDKG.Slabto = this._DDKGSlab[i].ToPiece;
          _tempDDKG.Slabrate = this._DDKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00084";
          _tempACPiece.Chargetypecode = "MSC00421";
          _tempACPiece.Slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.Slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.Slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKGSlab.length > 0) {
        for (var i = 0; i < this._ACKGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00084";
          _tempACKG.Chargetypecode = "MSC00421";
          _tempACKG.Slabfrom = this._ACKGSlab[i].FromPiece;
          _tempACKG.Slabto = this._ACKGSlab[i].ToPiece;
          _tempACKG.Slabrate = this._ACKGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      if (this._ACPieceSlab.length > 0) {
        for (var i = 0; i < this._ACPieceSlab.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00084";
          _tempACPiece.Chargetypecode = "Piece";
          _tempACPiece.Slabfrom = this._ACPieceSlab[i].FromPiece;
          _tempACPiece.Slabto = this._ACPieceSlab[i].ToPiece;
          _tempACPiece.Slabrate = this._ACPieceSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KGSlab.length > 0) {
        for (var i = 0; i < this._KGSlab.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00084";
          _tempACKG.Chargetypecode = "KG";
          _tempACKG.Slabfrom = this._KGSlab[i].FromPiece;
          _tempACKG.Slabto = this._KGSlab[i].ToPiece;
          _tempACKG.Slabrate = this._KGSlab[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }

      this._SlabFormList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;


      this._SlabIndex = null;
      this._updateRowSlab = true;
      this._addRowSlab = false;
      this.ClearRowSlab();

    }
  }



  //---------------- 2D -------------------//

  showBasicDialog2D() {
    if (this._2DForm.get("ratetypecode").value == '') {
      this.display2D = true;
    }
    if (this._2DForm.get("ratetypecode").value == '') {
      this.displayKG2D = true;
    }
  }
  addRowRate2D() {
    if (this._FromPiece2D != "" && this._ToPiece2D != "" && this._RatePiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPiece2D;
      _DCPieceTemp.ToPiece = this._ToPiece2D;
      _DCPieceTemp.Rate = this._RatePiece2D;
      this._Piece2D.push(_DCPieceTemp);
      this.ClearRowRate2D();
    }
  }
  ClearRowRate2D() {
    this._FromPiece2D = "";
    this._ToPiece2D = "";
    this._RatePiece2D = "";
  }
  addRowRateKG2D() {
    if (this._FromKG2D != "" && this._ToKG2D != "" && this._RateKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKG2D;
      _DCPieceGKTemp.ToPiece = this._ToKG2D;
      _DCPieceGKTemp.Rate = this._RateKG2D;
      this._KG2D.push(_DCPieceGKTemp);
      this.ClearRowRateKG2D();
    }
  }
  ClearRowRateKG2D() {
    this._FromKG2D = "";
    this._ToKG2D = "";
    this._RateKG2D = "";
  }

  showBasicDialogDCRate2D() {
    if (this._2DForm.get("dcratetypecode").value == 'MSC00098' || this._2DForm.get("dcratetypecode").value == 'MSC00631') {
      this.displayDCRate2D = true;
    }
    if (this._2DForm.get("dcratetypecode").value == 'MSC00099' || this._2DForm.get("dcratetypecode").value == 'MSC00632') {
      this.displayDCRateKG2D = true;
    }

  }
  addRowDCRate2D() {
    if (this._FromDCPiece2D != "" && this._ToDCPiece2D != "" && this._RateDCPiece2D != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromDCPiece2D;
      _DCPieceTemp.ToPiece = this._ToDCPiece2D;
      _DCPieceTemp.Rate = this._RateDCPiece2D;
      this._DCPiece2D.push(_DCPieceTemp);
      this.ClearRowDCRate2D();
    }
  }
  ClearRowDCRate2D() {
    this._FromDCPiece = "";
    this._ToDCPiece = "";
    this._RateDCPiece = "";
  }
  addRowDCRateKG2D() {
    if (this._FromDCKG2D != "" && this._ToDCKG2D != "" && this._RateDCKG2D != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromDCKG2D;
      _DCPieceGKTemp.ToPiece = this._ToDCKG2D;
      _DCPieceGKTemp.Rate = this._RateDCKG2D;
      this._DCKG2D.push(_DCPieceGKTemp);
      this.ClearRowDCRateKG2D();
    }
  }
  ClearRowDCRateKG2D() {
    this._FromDCKG2D = "";
    this._ToDCKG2D = "";
    this._RateDCKG2D = "";
  }
  showBasicDialogDDRate2D() {
    if (this._2DForm.get("ddratetypecode").value == 'MSC00095' || this._2DForm.get("ddratetypecode").value == 'MSC00629') {
      this.displayDDRate2D = true;
    }
    if (this._2DForm.get("ddratetypecode").value == 'MSC00096' || this._2DForm.get("ddratetypecode").value == 'MSC00630') {
      this.displayDDRateKG2D = true;
    }

  }
  addRowDDRate2D() {
    if (this._FromDDPiece2D != "" && this._ToDDPiece2D != "" && this._RateDDPiece2D != "") {
      var _DDPieceTemp: any = {};
      _DDPieceTemp.FromPiece = this._FromDDPiece2D;
      _DDPieceTemp.ToPiece = this._ToDDPiece2D;
      _DDPieceTemp.Rate = this._RateDDPiece2D;
      this._DDPiece2D.push(_DDPieceTemp);
      this.ClearRowDCRate2D();
    }
  }
  ClearRowDDRate2D() {
    this._FromDDPiece2D = "";
    this._ToDDPiece2D = "";
    this._RateDDPiece2D = "";
  }
  addRowDDRateKG2D() {
    if (this._FromDDKG2D != "" && this._ToDDKG2D != "" && this._RateDDKG2D != "") {
      var _DDPieceGKTemp: any = {};
      _DDPieceGKTemp.FromPiece = this._FromDDKG2D;
      _DDPieceGKTemp.ToPiece = this._ToDDKG2D;
      _DDPieceGKTemp.Rate = this._RateDDKG2D;
      this._DDKG2D.push(_DDPieceGKTemp);
      this.ClearRowDCRateKG2D();
    }
  }
  ClearRowDDRateKG2D() {
    this._FromDDKG2D = "";
    this._ToDDKG2D = "";
    this._RateDDKG2D = "";
  }
  ArticleChargeCode2D(event) {

  }
  showBasicDialogArticleChargeCode2D() {
    this.displayACRateType2D = true;
  }
  onRowSelectPopupArticleChargeCode2D(event: any) {
    var row = event.data;
    this._2DForm.controls['acratetypecode'].setValue(row.charge_Code);
    this._2DForm.controls['acrate'].setValue(row.rate);
    //this._2DForm.controls['acrate'].setValue(row.rate);
    this.displayACRateType2D = false;
  }
  addRow2D() {
    this._2DFormsubmitted = true;
    var _2DListTemp: any = {};
    _2DListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
    _2DListTemp.frombranchcode = this._2DForm.get("frombranchcode").value;
    _2DListTemp.frombranch = (this._BillingBranch || []).filter(f => f.branchcode == _2DListTemp.frombranchcode)[0].branchname;
    _2DListTemp.toKM = this._2DForm.get("toKM").value;
    _2DListTemp.articlecode = this._2DForm.get("articlecode").value;
    _2DListTemp.article = (this._ArticleName || []).filter(f => f.articlecode == _2DListTemp.articlecode)[0].articlename;
    _2DListTemp.ratetypecode = this._2DForm.get("ratetypecode").value;
    _2DListTemp.ratetype = (this._RateType || []).filter(f => f.metasubcode == _2DListTemp.ratetypecode)[0].metasubdescription;
    _2DListTemp.rate = this._2DForm.get("rate").value;
    _2DListTemp.dcratetypecode = this._2DForm.get("dcratetypecode").value;
    _2DListTemp.dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == _2DListTemp.dcratetypecode)[0].metasubdescription;
    _2DListTemp.dcrate = this._2DForm.get("dcrate").value;
    _2DListTemp.ddratetypecode = this._2DForm.get("ddratetypecode").value;
    _2DListTemp.ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == _2DListTemp.ddratetypecode)[0].metasubdescription;
    _2DListTemp.ddrate = this._2DForm.get("ddrate").value;
    _2DListTemp.acratetypecode = this._2DForm.get("acratetypecode").value;
    _2DListTemp.acratetype = this._2DForm.get("acratetypecode").value;
    _2DListTemp.acrate = this._2DForm.get("acrate").value;
    _2DListTemp.inclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
    _2DListTemp.inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == _2DListTemp.inclusiveorexclusivecode)[0].chargeName;
    _2DListTemp.isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;
    /*_2DListTemp._DCKG = this._DCKG2D;
    _2DListTemp._DDKG = this._DDKG2D;
    _2DListTemp._DDPiece = this._DDPiece2D;
    _2DListTemp._DCPiece = this._DCPiece2D;
    _2DListTemp._ACKG = this._ACKG2D;    
    _2DListTemp._ACPiece = this._ACPiece2D;
    _2DListTemp._SlabKG = this._KG2D;    
    _2DListTemp._SlabPiece = this._Piece2D;*/


    var _lstDCDDACSlabsTemp = []
    if (this._DCPiece2D.length > 0) {
      for (var i = 0; i < this._DCPiece2D.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCPiece.Contracttypecode = "MSC00082";
        _tempDCPiece.Chargetypecode = "MSC00107";
        _tempDCPiece.Slabfrom = this._DCPiece2D[i].FromPiece;
        _tempDCPiece.Slabto = this._DCPiece2D[i].ToPiece;
        _tempDCPiece.Slabrate = this._DCPiece2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCPiece);
      }
    }
    if (this._DCKG2D.length > 0) {
      for (var i = 0; i < this._DCKG2D.length; i++) {
        var _tempDCKG: any = {};
        _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDCKG.Contracttypecode = "MSC00082";
        _tempDCKG.Chargetypecode = "MSC00107";
        _tempDCKG.Slabfrom = this._DCKG2D[i].FromPiece;
        _tempDCKG.Slabto = this._DCKG2D[i].ToPiece;
        _tempDCKG.Slabrate = this._DCKG2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDCKG);
      }
    }

    if (this._DDPiece2D.length > 0) {
      for (var i = 0; i < this._DDPiece2D.length; i++) {
        var _tempDDPiece: any = {};
        _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDPiece.Contracttypecode = "MSC00082";
        _tempDDPiece.Chargetypecode = "MSC00108";
        _tempDDPiece.Slabfrom = this._DDPiece2D[i].FromPiece;
        _tempDDPiece.Slabto = this._DDPiece2D[i].ToPiece;
        _tempDDPiece.Slabrate = this._DDPiece2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDPiece);
      }
    }
    if (this._DDKG2D.length > 0) {
      for (var i = 0; i < this._DDKG2D.length; i++) {
        var _tempDDKG: any = {};
        _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempDDKG.Contracttypecode = "MSC00082";
        _tempDDKG.Chargetypecode = "MSC00108";
        _tempDDKG.Slabfrom = this._DDKG2D[i].FromPiece;
        _tempDDKG.Slabto = this._DDKG2D[i].ToPiece;
        _tempDDKG.Slabrate = this._DDKG2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempDDKG);
      }
    }

    if (this._ACPiece2D.length > 0) {
      for (var i = 0; i < this._ACPiece2D.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00082";
        _tempACPiece.Chargetypecode = "MSC00421";
        _tempACPiece.Slabfrom = this._ACPiece2D[i].FromPiece;
        _tempACPiece.Slabto = this._ACPiece2D[i].ToPiece;
        _tempACPiece.Slabrate = this._ACPiece2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._ACKG2D.length > 0) {
      for (var i = 0; i < this._ACKG2D.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00082";
        _tempACKG.Chargetypecode = "MSC00421";
        _tempACKG.Slabfrom = this._ACKG2D[i].FromPiece;
        _tempACKG.Slabto = this._ACKG2D[i].ToPiece;
        _tempACKG.Slabrate = this._ACKG2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }


    if (this._Piece2D.length > 0) {
      for (var i = 0; i < this._Piece2D.length; i++) {
        var _tempACPiece: any = {};
        _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACPiece.Contracttypecode = "MSC00082";
        _tempACPiece.Chargetypecode = "MSC00421";
        _tempACPiece.Slabfrom = this._Piece2D[i].FromPiece;
        _tempACPiece.Slabto = this._Piece2D[i].ToPiece;
        _tempACPiece.Slabrate = this._Piece2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACPiece);
      }
    }
    if (this._KG2D.length > 0) {
      for (var i = 0; i < this._KG2D.length; i++) {
        var _tempACKG: any = {};
        _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
        _tempACKG.Contracttypecode = "MSC00082";
        _tempACKG.Chargetypecode = "MSC00421";
        _tempACKG.Slabfrom = this._KG2D[i].FromPiece;
        _tempACKG.Slabto = this._KG2D[i].ToPiece;
        _tempACKG.Slabrate = this._KG2D[i].Rate;
        _lstDCDDACSlabsTemp.push(_tempACKG);
      }
    }
    _2DListTemp.lstDCDDACSlabs = _lstDCDDACSlabsTemp;

    this._2DList.push(_2DListTemp);
    this.ClearRow2D();
  }
  ClearRow2D() {
    this._2DFormsubmitted = false;
    this._2DForm.reset();
    this._DCKG2D = [];
    this._DDKG2D = [];
    this._DDPiece2D = []
    this._DCPiece2D = [];
    this._ACKG2D = [];
    this._ACPiece2D = [];
    this._KG2D = [];
    this._Piece2D = [];
  }

  onChangeDCRateType2D() {


  }
  onChangeDDRateType2D() {

  }

  Remove_Piece2D(RowIndex) {
    if (this._Piece2D.length > 1) {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1)
    }
    else {
      var index = this._Piece2D.indexOf(RowIndex);
      this._Piece2D.splice(index, 1);
    }
  }

  Remove_KG2D(RowIndex) {
    if (this._KG2D.length > 1) {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1)
    }
    else {
      var index = this._KG2D.indexOf(RowIndex);
      this._KG2D.splice(index, 1);
    }
  }
  Remove_DCPiece2D(RowIndex) {
    if (this._DCPiece2D.length > 1) {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1)
    }
    else {
      var index = this._DCPiece2D.indexOf(RowIndex);
      this._DCPiece2D.splice(index, 1);
    }
  }
  Remove_DCKG2D(RowIndex) {
    if (this._DCKG2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1)
    }
    else {
      var index = this._DCKG2D.indexOf(RowIndex);
      this._DCKG2D.splice(index, 1);
    }
  }
  Remove_DDPiece2D(RowIndex) {
    if (this._DDPiece2D.length > 1) {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1)
    }
    else {
      var index = this._DDPiece2D.indexOf(RowIndex);
      this._DDPiece2D.splice(index, 1);
    }
  }
  Remove_DDKG2D(RowIndex) {
    if (this._DDKG2D.length > 1) {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1)
    }
    else {
      var index = this._DDKG2D.indexOf(RowIndex);
      this._DDKG2D.splice(index, 1);
    }
  }
  Remove_ACPiece2D(RowIndex) {
    if (this._ACPiece2D.length > 1) {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1)
    }
    else {
      var index = this._ACPiece2D.indexOf(RowIndex);
      this._ACPiece2D.splice(index, 1);
    }
  }
  Remove_ACKG2D(RowIndex) {
    if (this._ACKG2D.length > 1) {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1)
    }
    else {
      var index = this._ACKG2D.indexOf(RowIndex);
      this._ACKG2D.splice(index, 1);
    }
  }
  Remove_2DListGrid(RowIndex) {
    if (this._2DList.length > 1) {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1)
    }
    else {
      var index = this._2DList.indexOf(RowIndex);
      this._2DList.splice(index, 1);
    }
  }

  onRowSelect_2DList(row: CustomerSiteContractTwoD, index) {
    debugger;
    console.log(row);
    this._2DIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._2DIndex);
    this._2DForm.controls['frombranchcode'].setValue(row.frombranchcode);
    this._2DForm.controls['toKM'].setValue(row.toKM);
    this._2DForm.controls['articlecode'].setValue(row.articlecode);
    this._2DForm.controls['ratetypecode'].setValue(row.ratetypecode);
    this._2DForm.controls['rate'].setValue(row.rate);
    this._2DForm.controls['dcratetypecode'].setValue(row.dcratetypecode);
    this._2DForm.controls['dcrate'].setValue(row.dcrate);
    this._2DForm.controls['ddratetypecode'].setValue(row.ddratetypecode);
    this._2DForm.controls['ddrate'].setValue(row.ddrate);
    this._2DForm.controls['acratetypecode'].setValue(row.acratetypecode);
    this._2DForm.controls['acrate'].setValue(row.acrate);
    this._2DForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._2DForm.controls['isneedreversebooking'].setValue(row.isneedreversebooking);


    if (row.lstDCDDACSlabs != null) {
      for (var i = 0; i < row.lstDCDDACSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstDCDDACSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstDCDDACSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstDCDDACSlabs[i].slabrate;
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00107") {
          if (row.dcratetypecode == 'MSC00098' || row.dcratetypecode == 'MSC00631') {
            this._DCPiece2D.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00099' || row.dcratetypecode == 'MSC00632') {
            this._DCKG2D.push(_tempDCPiece);
          }
        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00108") {
          if (row.dcratetypecode == 'MSC00095' || row.dcratetypecode == 'MSC00629') {
            this._DDPiece2D.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00096' || row.dcratetypecode == 'MSC00630') {
            this._DDKG2D.push(_tempDCPiece);
          }

        }
        if (row.lstDCDDACSlabs[i].chargetypecode == "MSC00421") {
          if (row.dcratetypecode == 'MSC00635') {
            this._ACPiece2D.push(_tempDCPiece);
          }
          if (row.dcratetypecode == 'MSC00634') {
            this._ACPiece2D.push(_tempDCPiece);
          }

        }
      }
    }

    this._updateRow2D = false;
    this._addRow2D = true;

  }

  updateRow2D() {

    if (this._2DIndex != null) {
      this._2DFormsubmitted = true;
      var ii = this._2DIndex;
      this._2DList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this._2DList[ii].frombranchcode = this._2DForm.get("frombranchcode").value;
      this._2DList[ii].frombranch = (this._BillingBranch || []).filter(f => f.branchcode == this._2DForm.get("frombranchcode").value)[0].branchname;
      this._2DList[ii].toregioncode = this._2DForm.get("toregioncode").value;
      this._2DList[ii].toregion = (this._State || []).filter(f => f.regioncode == this._2DForm.get("toregioncode").value)[0].regionname;
      this._2DList[ii].articlecode = this._2DForm.get("articlecode").value;
      this._2DList[ii].article = (this._ArticleName || []).filter(f => f.articlecode == this._2DForm.get("articlecode").value)[0].articlename;
      this._2DList[ii].ratetypecode = this._2DForm.get("ratetypecode").value;
      this._2DList[ii].ratetype = (this._RateType || []).filter(f => f.metasubcode == this._2DForm.get("ratetypecode").value)[0].metasubdescription;
      this._2DList[ii].rate = this._2DForm.get("rate").value;
      this._2DList[ii].dcratetypecode = this._2DForm.get("dcratetypecode").value;
      this._2DList[ii].dcratetype = (this._DCRateType || []).filter(f => f.metasubcode == this._2DForm.get("dcratetypecode").value)[0].metasubdescription;
      this._2DList[ii].dcrate = this._2DForm.get("dcrate").value;
      this._2DList[ii].ddratetypecode = this._2DForm.get("ddratetypecode").value;
      this._2DList[ii].ddratetype = (this._DDRateType || []).filter(f => f.metasubcode == this._2DForm.get("ddratetypecode").value)[0].metasubdescription;
      this._2DList[ii].ddrate = this._2DForm.get("ddrate").value;
      this._2DList[ii].acratetypecode = this._2DForm.get("acratetypecode").value;
      this._2DList[ii].acratetype = this._2DForm.get("acratetypecode").value;
      this._2DList[ii].acrate = this._2DForm.get("acrate").value;
      this._2DList[ii].inclusiveorexclusivecode = this._2DForm.get("inclusiveorexclusivecode").value;
      this._2DList[ii].inclusiveorexclusive = (this._AddonCharges || []).filter(f => f.chargeCode == this._2DForm.get("inclusiveorexclusivecode").value)[0].chargeName;
      this._2DList[ii].isneedreversebooking = this._2DForm.get("isneedreversebooking").value || false;




      var _lstDCDDACSlabsTemp = []
      if (this._DCPiece2D.length > 0) {
        for (var i = 0; i < this._DCPiece2D.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Contracttypecode = "MSC00082";
          _tempDCPiece.Chargetypecode = "MSC00107";
          _tempDCPiece.Slabfrom = this._DCPiece2D[i].FromPiece;
          _tempDCPiece.Slabto = this._DCPiece2D[i].ToPiece;
          _tempDCPiece.Slabrate = this._DCPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Contracttypecode = "MSC00082";
          _tempDCKG.Chargetypecode = "MSC00107";
          _tempDCKG.Slabfrom = this._DCKG2D[i].FromPiece;
          _tempDCKG.Slabto = this._DCKG2D[i].ToPiece;
          _tempDCKG.Slabrate = this._DCKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDCKG);
        }
      }

      if (this._DDPiece2D.length > 0) {
        for (var i = 0; i < this._DDPiece2D.length; i++) {
          var _tempDDPiece: any = {};
          _tempDDPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDPiece.Contracttypecode = "MSC00082";
          _tempDDPiece.Chargetypecode = "MSC00108";
          _tempDDPiece.Slabfrom = this._DDPiece2D[i].FromPiece;
          _tempDDPiece.Slabto = this._DDPiece2D[i].ToPiece;
          _tempDDPiece.Slabrate = this._DDPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDPiece);
        }
      }
      if (this._DDKG2D.length > 0) {
        for (var i = 0; i < this._DDKG2D.length; i++) {
          var _tempDDKG: any = {};
          _tempDDKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDDKG.Contracttypecode = "MSC00082";
          _tempDDKG.Chargetypecode = "MSC00108";
          _tempDDKG.Slabfrom = this._DDKG2D[i].FromPiece;
          _tempDDKG.Slabto = this._DDKG2D[i].ToPiece;
          _tempDDKG.Slabrate = this._DDKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempDDKG);
        }
      }

      if (this._ACPiece2D.length > 0) {
        for (var i = 0; i < this._ACPiece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00082";
          _tempACPiece.Chargetypecode = "MSC00421";
          _tempACPiece.Slabfrom = this._ACPiece2D[i].FromPiece;
          _tempACPiece.Slabto = this._ACPiece2D[i].ToPiece;
          _tempACPiece.Slabrate = this._ACPiece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._ACKG2D.length > 0) {
        for (var i = 0; i < this._ACKG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00082";
          _tempACKG.Chargetypecode = "MSC00421";
          _tempACKG.Slabfrom = this._ACKG2D[i].FromPiece;
          _tempACKG.Slabto = this._ACKG2D[i].ToPiece;
          _tempACKG.Slabrate = this._ACKG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }


      if (this._Piece2D.length > 0) {
        for (var i = 0; i < this._Piece2D.length; i++) {
          var _tempACPiece: any = {};
          _tempACPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACPiece.Contracttypecode = "MSC00082";
          _tempACPiece.Chargetypecode = "MSC00421";
          _tempACPiece.Slabfrom = this._Piece2D[i].FromPiece;
          _tempACPiece.Slabto = this._Piece2D[i].ToPiece;
          _tempACPiece.Slabrate = this._Piece2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACPiece);
        }
      }
      if (this._KG2D.length > 0) {
        for (var i = 0; i < this._KG2D.length; i++) {
          var _tempACKG: any = {};
          _tempACKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempACKG.Contracttypecode = "MSC00082";
          _tempACKG.Chargetypecode = "MSC00421";
          _tempACKG.Slabfrom = this._KG2D[i].FromPiece;
          _tempACKG.Slabto = this._KG2D[i].ToPiece;
          _tempACKG.Slabrate = this._KG2D[i].Rate;
          _lstDCDDACSlabsTemp.push(_tempACKG);
        }
      }
      this._2DList[ii].lstDCDDACSlabs = _lstDCDDACSlabsTemp;

      this._2DIndex = null;
      this._updateRow2D = true;
      this._addRow2D = false;
      this.ClearRow2D();
    }
  }


  ///////--------------Way Bill-------------//////////////

  showBasicDialogRateTypeWayBill() {
    this.displayRateTypeWayBill = true;
    //debugger;
  }

  showBasicDialogValue() {
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00635') {
      this.displayPieceWayBill = true;
    }
    if (this._WaybillForm.get("chargeratetypecode").value == 'MSC00634') {
      this.displayKGWayBill = true;
    }

    //this.displayKGWayBill = true;
    //this.displayPieceKGWayBill = true;
  }
  onChangechargeratetypecode() {
    this.displayPieceWayBill = true;
    //var this._TempWaybillList;
    debugger;
  }

  onRowSelectPopupArticleChargeCodeWayBill(event: any) {
    debugger;
    this.displayRateTypeWayBill = false;
    var row = event.data;
    this._WaybillForm.controls['chargetypecode'].setValue(row.charge_Code);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.rate_Type);
    this._WaybillForm.controls['adrate'].setValue(row.rate);
    //this.displayACRateType2D = false;
  }

  showBasicDialogRateType() {
    this.displayRateTypeWayBill = true;
  }


  addRowRateWayBill() {
    if (this._FromPieceWayBill != "" && this._ToPieceWayBill != "" && this._RatePieceWayBill != "") {
      var _DCPieceTemp: any = {};
      _DCPieceTemp.FromPiece = this._FromPieceWayBill;
      _DCPieceTemp.ToPiece = this._ToPieceWayBill;
      _DCPieceTemp.Rate = this._RatePieceWayBill;
      this._PieceWayBill.push(_DCPieceTemp);
      this.ClearRowRateWayBill();
    }
  }
  ClearRowRateWayBill() {
    this._FromPieceWayBill = "";
    this._ToPieceWayBill = "";
    this._RatePieceWayBill = "";
  }
  addRowRateKGWayBill() {
    if (this._FromKGWayBill != "" && this._ToKGWayBill != "" && this._RateKGWayBill != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToKGWayBill;
      _DCPieceGKTemp.Rate = this._RateKGWayBill;
      this._KGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRateKGWayBill();
    }
  }
  ClearRowRateKGWayBill() {
    this._FromKGWayBill = "";
    this._ToKGWayBill = "";
    this._RateKGWayBill = "";
  }

  addRowRatePieceKGWayBill() {
    if (this._FromPieceKGWayBill != "" && this._ToPieceKGWayBill != "" && this._RatePieceKGWayBill != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.FromPiece = this._FromPieceKGWayBill;
      _DCPieceGKTemp.ToPiece = this._ToPieceKGWayBill;
      _DCPieceGKTemp.Rate = this._RatePieceKGWayBill;
      this._PieceKGWayBill.push(_DCPieceGKTemp);
      this.ClearRowRatePieceKGWayBill();
    }
  }
  ClearRowRatePieceKGWayBill() {
    this._FromPieceKGWayBill = "";
    this._ToPieceKGWayBill = "";
    this._RatePieceKGWayBill = "";
  }


  addRowWaybill() {
    this._WaybillFormsubmitted = true;
    var error = "";
    for (var i = 0; i < this.WayBillList.length; i++) {
      if (this.WayBillList[i].chargecodeid == this._WaybillForm.get("chargecodeid").value) {
        error = "This charge name already added";
      }
    }

    if (error == "") {
      var _WaybillListTemp: any = {};
      _WaybillListTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _WaybillListTemp.chargetype = this._WaybillForm.get("chargetypecode").value;
      _WaybillListTemp.chargetypecode = this._WaybillForm.get("chargeratetypecode").value;
      _WaybillListTemp.chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
      _WaybillListTemp.chargeratetype = (this._ArticleChargeCode || []).filter(f => f.rate_Type == _WaybillListTemp.chargeratetypecode)[0].charge_Code;
      _WaybillListTemp.chargecodeid = this._WaybillForm.get("chargecodeid").value;
      _WaybillListTemp.chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == _WaybillListTemp.chargecodeid)[0].chargeName;
      _WaybillListTemp.adrate = this._WaybillForm.get("adrate").value;
      _WaybillListTemp.inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
      _WaybillListTemp.inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == _WaybillListTemp.inclusiveorexclusivecode)[0].metasubdescription;
      _WaybillListTemp.printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
      /*_2DListTemp._PieceWayBill = this._PieceWayBill;
      _2DListTemp._KGWayBill = this._KGWayBill;
     */


      var _lstAddOnSlabsTemp = []
      if (this._PieceWayBill.length > 0) {
        for (var i = 0; i < this._PieceWayBill.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Slabfrom = this._PieceWayBill[i].FromPiece;
          _tempDCPiece.Slabto = this._PieceWayBill[i].ToPiece;
          _tempDCPiece.Slabrate = this._PieceWayBill[i].Rate;
          _tempDCPiece.Slabaddrate = _WaybillListTemp.adrate;
          _tempDCPiece.Chargecodeid = _WaybillListTemp.chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Slabfrom = this._KGWayBill[i].FromPiece;
          _tempDCKG.Slabto = this._KGWayBill[i].ToPiece;
          _tempDCKG.Slabrate = this._KGWayBill[i].Rate;
          _tempDCKG.Slabaddrate = _WaybillListTemp.adrate;
          _tempDCKG.Chargecodeid = _WaybillListTemp.chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCKG);
        }
      }


      _WaybillListTemp.lstAddOnSlabs = _lstAddOnSlabsTemp;

      this.WayBillList.push(_WaybillListTemp);
      this.ClearRowWaybill();
    }
    else {
      this._CustomExceptionService.handleError(error)
    }

  }
  ClearRowWaybill() {
    this._WaybillFormsubmitted = false;
    this._WaybillForm.reset();
    this._PieceWayBill = [];
    this._KGWayBill = [];
  }

  RemoveWayBillList(RowIndex) {
    if (this.WayBillList.length > 1) {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1)
    }
    else {
      var index = this.WayBillList.indexOf(RowIndex);
      this.WayBillList.splice(index, 1);
    }
  }
  Remove_PieceWayBill(RowIndex) {
    if (this._PieceWayBill.length > 1) {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceWayBill.indexOf(RowIndex);
      this._PieceWayBill.splice(index, 1);
    }
  }
  Remove_KGWayBill(RowIndex) {
    if (this._KGWayBill.length > 1) {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1)
    }
    else {
      var index = this._KGWayBill.indexOf(RowIndex);
      this._KGWayBill.splice(index, 1);
    }
  }
  Remove_PieceKGWayBill(RowIndex) {
    if (this._PieceKGWayBill.length > 1) {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1)
    }
    else {
      var index = this._PieceKGWayBill.indexOf(RowIndex);
      this._PieceKGWayBill.splice(index, 1);
    }
  }

  onRowSelectWayBill(row: CustomerSiteContractAddOnCharge, index) {
    console.log(row);
    this._WayBillIndex = index;
    //this._RegionLevelForm.setValue(row);
    //var row = event.data;
    console.log(this._WayBillIndex);
    this._WaybillForm.controls['chargecodeid'].setValue(row.chargecodeid);
    this._WaybillForm.controls['chargetypecode'].setValue(row.chargeratetype);
    this._WaybillForm.controls['chargeratetypecode'].setValue(row.chargetypecode);
    this._WaybillForm.controls['adrate'].setValue(row.adrate);
    this._WaybillForm.controls['inclusiveorexclusivecode'].setValue(row.inclusiveorexclusivecode);
    this._WaybillForm.controls['printinothercharge'].setValue(row.printinothercharge);
    /////////this._RegionLevelForm.controls['acrate'].setValue(row.rate);
    if (row.lstAddOnSlabs  != null) {
      for (var i = 0; i < row.lstAddOnSlabs.length; i++) {
        var _tempDCPiece: any = {};
        _tempDCPiece.FromPiece = row.lstAddOnSlabs[i].slabfrom;
        _tempDCPiece.ToPiece = row.lstAddOnSlabs[i].slabto;
        _tempDCPiece.Rate = row.lstAddOnSlabs[i].slabrate;

        if (row.chargeratetypecode == 'MSC00635') {
          this._PieceWayBill.push(_tempDCPiece);
        }
        if (row.chargeratetypecode == 'MSC00634') {
          this._KGWayBill.push(_tempDCPiece);
        }


      }
    }

    this._updateRowWayBill = false;
    this._addRowWayBill = true;
  }

  updateRowWaybill() {
    if (this._WayBillIndex != null) {
      this._WaybillFormsubmitted = true;
      var ii = this._WayBillIndex;
      this.WayBillList[ii].customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      this.WayBillList[ii].chargetype = this._WaybillForm.get("chargetypecode").value;
      this.WayBillList[ii].chargetypecode = this._WaybillForm.get("chargeratetypecode").value;
      this.WayBillList[ii].chargeratetypecode = this._WaybillForm.get("chargeratetypecode").value;
      this.WayBillList[ii].chargeratetype = (this._ArticleChargeCode || []).filter(f => f.rate_Type == this.WayBillList[ii].chargeratetypecode)[0].charge_Code;
      this.WayBillList[ii].chargecodeid = this._WaybillForm.get("chargecodeid").value;
      this.WayBillList[ii].chargecodeName = (this._AddOnChargeType || []).filter(f => f.chargeCode == this.WayBillList[ii].chargecodeid)[0].chargeName;
      this.WayBillList[ii].adrate = this._WaybillForm.get("adrate").value;
      this.WayBillList[ii].inclusiveorexclusivecode = this._WaybillForm.get("inclusiveorexclusivecode").value;
      //this.WayBillList[ii].inclusiveorexclusive = (this._InclusiveExclusive || []).filter(f => f.metasubcode == this.WayBillList[ii].inclusiveorexclusivecode)[0].metasubdescription;
      this.WayBillList[ii].printinothercharge = this._WaybillForm.get("printinothercharge").value || false;
      /*_2DListTemp._PieceWayBill = this._PieceWayBill;
      _2DListTemp._KGWayBill = this._KGWayBill;
     */


      var _lstAddOnSlabsTemp = []
      if (this._PieceWayBill.length > 0) {
        for (var i = 0; i < this._PieceWayBill.length; i++) {
          var _tempDCPiece: any = {};
          _tempDCPiece.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCPiece.Slabfrom = this._PieceWayBill[i].FromPiece;
          _tempDCPiece.Slabto = this._PieceWayBill[i].ToPiece;
          _tempDCPiece.Slabrate = this._PieceWayBill[i].Rate;
          _tempDCPiece.Slabaddrate = this.WayBillList[ii].adrate;
          _tempDCPiece.Chargecodeid = this.WayBillList[ii].chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCPiece);
        }
      }
      if (this._DCKG2D.length > 0) {
        for (var i = 0; i < this._DCKG2D.length; i++) {
          var _tempDCKG: any = {};
          _tempDCKG.Customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
          _tempDCKG.Slabfrom = this._KGWayBill[i].FromPiece;
          _tempDCKG.Slabto = this._KGWayBill[i].ToPiece;
          _tempDCKG.Slabrate = this._KGWayBill[i].Rate;
          _tempDCKG.Slabaddrate = this.WayBillList[ii].adrate;
          _tempDCKG.Chargecodeid = this.WayBillList[ii].chargecodeid;
          _lstAddOnSlabsTemp.push(_tempDCKG);
        }
      }


      this.WayBillList[ii].lstAddOnSlabs = _lstAddOnSlabsTemp;
      this._WayBillIndex = null;
      this._updateRowWayBill = true;
      this._addRowWayBill = false;

      this.ClearRowWaybill();
    }

  }




  addRowArticle() {
    if (this._ArticleFrom != "" && this._ArticleTo != "" && this._ArticleCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._ArticleFrom;
      _DCPieceGKTemp.flatodachargeto = this._ArticleTo;
      _DCPieceGKTemp.flatodacharges = this._ArticleCharges;
      this._ArticleList.push(_DCPieceGKTemp);
      this.clearRowArticle();
    }
  }
  clearRowArticle() {
    this._ArticleFrom = "";
    this._ArticleTo = "";
    this._ArticleCharges = "";
  }

  addRowKG() {
    if (this._KGFrom != "" && this._KGTo != "" && this._KGCharges != "") {
      var _DCPieceGKTemp: any = {};
      _DCPieceGKTemp.customersitecode = this._CustomerSiteCode || this.CustomersiteCode;
      _DCPieceGKTemp.flatodachargefrom = this._KGFrom;
      _DCPieceGKTemp.flatodachargeto = this._KGTo;
      _DCPieceGKTemp.flatodacharges = this._KGCharges;
      this._KGList.push(_DCPieceGKTemp);
      this.clearRowKG();
    }
  }
  clearRowKG() {
    this._KGFrom = "";
    this._KGTo = "";
    this._KGCharges = "";
  }



}
